/* ============================================================
   PRICING — Cake Pricing Calculator (FREE bundle)
   LAYER'D Cakes · Access Gating retrofit

   The free tier: servings (typed or built from tiers on the
   public Wilton chart) + a design-complexity choice produce a
   STARTING RANGE — two precomputed per-serving endpoints from
   the #ldp-config island. No base rates, no multipliers, no
   location table, no formulas ship in this file or its island;
   the endpoints are rounded numbers computed at build time.

   The full framework (exact rates, market multipliers, add-ons,
   itemized breakdown, margin cross-check) lives in the premium
   bundle + #ldp-premium island, rendered ONLY for
   premium customers (learn-hub-pro OR academy-member tag), server-side. When that bundle is
   present it registers window.LAYERD.premium.pricing and this
   file hands the Calculate click over to it.

   MARIYA: numbers live in pricing/pricing-master.json — edit
   there, run generate.bat, re-paste the dist template.
   ============================================================ */

(function () {
"use strict";
  /* Landing handoff (2026-07-21): once a price is on screen, committing
     any input change recomputes it — same engine, same Calculate handler,
     no second press. The FIRST calculate stays an explicit click. */
  (function initLive() {
    function wire() {
      var rootEl = document.getElementById('ldpPriceCalc');
      var btn = document.getElementById('ldpCalcBtn');
      if (!rootEl || !btn) return;
      var t = null;
      rootEl.addEventListener('change', function () {
        if (!document.querySelector('.ldp-result-total')) return;
        clearTimeout(t);
        t = setTimeout(function () { btn.click(); }, 300);
      }, true);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
    else wire();
  })();

  /* every viewport move routes through the ONE shared utility
     (nav rule 2026-07-20); absent = no scroll, never a local fallback */
  function ldNav(target, opts) {
    var C2 = window.LAYERD && window.LAYERD.components;
    return !!(C2 && C2.navigateToSection && C2.navigateToSection(target, opts));
  }


var root = document.getElementById('ldpPriceCalc');
if (!root) return;

/* SPINE r233: EMBED MODE. When the Pricing tool runs inside the workspace
   (studio spine) — either as an iframe (self !== top) or via ?embed=1 — it
   hides its own page chrome (subnav, header, client bar) via html.ld-embed
   (CSS in learn-pricing.css) so only the quote tool shows, and reports its
   content height to the parent so the frame can size to it. The engine and
   every number are untouched; this is presentation + a height ping only. */
var LDP_EMBED = /[?&]embed=1/.test(location.search) || (window.self !== window.top);
if (LDP_EMBED) {
  try { document.documentElement.classList.add('ld-embed'); } catch (eEm) { }
  var ldpPostHeight = function () {
    try {
      var h = Math.max(document.body ? document.body.scrollHeight : 0, document.documentElement.scrollHeight);
      parent.postMessage({ ldEmbed: 'pricing', height: h }, '*');
    } catch (e) { }
  };
  window.addEventListener('load', ldpPostHeight);
  window.addEventListener('resize', ldpPostHeight);
  window.addEventListener('layerd:pricing-changed', function () { setTimeout(ldpPostHeight, 80); });
  window.addEventListener('layerd:cakefile', function () { setTimeout(ldpPostHeight, 80); });
  [300, 900, 1800].forEach(function (t) { setTimeout(ldpPostHeight, t); });
}

var CFG = null;
try {
  var cfgEl = document.getElementById('ldp-config');
  CFG = cfgEl ? JSON.parse(cfgEl.textContent) : null;
} catch (e) { CFG = null; }

/* ---------- SPINE r229: one servings owner ----------
   cakeCore (learn-cake-core.js, loaded before this file since r110) is the
   single source of the Wilton chart AND the height-scaling rule for the
   whole suite. Pricing used to keep a private copy of both, embedded here as
   CFG.servings, which is the drift that let the same cake read a different
   count than Serving/Structure/Batch. Point the chart at cakeCore so the size
   list and every count read ONE table, and route counting through
   CORE.servingsFor so the *h/4 rule lives in ONE place. The embedded JSON
   copy stays only as a fallback if cakeCore is absent (e.g. a stripped
   preview). The two charts were identical at cutover, so this moves no number
   today; it removes the ability to drift. Every servings count in this file
   goes through ldpServingsFor - never a second formula. */
var LDP_CORE = window.LAYERD && window.LAYERD.cakeCore;
if (LDP_CORE && LDP_CORE.SERVINGS && CFG) CFG.servings = LDP_CORE.SERVINGS;
function ldpServingsFor(shape, size, occasion, height) {
  if (LDP_CORE && LDP_CORE.servingsFor) return LDP_CORE.servingsFor(shape, size, occasion, height);
  var entry = CFG && CFG.servings && CFG.servings[shape] && CFG.servings[shape][size];
  if (!entry || entry[occasion] == null) return 0;
  return Math.round(entry[occasion] * (height || 4) / 4);
}

/* ---------- SPINE r230: publish the four numbers to the shared store ----------
   cost/sv, charge/sv and the quote are computed only here, but the spine's
   summary bar needs them on every step and on pages the Pricing script never
   loads. Both tiers converge on the Calculate handler's finalize points, where
   the numbers are already in scope; from there we snapshot them onto the scoped
   booking via LdCakeFile.writeMoney. Only when a booking is scoped - quick
   tools saves nothing. Signature-guarded so an unchanged recompute (or the
   cakefile event our own write fires) never re-writes or loops. */
var _ldpMoneySig = '';
function ldpPersistMoney(m) {
  var F = window.LdCakeFile;
  if (!F || !F.writeMoney || !F.getActiveBooking || !F.getActiveBooking()) return;
  var sig = [m.servings, m.costSv, m.chargeSv, m.quote, m.occasion].join('|');
  if (sig === _ldpMoneySig) return;
  _ldpMoneySig = sig;
  F.writeMoney('pricing', m);
}
function ldpCakeFloor(bandKey) {
  try { return (window.LDP_COSTFIRST && window.LDP_COSTFIRST.cakeFloorFor) ? window.LDP_COSTFIRST.cakeFloorFor(bandKey) : null; } catch (e) { return null; }
}

function premium() {
  return (window.LAYERD && window.LAYERD.premium && window.LAYERD.premium.pricing) || null;
}

var TIMES_SIGN = String.fromCharCode(215);
var SHAPE_LABEL = { round: 'Round', square: 'Square', heart: 'Heart' };

/* ---------- units: inches <-> cm, shared suite-wide ----------
   Same contract as Batch Math and Structure: ONE preference for the
   whole Learn suite (same localStorage key). Values stay inches
   everywhere - the Wilton servings chart is keyed in inches and the
   shared cake (layerd-learn-tiers) always stores inches; cm is a
   LABEL, mapped to the standard retail metric pan sizes (6" = 15 cm,
   8" = 20 cm...), so the servings math never moves. */
var UNITS_KEY = 'layerd-learn-units';
var IN2CM = { 4: 10, 5: 13, 6: 15, 7: 18, 8: 20, 9: 23, 10: 25, 11: 28, 12: 30, 13: 33, 14: 35, 15: 38, 16: 40 };
function unitPref() {
  try { return localStorage.getItem(UNITS_KEY) === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; }
}
function sizeLabel(n) {
  return unitPref() === 'cm' ? (IN2CM[n] || Math.round(n * 2.54)) + ' cm' : n + '"';
}
var unitListeners = [];   // rebuilds registered below, fired on toggle

var state = {
  servingsMode: 'tiers',   /* tiers first + default (Mariya, 2026-07-09) */
  occasion: 'wedding',
  complexity: 'simple'
};

// Currency symbol follows the country selector, which is a premium-tier
// control (step 03) that writes data-currency on the root. The free tier has
// no country selector, so it defaults to a plain "$" — its starting range is a
// currency-neutral convention number that reads the same in USD or CAD.
/* Consolidated brief E-4 (2026-08-02): the free tier has no country control,
   so it used to render a bare "$" on a CAD store — a Canadian visitor read
   the starting range as US dollars. The STORE's own currency is the default
   now (stamped on .ldpc by the template), with her saved Toolkit Currency
   preference outranking it. Premium overwrites data-currency the moment its
   country segment initialises, so the two can't disagree. */
/* r197 (Mariya, 2026-08-31): "we need to develop the option to use any
   currency worldwide to populate the pricing and invoice."

   ANY ISO CURRENCY, AND NOTHING IS EVER CONVERTED. Her call, and the right
   one: every amount on this page is either one SHE typed or a studio
   default she overwrites, so converting at a spot rate would silently
   restate prices she set. FX is also the wrong model for pricing - a cake
   in Lisbon is not a US cake at today's rate, which is exactly what the
   market multiplier is for.

   `layerd-learn-currency` used to hold 'US'/'CA' (it was the COUNTRY
   selector, doing double duty). It holds an ISO code now; the two old
   values are migrated on read so nobody's saved preference is lost. */
var LDP_CUR_KEY = 'layerd-learn-currency';
function ldpSavedCurrency() {
  var v = '';
  try { v = (localStorage.getItem(LDP_CUR_KEY) || '').toUpperCase(); } catch (e) { }
  if (v === 'US') return 'USD';       /* pre-r197 country values */
  if (v === 'CA') return 'CAD';
  return /^[A-Z]{3}$/.test(v) ? v : '';
}
(function ldpSeedCurrency() {
  if (!root || root.getAttribute('data-currency')) return;
  var saved = ldpSavedCurrency();
  if (saved) { root.setAttribute('data-currency', saved); return; }
  /* Consolidated brief E-4 (2026-08-02): with no saved preference the
     STORE's own currency wins - a Canadian visitor must not read the
     starting range as US dollars. */
  var cur = (root.getAttribute('data-shop-currency') || '').toUpperCase();
  if (/^[A-Z]{3}$/.test(cur)) { root.setAttribute('data-currency', cur); return; }
  var country = (root.getAttribute('data-shop-country') || '').toUpperCase();
  root.setAttribute('data-currency', country === 'CA' ? 'CAD' : 'USD');
})();
function currencyCode() {
  var c = (root && root.getAttribute('data-currency') || '').toUpperCase();
  return /^[A-Z]{3}$/.test(c) ? c : 'USD';
}
/* Intl gives the symbol AND the currency's own decimal convention (JPY has
   none, KWD has three) - which is why no symbol is stored in the master.
   Formatters are cached: building one per amount is measurably slow, and
   this page reformats every number on every keystroke. */
var _ldpFmt = {};
function ldpFormatter(whole) {
  var key = currencyCode() + (whole ? ':0' : ':d');
  if (_ldpFmt[key]) return _ldpFmt[key];
  var opts = { style: 'currency', currency: currencyCode() };
  if (whole) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
  var f;
  try { f = new Intl.NumberFormat('en-US', opts); }
  catch (e) {
    /* an unknown code, or an engine without Intl currency data: never throw
       in the middle of a quote - fall back to the code and the number */
    f = { format: function (n) {
      return currencyCode() + ' ' + n.toLocaleString('en-US',
        whole ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } };
  }
  _ldpFmt[key] = f;
  return f;
}
function currencySymbol() {
  /* the symbol alone, for the few places that concatenate it themselves */
  try {
    return ldpFormatter(true).formatToParts(0)
      .filter(function (p) { return p.type === 'currency'; })
      .map(function (p) { return p.value; }).join('') || currencyCode();
  } catch (e) { return currencyCode(); }
}
function formatMoney(amount) { return ldpFormatter(false).format(amount); }
function formatMoneyWhole(amount) { return ldpFormatter(true).format(amount); }
window.LAYERD = window.LAYERD || {};
window.LAYERD.pricingCurrency = {
  code: currencyCode, symbol: currencySymbol,
  money: formatMoney, whole: formatMoneyWhole
};

var resultsEl = document.getElementById('ldpResults');
var leadCard = document.getElementById('ldpLeadCard');

/* Graceful degradation: a missing/malformed config island means no
   silent half-working tool — say so and stop cleanly. */
if (!CFG || !CFG.servings || !CFG.bands) {
  var calcBtnBroken = document.getElementById('ldpCalcBtn');
  if (calcBtnBroken) {
    calcBtnBroken.addEventListener('click', function () {
      resultsEl.innerHTML = '<p class="ldp-sub">The calculator couldn’t load its settings just now. Please refresh the page and try again.</p>';
      resultsEl.hidden = false;
    });
  }
  return;
}

/* ---------- client-file quote handoff (Client File & Quote Engine §2.5) ----------
   The Planner's "Quote in Pricing" opens this page as /pages/pricing?booking=<id>
   AND pre-seeds the shared cake. We read the file (the baker's OWN localStorage —
   bookings are free-tier, no gating), show whose cake we're quoting, fill the
   tiers, and after the price computes offer to save it straight back onto the
   file (moving Inquiry -> Quoted). Works the same for the free ballpark and the
   full framework — a saved quote is a saved quote. */
var BOOKINGS_KEY = 'layerd-academy-bookings';
var CAKE_HEX = ['#4C3A50', '#6F7D62', '#BCA069', '#7A4A55'];   /* suite cake palette — slot 0 stays aubergine, not the brand ink (see learn-tokens --cake-1) */
var quoteBooking = (function readQuoteBooking() {
  /* Toolkit Fix 01: scope resolves through the shared cake-file layer */
  if (window.LdCakeFile) return window.LdCakeFile.resolveScope();
  var m = location.search.match(/[?&]booking=([^&]+)/);
  if (!m) return null;
  var id;
  try { id = decodeURIComponent(m[1]); } catch (e) { id = m[1]; }
  try {
    var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
    if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
    for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === id) return v.bookings[i];
  } catch (e) { /* private mode / corrupt */ }
  return null;
})();
function plannerUrl() {
  var a = document.querySelector('.learn-subnav__tab--flagship');
  return (a && a.getAttribute('href')) || '/pages/planner';
}
/* round six: the saved-quote confirmation points at the pipeline's next
   step too — Structure's URL discovered from the subnav like the rest */
/* CO#1 C1: the serving page discovered from the subnav, scoped when a file is */
function servingHandoffUrl() {
  var tabs = document.querySelectorAll('.learn-subnav__tab');
  var href = '/pages/serving-size-calculator';
  for (var i = 0; i < tabs.length; i++) {
    var h = tabs[i].getAttribute('href') || '';
    if (/serving/i.test(h)) { href = h; break; }
  }
  return quoteBooking ? href + '?booking=' + encodeURIComponent(quoteBooking.id) : href;
}
window.LAYERD = window.LAYERD || {};
window.LAYERD.pricingServingUrl = servingHandoffUrl;

/* ============ CO#1 D1/D2 (round 39): ELEMENTS, priced never re-entered =====
   Scoped: the client file's element flags render as read-only priced lines;
   editing goes THROUGH the file. Unscoped: session-only local chips.
   Exposed as window.LAYERD.pricingElements for the premium bundle. */
var EL_STUDIO_RULES = (CFG && CFG.elements) || [];
var EL_SCALE_LABEL = { few: 'a few statement blooms', bouquet: 'a bouquet', cascade: 'a full cascade' };
var localElements = {};            /* unscoped session-only picks */
var localFlowerScale = 'bouquet';

/* ---- r38 (Mariya, 2026-08-02): "maybe we even have an 'add your own
   element' feature for unique designs". Her rows join the studio list at
   READ time, so every consumer below — selectedElements, elementsTotal,
   the chips, the quote lines, the r18 rate editor — picks them up with no
   new code path. Stored on the client file when one is open (they belong
   to that cake); session-only otherwise, like the unscoped picks above. */
var EL_CUSTOM_KEY = 'ldpCustomElements';
var localCustomEls = [];
function readCustomEls() {
  if (quoteBooking) {
    var v = quoteBooking[EL_CUSTOM_KEY];
    return (Object.prototype.toString.call(v) === '[object Array]') ? v : [];
  }
  return localCustomEls;
}
function writeCustomEls(list) {
  if (!quoteBooking) { localCustomEls = list; return true; }
  try {
    var raw = localStorage.getItem(BOOKINGS_KEY);
    var store = raw ? JSON.parse(raw) : null;
    if (!store || !store.bookings) return false;
    for (var i = 0; i < store.bookings.length; i++) {
      if (store.bookings[i].id !== quoteBooking.id) continue;
      store.bookings[i][EL_CUSTOM_KEY] = list;
      localStorage.setItem(BOOKINGS_KEY, JSON.stringify(store));
      quoteBooking[EL_CUSTOM_KEY] = list;
      try { window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'pricing' } })); } catch (e2) { }
      return true;
    }
  } catch (e) { /* private mode - the row still prices this session */ }
  return false;
}
/* the studio list + hers, in one array — the ONLY definition of EL_RULES */
function elRules() {
  return EL_STUDIO_RULES.concat(readCustomEls());
}
Object.defineProperty(window, 'ldpElRules', { get: elRules });
var EL_RULES = EL_STUDIO_RULES;   /* legacy alias; readers use elRules() */
function elementRule(id) {
  var all = elRules();
  for (var i = 0; i < all.length; i++) if (all[i].id === id) return all[i];
  return null;
}
function elementOn(id) {
  /* r42: the faux element is DERIVED, never ticked. She marks a tier faux
     in Recipes; the price follows. A tickable chip here would let the
     quote disagree with the cake file — the exact silent gap that had
     Batch Math shopping for a dummy's batter. The picker hides the chip
     when the count is zero, so there is no dead control either. */
  if (id === 'faux') return ldpFauxCount() > 0;
  if (quoteBooking) return !!quoteBooking[id];
  return !!localElements[id];
}
function flowerScale() {
  if (quoteBooking) return quoteBooking.band || 'bouquet';
  return localFlowerScale;
}
/* ---- r18 (Mariya, 2026-07-31): "every single element should be editable
   to be customized based on the users preferences ... can we put it under
   the pro plan only?" Her rate wins over the studio default, per element,
   saved on this device. Flowers are stored per band, because "a few
   blooms" and "a full cascade" are different prices. PRO ONLY: the free
   tier reads the studio defaults and sees the panel locked. ---- */
var EL_RATES_KEY = 'layerd-pricing-element-rates';
function readElRates() {
  try {
    var v = JSON.parse(localStorage.getItem(EL_RATES_KEY));
    if (v && v.v === 1 && v.rates && typeof v.rates === 'object') return v.rates;
  } catch (e) { /* private mode / corrupt - fall back to the defaults */ }
  return {};
}
function writeElRates(rates) {
  try { localStorage.setItem(EL_RATES_KEY, JSON.stringify({ v: 1, rates: rates })); return true; }
  catch (e) { return false; }
}
function elRateKey(rule) { return rule.scale ? rule.id + ':' + flowerScale() : rule.id; }
/* r60 (Mariya): "toggle between per-serving or flat rate" — a Pro member's
   UNIT override per element, stored beside the rate overrides. Only two
   kinds are togglable: banded elements (flowers) and the derived faux tier
   keep the unit their maths requires. Free reads the studio kinds. */
var EL_UNITS_KEY = 'layerd-pricing-element-units';
function readElUnits() {
  try {
    var v = JSON.parse(localStorage.getItem(EL_UNITS_KEY));
    if (v && v.v === 1 && v.units && typeof v.units === 'object') return v.units;
  } catch (e) { }
  return {};
}
function writeElUnits(units) {
  try { localStorage.setItem(EL_UNITS_KEY, JSON.stringify({ v: 1, units: units })); return true; }
  catch (e) { return false; }
}
function elUnitTogglable(rule) { return !!rule && !rule.scale && rule.kind !== 'perFauxTier'; }
function elKind(rule) {
  if (!rule) return 'flat';
  if (!elUnitTogglable(rule) || !ldpIsPro()) return rule.kind;
  var u = readElUnits()[rule.id];
  return (u === 'flat' || u === 'perServing') ? u : rule.kind;
}
/* r124: an element deliberately not priced (its cost lives in the
   ingredient calculation). Module scope - both the rates editor out here
   and the chip renderer inside the page IIFE read it. */
function elIsPriced(r) { return !(r && r.unpriced); }
function elDefaultRate(rule) {
  if (!rule) return 0;
  if (rule.scale) return +rule.scale[flowerScale()] || 0;
  return +rule.amount || 0;
}
function elIsCustom(rule) {
  var r = readElRates()[elRateKey(rule)];
  return r != null && !isNaN(+r) && +r !== elDefaultRate(rule);
}
/* r60: is the UNIT overridden away from the studio kind? */
function elUnitCustom(rule) {
  if (!elUnitTogglable(rule)) return false;
  var u = readElUnits()[rule.id];
  return (u === 'flat' || u === 'perServing') && u !== rule.kind;
}
/* Pro = the member framework is actually on this page. `data-lh-tier` is
   the theme's signal but it is absent from the local previews, so the
   premium bundle's own presence is the honest second test - it is only
   ever served to members, and the leak check enforces that. */
/* S-4 (2026-08-03): "a member who just saved an $825 quote is offered 'Want
   this pricing breakdown emailed to you?'" — suppressed for members, kept
   for free and logged-out visitors where it does real work. */
function ldpHideLead() {
  try {
    var C = window.LAYERD && window.LAYERD.components;
    if (C && C.isMember && C.isMember()) return true;
  } catch (e) { }
  return ldpIsPro();
}
function ldpIsPro() {
  if (gaTier() === 'premium') return true;
  return !!(window.LAYERD && window.LAYERD.premium && window.LAYERD.premium.pricing);
}
function elRate(rule) {
  if (!ldpIsPro()) return elDefaultRate(rule);   /* Pro only */
  var r = readElRates()[elRateKey(rule)];
  return (r == null || isNaN(+r)) ? elDefaultRate(rule) : +r;
}
/* r42: how many tiers on the open client file are dummies. Read fresh each
   time rather than cached — she marks a tier faux over in Recipes, and the
   quote has to be right the next time it recomputes, not after a reload.
   No open file means no faux tiers, which is also the honest answer for a
   logged-out visitor playing with a ballpark. */
function ldpFauxCount() {
  try {
    var b = window.LdCakeFile && window.LdCakeFile.getActiveBooking
      ? window.LdCakeFile.getActiveBooking() : null;
    if (!b || !Array.isArray(b.tierSpec)) return 0;
    var n = Math.max(1, +b.tiers || b.tierSpec.length);
    return b.tierSpec.slice(0, n).filter(function (s) { return s && s.faux; }).length;
  } catch (e) { return 0; }
}
function elementAmount(rule, servings) {
  if (!rule) return 0;
  var base = elRate(rule);
  /* a dummy is priced per tier, not per serving — it has no servings at
     all, and two dummies are two afternoons of sanding and covering. */
  if (rule.kind === 'perFauxTier') return base * ldpFauxCount();
  /* r60: the member's unit override wins over the studio kind */
  if (elKind(rule) === 'perServing') return base * (servings || 0);
  return base;
}
function selectedElements(servings) {
  var out = [];
  elRules().forEach(function (r) {
    if (!elementOn(r.id)) return;
    /* r124: an unpriced element is a fact about the cake, not a charge -
       it belongs on the chip and in the file, never as a $0.00 line in an
       itemised quote a client reads. */
    if (r.unpriced) return;
    var label = r.label + (r.scale ? ' · ' + (EL_SCALE_LABEL[flowerScale()] || flowerScale()) : '');
    out.push({ id: r.id, label: label, amount: elementAmount(r, servings),
               /* r18: a rate SHE set is a rule - only a genuine zero is not */
               noRule: !(elRate(r) > 0) });
  });
  return out;
}
function elementsTotal(servings) {
  return selectedElements(servings).reduce(function (a, l) { return a + l.amount; }, 0);
}
/* ============ r206: an element's TIME (Mariya, 2026-09-03) ============
   "the elements need to be somehow considered as part of the break even
   calculation" - but without asking anyone to cost a sugar flower. The
   studio ships a TYPICAL hours figure per element (master `time`,
   placeholders she verifies); the only conversion needed is the hourly
   rate the break-even step already holds. Her design rule, hers exactly:
   the hourly rate is a FLOOR, never a target - a $300 flower set that
   takes 2 hours reads "pays ~$147/hr", a fact, never a warning; only an
   element paying UNDER her own rate is flagged. Pro can adjust the hours
   to their own speed; the rate stays whatever they chose to charge. */
var EL_HOURS_KEY = 'layerd-pricing-element-hours';
function readElHours() {
  try {
    var v = JSON.parse(localStorage.getItem(EL_HOURS_KEY));
    if (v && v.v === 1 && v.hours && typeof v.hours === 'object') return v.hours;
  } catch (e) { }
  return {};
}
function writeElHours(hours) {
  try { localStorage.setItem(EL_HOURS_KEY, JSON.stringify({ v: 1, hours: hours })); return true; }
  catch (e) { return false; }
}
function elTypicalHours(rule) {
  var t = rule && rule.time;
  if (!t) return 0;
  if (rule.scale) return +((t.hours || {})[flowerScale()]) || 0;
  return +t.hours || 0;
}
/* r207 (Mariya, 2026-09-03): "every rate under element to be based on
   hourly instead of by serving - it needs to all be consistent."

   ONE unit for the question, ONE unit for the answer. Every element is
   asked for HOURS and reports $/hr. What differs is only what a UNIT of
   the element is: a per-serving element's unit is the cake (its hours
   scale with the serving count), a flat element's unit is itself, a faux
   tier's unit is one dummy.

   Per-serving time is stored as MINUTES PER SERVING even though it is
   asked in hours, because that is the intensive property: type 1.3 hrs on
   a 26-serving cake and the same element correctly asks 5 hrs of a
   100-serving one, and the $/hr readout holds steady instead of
   exploding. Flat and per-tier store hours directly - the basis they
   already had, and the one that already worked. */
function elBaseHours(rule) {
  if (ldpIsPro()) {
    var h = readElHours()[elRateKey(rule)];
    if (h != null && +h > 0) return +h;
  }
  return elTypicalHours(rule);
}
function elHoursOf(rule) { return elBaseHours(rule); }   /* legacy alias */
/* how many UNITS of this element the cake carries */
function elUnitsOn(rule, servings) {
  if (!rule) return 0;
  if (rule.kind === 'perFauxTier') return ldpFauxCount();
  if (elKind(rule) === 'perServing') return servings || 0;
  return 1;
}
/* minutes per serving, stored or studio, for a per-serving element */
function elMinsPerServing(rule) {
  if (ldpIsPro()) {
    var m = readElHours()[elRateKey(rule) + ':mps'];
    if (m != null && +m > 0) return +m;
  }
  var t = rule && rule.time;
  return t && +t.minsPerServing > 0 ? +t.minsPerServing : 0;
}
/* THE hours question, always: how long this element takes on THIS cake
   (per dummy tier for a faux tier - its charge is per tier too) */
function elHoursForCake(rule, servings) {
  if (!rule || !rule.time) return 0;
  if (elKind(rule) === 'perServing') {
    return elMinsPerServing(rule) * (servings || 0) / 60;
  }
  return elBaseHours(rule) * (rule.kind === 'perFauxTier' ? 1 : 1);
}
/* what she is paid for this element on this cake, and what it costs her
   in materials - both across every unit the cake carries */
function elChargeForCake(rule, servings) { return elementAmount(rule, servings); }
function elMaterialsForCake(rule, servings) {
  return elMaterialsOf(rule) * (rule.kind === 'perFauxTier' ? elUnitsOn(rule, servings) : 1);
}
function elTotalHoursForCake(rule, servings) {
  var h = elHoursForCake(rule, servings);
  return rule.kind === 'perFauxTier' ? h * elUnitsOn(rule, servings) : h;
}
/* the LEDGER's units: a faux tier's row states what ONE dummy pays, so
   the rate reads on a cake that has none yet - the cost side still uses
   the real count (elTotalHoursForCake / selectedElementsCost). */
function elLedgerUnits(rule, servings) {
  if (rule.kind === 'perFauxTier') return 1;
  return elUnitsOn(rule, servings);
}
/* writing the answer back in the unit the model wants */
function elSetHoursForCake(rule, hours, servings) {
  var next = readElHours();
  var key = elRateKey(rule);
  if (elKind(rule) === 'perServing') {
    var sv = servings || 0;
    if (!(hours > 0) || !(sv > 0)) delete next[key + ':mps'];
    else next[key + ':mps'] = Math.round((hours * 60 / sv) * 1000) / 1000;
  } else {
    if (!(hours > 0) || hours === elTypicalHours(rule)) delete next[key];
    else next[key] = Math.round(hours * 100) / 100;
  }
  writeElHours(next);
}
function elHoursCustom(rule) {
  var r = readElHours();
  var k = elRateKey(rule);
  if (elKind(rule) === 'perServing') return r[k + ':mps'] != null;
  return r[k] != null && +r[k] > 0 && +r[k] !== elTypicalHours(rule);
}
function elMaterialsOf(rule) {
  var t = rule && rule.time;
  if (!t) return 0;
  if (rule.scale) return +((t.materials || {})[flowerScale()]) || 0;
  return +t.materials || 0;
}
/* the baker's own hourly rate - the premium break-even step's, when it is
   on the page; 28 is the studio default the master derives from */
function ldpHourlyRate() {
  try {
    var B = window.LAYERD && window.LAYERD.pricingBreakeven;
    if (B && B.rate) { var r = +B.rate(); if (r > 0) return r; }
  } catch (e) { }
  return 28;
}
/* what one unit of this element pays per hour of HER time, at her rate:
   perServing lines are servings-independent (price and minutes are both
   per serving); flat and banded subtract the modest materials first */
/* r207: ONE formula for every element - what the charge pays per hour of
   her time, after the element's own materials. Derived from the STORED
   value, never a display string (0.87 shown from 0.8667 must still divide
   to the rate beside it). */
function elPaysPerHour(rule, servings) {
  var sv = servings != null ? servings : ldpServingsNow();
  var hrs = elHoursForCake(rule, sv) * (rule.kind === 'perFauxTier' ? 1 : 1);
  if (!(hrs > 0)) return 0;
  /* per ONE unit on both sides, so the ratio is the same either way */
  var units = elLedgerUnits(rule, sv);
  var pay = (elKind(rule) === 'perServing')
    ? elRate(rule) * sv - elMaterialsOf(rule)
    : elRate(rule) - elMaterialsOf(rule);
  if (elKind(rule) === 'perServing') hrs = elHoursForCake(rule, sv);
  return hrs > 0 ? Math.max(0, pay) / hrs : 0;
}
/* the serving count this page is pricing, wherever the caller sits */
function ldpServingsNow() {
  /* SPINE: the count the live quote is being computed with wins - it is the
     freshest source and it exists on the very first press, unlike the box
     (empty in tiers mode), the finished quote and the results panel below. */
  try {
    var lv = parseInt(window.__ldpLiveServings, 10);
    if (lv > 0) return lv;
  } catch (e0) { }
  /* r210: in TIERS mode the servings box is empty - the count is derived
     from the stack - so reading only the input left every per-serving
     element with "size the cake for the hours" on a page that plainly
     said 24 servings. Ask the three sources in the order they become
     true: the typed box, the finished quote, then the results panel's
     own printed count (the same figure the servings block reads). */
  try {
    var n = parseInt((document.getElementById('ldpServingsCount') || {}).value, 10);
    if (n > 0) return n;
  } catch (e) { }
  try {
    var q = window.__ldpFreeQuote;
    var qn = q ? parseInt(q.servings, 10) : 0;
    if (qn > 0) return qn;
  } catch (e2) { }
  try {
    var from = document.querySelector('#ldpResults .ldp-fromserving--inline');
    var m = from && /(\d[\d,]*)\s+servings/.exec(from.textContent || '');
    if (m) { var rn = parseInt(m[1].replace(/,/g, ''), 10); if (rn > 0) return rn; }
  } catch (e3) { }
  return 0;
}
/* the cost side for the Margin Check: every selected, priced element at
   `rate` per hour plus materials - the same one-directional floor */
function selectedElementsCost(servings, rate) {
  var r = rate > 0 ? rate : ldpHourlyRate();
  var sv = servings != null ? servings : ldpServingsNow();
  var total = 0;
  elRules().forEach(function (el) {
    if (!elementOn(el.id) || el.unpriced || !el.time) return;
    total += elTotalHoursForCake(el, sv) * r + elMaterialsForCake(el, sv);
  });
  return total;
}
/* how many selected elements pay under her floor - the ledger's strip */
function elementsUnderFloor(servings) {
  var hr = ldpHourlyRate(), sv = servings != null ? servings : ldpServingsNow(), n = 0;
  elRules().forEach(function (el) {
    if (!elIsPriced(el) || !el.time) return;
    var pays = elPaysPerHour(el, sv);
    if (pays > 0 && pays < hr - 0.005) n++;
  });
  return n;
}
/* round 54 (mock): a gold dot marks any element whose flat fee pays under
   her hourly floor - the same test the "N under your floor" strip counts. */
function elUnderFloorFlag(rule, servings) {
  if (!rule || rule.id === 'faux' || !elIsPriced(rule) || !rule.time) return false;
  var pays = elPaysPerHour(rule, servings != null ? servings : ldpServingsNow());
  return pays > 0 && pays < ldpHourlyRate() - 0.005;
}
window.LAYERD.pricingElements = { list: selectedElements, total: elementsTotal,
  cost: selectedElementsCost, hoursOf: elHoursOf, paysPerHour: elPaysPerHour,
  underFloor: elementsUnderFloor, servingsNow: ldpServingsNow };

/* ============ r147 (Mariya, 2026-08-26): the free tier widens ============
   "free = understand your price; Pro = use it with clients."
   Market and add-ons become usable at studio rates; printing becomes the
   Pro door, replaced for free by a watermarked preview of the quote
   sheet; and one read-only break-even sentence teaches the model.
   ALL of it is guarded on the premium island being absent - on a Pro page
   the premium bundle owns these controls. */
function ldpIsFreePage() { return !document.getElementById('ldp-premium'); }

var ldpFreeMkt = { mult: 1, label: '', bandId: '' };   /* r197: no country */
(function initLdpFreeMarket() {
  if (!ldpIsFreePage() || !CFG || !CFG.marketBands) return;
  var card = document.getElementById('ldp-market');
  if (!card) return;
  var sel = document.getElementById('ldpRegionSelect');
  var note = document.getElementById('ldpLocationNote');
  var val = document.getElementById('ldpLocationValue');
  var slider = document.getElementById('ldpLocationSlider');
  var KEY = 'layerd-pricing-freemarket';
  /* the multiplier is a picked BAND here, never a slid number - the raw
     slider is Pro chrome, so it hides and the label shows the pick */
  if (slider && slider.parentNode) slider.parentNode.classList.add('ldp-sliderfield--quiet');
  var lblWrap = slider ? slider.parentNode.querySelector('.ld-field__label') : null;
  if (lblWrap) lblWrap.style.display = 'block';   /* r144 hid it for Pro; free needs it back */

  /* r197 (Mariya, 2026-08-31): "I don't really like that it only considers
     US and Canada... I believe this can be applied just fine across any
     country and opens up the ability for them to participate."

     Right on the facts: the two country lists carried the SAME five labels
     and differed on one multiplier. They are metro-SIZE tiers. One global
     list now, and the country chips are gone from the card entirely. */
  function bands() { return CFG.marketBands || []; }

  /* a saved id from before r197 was prefixed (us-metro / ca-metro); the
     prefix is all that changed, so strip it rather than dropping her pick */
  function migrateBandId(id) {
    id = String(id || '');
    var m = /^(?:us|ca)-(.+)$/.exec(id);
    if (m) id = (m[1] === 'baseline') ? 'baseline' : m[1];
    return bands().filter(function (b) { return b.id === id; })[0] ? id : '';
  }

  function paint() {
    var b = bands().filter(function (x) { return x.id === ldpFreeMkt.bandId; })[0] || bands()[0] || { multiplier: 1, label: '' };
    ldpFreeMkt.mult = b.multiplier || 1;
    ldpFreeMkt.label = b.label || '';
    ldpFreeMkt.bandId = b.id || '';
    if (val) val.textContent = '\u00d7' + ldpFreeMkt.mult.toFixed(2);
    if (note) note.textContent = ldpFreeMkt.mult === 1 ? ''
      : ldpFreeMkt.label + ' pricing is applied to your starting price.';
    try { localStorage.setItem(KEY, JSON.stringify({ b: ldpFreeMkt.bandId })); } catch (e) { }
    ldpFreeRecalc();
  }
  function fillSelect() {
    if (!sel) return;
    sel.innerHTML = '';
    bands().forEach(function (b) {
      var o = document.createElement('option');
      o.value = b.id; o.textContent = b.label;
      sel.appendChild(o);
    });
    sel.value = ldpFreeMkt.bandId;
    if (sel.selectedIndex < 0 && sel.options.length) { sel.selectedIndex = 0; ldpFreeMkt.bandId = sel.value; }
  }
  try {
    var saved = JSON.parse(localStorage.getItem(KEY));
    if (saved) ldpFreeMkt.bandId = migrateBandId(saved.b);
  } catch (e) { }
  if (sel) sel.addEventListener('change', function () { ldpFreeMkt.bandId = sel.value; paint(); });

  /* detect: same on-device nearest-match the Pro page does */
  var det = document.getElementById('ldpDetectBtn');
  var st = document.getElementById('ldpDetectStatus');
  if (det) det.addEventListener('click', function () {
    if (!navigator.geolocation) return;
    if (st) { st.hidden = false; st.textContent = 'Finding the nearest match' + String.fromCharCode(8230); }
    navigator.geolocation.getCurrentPosition(function (pos) {
      var hit = ldpNearestMetro(pos.coords.latitude, pos.coords.longitude);
      if (!hit) {
        /* r197: THE DETECTOR MUST BE ABLE TO SAY NO. The metro table is 29
           named North American cities; before this round the nearest one
           always won, however far away it was, so opening the page in
           London would have answered "New York". Outside the coverage it
           declines and she picks a band - which is why the bands had to
           stop being country-specific first. */
        if (st) st.textContent = 'No city near you on file yet - pick the market that fits from the list above.';
        return;
      }
      var band = bands().filter(function (b) { return b.tier === hit.entry.tier; })[0];
      ldpFreeMkt.bandId = band ? band.id : ldpFreeMkt.bandId;
      fillSelect(); paint();
      if (st) st.textContent = 'Nearest match: ' + hit.entry.label +
        (band ? ', that is a ' + band.label.toLowerCase() + ' market.' : '') +
        ' Change it above if this is not right.';
    }, function () {
      if (st) { st.hidden = false; st.textContent = 'Location permission was not granted - just pick your market above.'; }
    }, { timeout: 8000 });
  });
  fillSelect(); paint();
})();

/* r197: ONE nearest-metro search, shared by the free card above and (by the
   same rules) the premium bundle. Two things it must get right:
     - the master's field is `lng`, not `lon`. Reading `lon` made every
       distance NaN, nothing won the comparison, and the free button
       silently reported no match while Pro worked (r178).
     - great-circle km, not squared degrees. A degree of longitude is ~78km
       in Toronto and ~111km at the equator, so the cheap planar version
       skewed north-south and, worse, gave no honest distance to test the
       coverage ceiling against. */
var LDP_DETECT_MAX_KM = 240;
function ldpNearestMetro(lat, lng) {
  var list = (CFG && CFG.locationTiers) || [];
  var best = null, bestKm = Infinity;
  list.forEach(function (e) {
    var elat = e.lat, elng = (e.lng != null) ? e.lng : e.lon;
    if (typeof elat !== 'number' || typeof elng !== 'number') return;
    var dLat = (elat - lat) * Math.PI / 180;
    var dLng = (elng - lng) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat * Math.PI / 180) * Math.cos(elat * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var km = 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    if (km < bestKm) { bestKm = km; best = e; }
  });
  if (!best || bestKm > LDP_DETECT_MAX_KM) return null;
  return { entry: best, km: bestKm };
}
window.LAYERD = window.LAYERD || {};
window.LAYERD.pricingNearestMetro = ldpNearestMetro;

/* ---------- r197: the currency picker ----------
   Lives in the FREE bundle so both tiers get one control with one
   behaviour - the old country segment was premium-wired and the free page
   had no way to say what currency it was quoting in at all.

   Symbol only. Nothing is converted, ever: every amount here is one she
   typed or a studio default she overwrites, and restating those at a spot
   rate would quietly change prices she set. */
(function initLdpCurrency() {
  var sel = document.getElementById('ldpCurrencySelect');
  if (!sel || !CFG || !CFG.currencies || !CFG.currencies.length) return;

  CFG.currencies.forEach(function (c) {
    var o = document.createElement('option');
    o.value = c.code;
    /* the code carries the meaning on a quote; the name is the disambiguator
       for the several dollars and the several pounds */
    o.textContent = c.code + ' · ' + c.label;
    sel.appendChild(o);
  });

  function current() {
    var code = currencyCode();
    return CFG.currencies.filter(function (c) { return c.code === code; })[0]
      ? code : CFG.currencies[0].code;
  }
  sel.value = current();
  /* the seeded value may be a currency we do not list (an obscure store
     currency); adopt the list's answer so the control and the page agree */
  if (root && sel.value) root.setAttribute('data-currency', sel.value);

  sel.addEventListener('change', function () {
    if (!sel.value) return;
    root.setAttribute('data-currency', sel.value);
    try { localStorage.setItem(LDP_CUR_KEY, sel.value); } catch (e) { }
    _ldpFmt = {};                       /* the cached formatters are stale */
    if (ldpIsFreePage()) ldpFreeRecalc();
    /* the premium bundle owns its own quote render; it listens for this */
    try {
      window.dispatchEvent(new CustomEvent('layerd:currency', { detail: { code: sel.value } }));
    } catch (e) {
      var ev = document.createEvent('Event');
      ev.initEvent('layerd:currency', true, true);
      window.dispatchEvent(ev);
    }
  });
})();

/* free add-ons: five studio-rate rows, summed into the quote */
function ldpFreeAddons(cakePlusElements) {
  var flat = 0, pct = 0, names = [], lines = [];
  Array.prototype.forEach.call(document.querySelectorAll('[data-ldpfa]'), function (t) {
    if (!t.checked) return;
    var amt = parseFloat(t.getAttribute('data-amt')) || 0;
    var isPct = t.getAttribute('data-ldpfa') === 'pct';
    if (isPct) pct += amt; else flat += amt;
    var lbl = t.closest('.ldp-addon-row2');
    lbl = lbl && lbl.querySelector('.ldp-addon-lbl');
    var nm = lbl ? lbl.textContent.trim() : '';
    names.push(nm);
    lines.push({ name: nm, amt: isPct ? Math.round(cakePlusElements * amt) / 100 : amt });
  });
  return { total: flat + Math.round(cakePlusElements * pct) / 100,
           names: names, lines: lines, any: flat > 0 || pct > 0 };
}
(function wireFreeAddons() {
  if (!ldpIsFreePage()) return;
  Array.prototype.forEach.call(document.querySelectorAll('[data-ldpfa]'), function (t) {
    t.addEventListener('change', function () { ldpFreeRecalc(); });
  });
})();

/* re-run the visible quote after a market/add-on change - the calc button
   is the one render path, same pattern the rest of this file uses */
function ldpFreeRecalc() {
  var res = document.getElementById('ldpResults');
  var btn = document.getElementById('ldpCalcBtn');
  if (res && !res.hidden && btn) btn.click();
}

/* one read-only sentence above Base cover: the model, taught in the
   visitor's own numbers. Pro computes it from THEIR costs; this states it
   at the studio's. */
function ldpFreeFloorLine(servings, tiers) {
  var host = document.getElementById('ldpFreeFloor');
  /* 2026-09-11 (Mariya): the break-even now leads in the quote band (see the
     .ldp-breakeven line there), so this above-Base-cover sentence is retired
     to avoid stating the floor twice. */
  if (host) { host.hidden = true; host.innerHTML = ''; }
  return;
  var cf = CFG && CFG.costFirst;
  if (!host || !cf || !cf.ing) return;
  /* r149: initLdpOneCard merges every .ldp-card into one and leaves this
     non-card div stranded BELOW the merged card. Its home is above Base
     cover, inside the card - it moves itself there on first render. */
  var design = document.getElementById('ldp-design');
  if (design && host.nextElementSibling !== design) {
    design.parentNode.insertBefore(host, design);
  }
  var band = (state.complexity === 'fondant') ? 'fondant' : 'simple';
  var sv = servings > 0 ? servings : 45;
  var ti = tiers > 0 ? tiers : Math.max(1, Math.round(sv / 15));
  var floor = (cf.ing[band] || 0) + ((cf.hpt || {})[band] || 0) * ti * (cf.rate || 28) / sv;
  host.innerHTML = 'at studio costs, break-even here is <b>' + formatMoney(floor) +
    '</b> a serving ' + String.fromCharCode(8212) + ' under that you are paying to work.' +
    '<span class="ldp-freefloor__pro"> Pro computes yours.</span>';
  host.hidden = false;
}

/* the watermarked sheet preview - the Pro quote sheet's shape, the
   visitor's own numbers, SAMPLE across it, blank if printed */
(function initLdpSheetPreview() {
  if (!ldpIsFreePage()) return;
  var btn = document.getElementById('ldpSheetPreviewBtn');
  if (!btn) return;

  /* r178 (Mariya: "the invoice is still cutting off. I don't get it. Why
     is it not showing properly?").

     THE CAUSE, finally: this read the sheet's CSS out of
     document.styleSheets[].cssRules. On her live site learn-pricing.css is
     served from cdn.shopify.com - a DIFFERENT ORIGIN - and cssRules throws
     SecurityError on any cross-origin sheet. The catch swallowed it, the
     collector returned NOTHING, and the sheet rendered with no styles at
     all: no fixed page width, no padding, no scale. Every local preview is
     same-origin, which is exactly why I could never reproduce it.

     It fetches the stylesheet TEXT now (Shopify's CDN allows it) and pulls
     the @media print block out with a scan. cssRules stays as the fast
     path when it IS same-origin. Cached after the first open. */
  var cssCache = null;

  function fromCssom() {
    var css = '';
    for (var i = 0; i < document.styleSheets.length; i++) {
      var rules;
      try { rules = document.styleSheets[i].cssRules; } catch (e) { continue; }
      for (var j = 0; j < rules.length; j++) {
        var r = rules[j];
        if (!r.media || !/print/.test(r.media.mediaText) || !r.cssRules) continue;
        for (var k = 0; k < r.cssRules.length; k++) {
          var sel = r.cssRules[k].selectorText || '';
          if (sel.indexOf('ldpQuoteSheet') > -1 || sel.indexOf('ldq-has-sheet') > -1) {
            css += r.cssRules[k].cssText + String.fromCharCode(10);
          }
        }
      }
    }
    return css;
  }

  /* pull every @media print { ... } body out of raw CSS text by matching
     braces - a regex cannot balance them */
  function printBlocks(text) {
    var out = '', at = 0;
    while (true) {
      var m = text.indexOf('@media', at);
      if (m < 0) break;
      var open = text.indexOf('{', m);
      if (open < 0) break;
      var head = text.slice(m, open);
      var depth = 0, p = open;
      for (; p < text.length; p++) {
        if (text[p] === '{') depth++;
        else if (text[p] === '}') { depth--; if (!depth) break; }
      }
      if (/print/.test(head)) out += text.slice(open + 1, p) + String.fromCharCode(10);
      at = p + 1;
    }
    return out;
  }

  function sheetCss() {
    if (cssCache != null) return Promise.resolve(cssCache);
    var direct = fromCssom();
    if (direct && direct.length > 400) { cssCache = direct; return Promise.resolve(direct); }
    var hrefs = [];
    for (var i = 0; i < document.styleSheets.length; i++) {
      var h = document.styleSheets[i].href;
      if (h && /learn-pricing/.test(h)) hrefs.push(h);
    }
    if (!hrefs.length) { cssCache = direct; return Promise.resolve(direct); }
    return Promise.all(hrefs.map(function (h) {
      return fetch(h).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (texts) {
      cssCache = printBlocks(texts.join(String.fromCharCode(10))) || direct;
      return cssCache;
    });
  }

  btn.addEventListener('click', function () {
    var q = window.__ldpFreeQuote;
    if (!q || !window.ldqBuildSheetHtml) return;
    var old = document.getElementById('ldqsOverlay');
    if (old) old.remove();

    var ov = document.createElement('div');
    ov.id = 'ldqsOverlay';
    ov.className = 'ldqs-overlay';
    ov.innerHTML =
      '<div class="ldqs-frame" role="dialog" aria-label="Quote sheet preview">' +
        '<button type="button" class="ldqs-close" aria-label="Close preview">' + String.fromCharCode(215) + '</button>' +
        '<div class="ldqs-scroll"><iframe class="ldqs-if" title="Sample quote sheet"></iframe></div>' +
        '<p class="ldqs-cta">This is the sheet LAYER' + String.fromCharCode(8217) + 'D Toolkit Pro prints ' +
          String.fromCharCode(8212) + ' your logo, your rates, deposit terms, no watermark.</p>' +
      '</div>';
    document.body.appendChild(ov);

    var f = ov.querySelector('.ldqs-if');
    var scroll = ov.querySelector('.ldqs-scroll');
    function close() { ov.remove(); }
    ov.addEventListener('click', function (ev) { if (ev.target === ov) close(); });
    ov.querySelector('.ldqs-close').addEventListener('click', close);

    /* the scale is decided HERE, from a container this document owns, and
       baked into the iframe's own markup. Nothing is measured after the
       write - that cross-document read is what iOS invalidated. */
    var SHEET_W = 816, SHEET_H = 960;
    /* measured from the VIEWPORT, not the container: the overlay was
       appended a tick ago and its inner width still reads ~5px until the
       browser lays it out. The numbers mirror the CSS - frame is
       min(860px, 100%) inside a 10px gutter - so the two cannot disagree. */
    var avail = Math.min(860, (window.innerWidth || SHEET_W) - 20);
    var scale = Math.min(1, avail / SHEET_W);
    f.style.width = Math.round(SHEET_W * scale) + 'px';
    f.style.height = Math.round(SHEET_H * scale) + 'px';
    scroll.style.height = Math.round(SHEET_H * scale) + 'px';

    sheetCss().then(function (css) {
      if (!document.getElementById('ldqsOverlay')) return;   /* closed while fetching */
      var d = f.contentDocument;
      d.open();
      d.write('<!doctype html><html><head><meta charset="utf-8">' +
        '<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=Jost:wght@300;400;500&display=swap">' +
        '<style>html,body{margin:0;padding:0;background:#FCFAF5;width:' + SHEET_W + 'px}' +
        css +

        '.ldqs-mark{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;' +
        'font-family:Jost,sans-serif;font-size:132px;font-weight:500;letter-spacing:.3em;' +
        'color:rgba(43,38,32,.10);transform:rotate(-28deg);pointer-events:none;z-index:9}' +
        '</style></head><body class="ldq-has-sheet">' +
        /* r178: NO wrapper, and the scale rides an INLINE style.
           Two reasons, both learned the hard way:
             - the injected CSS is r157's print isolation, which includes
               `body.ldq-has-sheet > * { display:none !important }` to hide
               page furniture from the printer. A wrapper div IS such a
               child, so it was being hidden - the sheet had no layout at
               all, which is the "cut off" she kept seeing;
             - the stylesheet is fetched text, so a class rule appended
               after it can be lost to one malformed brace. Inline cannot.
           The sheet stays a direct child (the rule's own exception) and
           carries the transform itself; the watermark goes INSIDE it. */
        '<div id="ldpQuoteSheet" style="transform:scale(' + scale +
          ');transform-origin:top left;position:relative"></div>' +
        '</body></html>');
      d.close();
      var host = d.getElementById('ldpQuoteSheet');
      if (!host) return;
      host.classList.toggle('ldq-compact', (q.lines || []).length > 7);
      host.innerHTML = window.ldqBuildSheetHtml(q);
      window.ldqApplyAccent(host);
      /* the watermark lives inside the sheet now - as a body child it was
         caught by the same display:none rule */
      var mk = d.createElement('div');
      mk.className = 'ldqs-mark';
      mk.textContent = 'SAMPLE';
      host.appendChild(mk);
    });
  });
})();

/* ---------- r18: "Your rates" — every element, editable, Pro only ----------
   MUST LIVE HERE, not at the end of the file: EL_RULES and the rate helpers
   belong to this scope, and an earlier attempt appended this after the
   enclosing IIFE closed - it threw on its first reference and silently
   never rendered. Scope is not a detail.
   Sits inside the elements editor, under the chips, so the price and the
   thing being priced are in one place. Rates are hers and live on this
   device; "reset" puts the studio default back. */
(function initLdpElRates() {
  function boot() {
    var box = document.getElementById('ldpElementsBox');
    if (!box || !EL_STUDIO_RULES.length || box.querySelector('.ldp-elrates')) return;
    /* r132 (Mariya: "I want to be able to collapse the your rates section
       because it can be annoying having that constantly be viewable").
       Studio rates are set once and then read rarely; they should not sit
       open under the chips she taps on every quote. Shut by default, and
       her choice is remembered. */
    var RATES_KEY = 'layerd-pricing-rates-open';
    function ratesOpen() {
      try { return localStorage.getItem(RATES_KEY) === '1'; } catch (e) { return false; }
    }
    function setRatesOpen(on) {
      try { localStorage.setItem(RATES_KEY, on ? '1' : '0'); } catch (e) { }
    }
    var pro = ldpIsPro();
    var panel = document.createElement('div');
    panel.className = 'ldp-elrates ldc-rates';
    /* r207: the ledger's figures are all per-cake, so it re-renders with
       the cake. Without this it painted once at boot - before a serving
       count existed - and every per-serving element read "no time set". */
    var reRenderPending = false;
    window.addEventListener('layerd:pricing-changed', function () {
      if (reRenderPending) return;
      reRenderPending = true;
      setTimeout(function () { reRenderPending = false; try { render(); } catch (e) { } }, 0);
    });
    /* r207: which row is expanded - ONE string, not a set of booleans */
    var openRow = null;

    /* r231 (Mariya): "Your rates" opens as a pop-up now, like the ingredient
       costs - the studio rates are set-once-and-read-rarely, so they should
       not sit inline under the chips. A slim opener row stays in the card;
       the ledger renders inside a modal (reusing the .mcs1-modal chrome). */
    var MODAL = true;
    var opener = null;
    function ensureRatesModal() {
      var m = document.getElementById('ldpRatesModal');
      if (m) return m;
      m = document.createElement('div');
      m.id = 'ldpRatesModal';
      m.className = 'mcs1-modal';
      m.hidden = true;
      m.innerHTML =
        '<div class="mcs1-modal__backdrop" data-ldratesclose="1"></div>' +
        '<div class="mcs1-modal__panel" role="dialog" aria-modal="true" aria-label="Your element rates">' +
          '<div class="mcs1-modal__head">' +
            '<span class="mcs1-modal__title">your element rates</span>' +
            '<button type="button" class="mcs1-modal__x" data-ldratesclose="1" aria-label="Close">×</button>' +
          '</div>' +
          '<div class="mcs1-modal__scroll" id="ldpRatesModalBody"></div>' +
        '</div>';
      (box.closest('.ldpc') || document.body).appendChild(m);
      m.addEventListener('click', function (ev) {
        if (ev.target && ev.target.closest && ev.target.closest('[data-ldratesclose]')) closeRatesModal();
      });
      return m;
    }
    function ratesModalOpen() { var m = document.getElementById('ldpRatesModal'); return !!(m && !m.hidden); }
    function openRatesModal() {
      ensureRatesModal();
      var b = document.getElementById('ldpRatesModalBody');
      if (b && panel.parentNode !== b) b.appendChild(panel);
      render();
      var m = document.getElementById('ldpRatesModal');
      if (m) m.hidden = false;
      try { document.documentElement.classList.add('mcs1-modal-open'); } catch (e) { }
    }
    function closeRatesModal() {
      var m = document.getElementById('ldpRatesModal');
      if (m) m.hidden = true;
      try { document.documentElement.classList.remove('mcs1-modal-open'); } catch (e) { }
    }
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && ratesModalOpen()) closeRatesModal();
    });
    function buildOpener() {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ldp-elrates-open ldc-price__jump';
      b.setAttribute('aria-haspopup', 'dialog');
      b.addEventListener('click', openRatesModal);
      return b;
    }
    function updateOpener() {
      if (!opener) return;
      var underNow = 0;
      try { underNow = elementsUnderFloor(ldpServingsNow()); } catch (e) { underNow = 0; }
      var sub = ldpIsPro()
        ? (underNow
            ? '<span class="ldp-elrates__sub ldc-price__jumpsub ldc-price__jumpsub--warn">' + underNow + ' under your floor</span>'
            : '')
        : '<span class="ldp-elrates__sub ldc-price__jumpsub">Part of the full framework.</span>';
      opener.innerHTML = '<span class="ldp-elrates__text">' +
        '<span class="ldp-elrates__eyebrow ldc-price__jumpname">Your rates</span>' + sub + '</span>' +
        '<span class="ldp-elrates__x ld-collapse__x" aria-hidden="true">›</span>';
    }

    function render() {
      updateOpener();
      panel.innerHTML = '';
      var head = document.createElement('div');
      head.className = 'ldp-elrates__head ldp-elrates__toggle';
      /* r200: the label column is its own box so the chevron can sit
         centred at the right of the row. It used to be a third child of a
         COLUMN flex head, which parked the arrow on a line of its own
         under the sub-line - the reason it read as a stray mark. */
      /* r211 correction 5: this is a ROW, not a titled card - the same
         .ldc-price__jump the rest of the page uses to send you somewhere.
         The teaching sub is gone for members; what it says instead is the
         one fact worth a sub, how many rates sit under the floor. */
      var underNow = 0;
      try { underNow = elementsUnderFloor(ldpServingsNow()); } catch (eU) { underNow = 0; }
      head.className += ' ldc-price__jump';
      head.innerHTML = '<span class="ldp-elrates__text">' +
        '<span class="ldp-elrates__eyebrow ldc-price__jumpname">Your rates</span>' +
        (pro
          ? (underNow
              ? '<span class="ldp-elrates__sub ldc-price__jumpsub ldc-price__jumpsub--warn">' +
                underNow + ' under your floor</span>'
              : '')
          : '<span class="ldp-elrates__sub ldc-price__jumpsub">Part of the full framework.</span>') +
        '</span>';
      /* r231: in modal mode the modal title carries the heading, so the
         inline head (and its fold toggle) is not appended - the opener row
         in the card is the only "Your rates" control on the page. */
      if (!MODAL) panel.appendChild(head);

      if (!pro) {
        /* r54 follow-up (Mariya): locked-but-visible, upgraded from a bare
           text note to a DIMMED LIVE LEDGER. Free sees the real studio rates
           and the floor check per element - the same numbers the elements
           section already shows - but the rows are inert and dimmed. Setting
           your own rate per element is the Pro door, and the CTA links
           straight to the Toolkit product page. */
        var svF = ldpServingsNow();
        var floorRateF = ldpHourlyRate();
        var underF = elementsUnderFloor(svF);

        var stripF = document.createElement('div');
        stripF.className = 'ldc-rates__strip' + (underF ? '' : ' ldc-rates__strip--ok');
        stripF.innerHTML = '<span>' +
          (underF ? underF + ' under your floor' : 'every rate clears your floor') +
          (svF > 0 ? ' · ' + svF + '-serving cake' : '') + '</span>' +
          '<span class="ldc-rates__floor">' + currencySymbol() + Math.round(floorRateF) +
          '<span>/hr</span></span>';
        panel.appendChild(stripF);

        var lockList = document.createElement('div');
        lockList.className = 'ldc-rates__list ldp-elrates__locklist';
        lockList.setAttribute('aria-hidden', 'true');
        EL_STUDIO_RULES.forEach(function (rule) {
          if (!elIsPriced(rule)) return;
          var perF = elKind(rule) === 'perServing';
          var nameF = rule.label + (rule.scale ? ' (' + (EL_SCALE_LABEL[flowerScale()] || flowerScale()) + ')' : '');
          var paysF = elPaysPerHour(rule, svF);
          var isUnderF = paysF > 0 && paysF < floorRateF - 0.005;
          var basisF = rule.kind === 'perFauxTier' ? '/tier' : (perF ? '/serving' : ' flat');
          var rowF = document.createElement('div');
          rowF.className = 'ldc-rate ldc-rate--locked';
          var labF = document.createElement('span');
          labF.className = 'ldc-rate__label';
          var nEl = document.createElement('span'); nEl.className = 'ldc-rate__name'; nEl.textContent = nameF;
          var sEl = document.createElement('span'); sEl.className = 'ldc-rate__sub';
          sEl.textContent = currencySymbol() + elRate(rule) + basisF;
          labF.appendChild(nEl); labF.appendChild(sEl);
          var figF = document.createElement('span'); figF.className = 'ldc-rate__fig';
          var hrF = document.createElement('span');
          hrF.className = 'ldc-rate__hr' + (isUnderF ? ' ldc-rate__hr--under' : '');
          hrF.innerHTML = paysF > 0 ? Math.round(paysF) + '<span>/hr</span>' : 'n/a';
          figF.appendChild(hrF);
          rowF.appendChild(labF); rowF.appendChild(figF);
          lockList.appendChild(rowF);
        });
        panel.appendChild(lockList);

        var lock = document.createElement('div');
        lock.className = 'ldp-elrates__lock';
        var lockP = document.createElement('p');
        lockP.className = 'ldp-elrates__lockcopy';
        lockP.textContent = 'these are the studio rates. in pro you set your own for every element.';
        var lockA = document.createElement('a');
        lockA.className = 'ldp-elrates__lockcta';
        lockA.href = '/products/learn-hub-pro';
        lockA.setAttribute('data-cta', 'toolkit');
        lockA.textContent = 'set your own rates in pro';
        lock.appendChild(lockP); lock.appendChild(lockA);
        panel.appendChild(lock);
        return;
      }
      /* ================= r207: THE RATE LEDGER (her round 51, 1a) =========
         The hourly rate is the point of the feature, and it shipped as the
         smallest text on the row in a column so narrow that "hrs \u00b7" broke
         over two lines. Inverted: the RATE is the ledger figure, what she
         charges is the summary under the name, and every element is asked
         the same question in the same unit - hours on this cake.

         One row open at a time (one `openRow` string, not a set of
         booleans). Rows under her floor take the gold dot and figure;
         nothing above it is ever flagged - the floor is a floor. */
      var sv = ldpServingsNow();
      var floorRate = ldpHourlyRate();
      var under = elementsUnderFloor(sv);

      var strip = document.createElement('div');
      strip.className = 'ldc-rates__strip' + (under ? '' : ' ldc-rates__strip--ok');
      /* r211 correction 5: "3 pays under your floor" hyphenated across
         two lines at 390px. The verb is not carrying anything. */
      var stripTxt = under
        ? under + ' under your floor'
        : 'every rate clears your floor';
      strip.innerHTML = '<span>' + stripTxt + (sv > 0 ? ' \u00b7 ' + sv + '-serving cake' : '') + '</span>' +
        '<span class="ldc-rates__floor">' + currencySymbol() + Math.round(floorRate) +
        '<span>/hr</span></span>';
      panel.appendChild(strip);

      var list = document.createElement('div');
      list.className = 'ldc-rates__list';
      panel.appendChild(list);

      EL_STUDIO_RULES.forEach(function (rule) {
        /* r124: nothing to set for an element that is not priced */
        if (!elIsPriced(rule)) return;
        var key = elRateKey(rule);
        var per = elKind(rule) === 'perServing';
        var name = rule.label + (rule.scale ? ' (' + (EL_SCALE_LABEL[flowerScale()] || flowerScale()) + ')' : '');
        var pays = elPaysPerHour(rule, sv);
        var isUnder = pays > 0 && pays < floorRate - 0.005;
        var hrs = elHoursForCake(rule, sv);

        /* the charge, in its own basis - the summary line, never the figure */
        function basisTxt() {
          if (rule.kind === 'perFauxTier') return '/tier';
          return per ? '/serving' : ' flat';
        }
        function hoursTxt() {
          /* a per-serving element's hours ARE the cake's - before one is
             sized there is no honest number to show, and saying "no time
             set" would blame her for a blank the page owns */
          if (!(hrs > 0) && per && !(sv > 0)) return 'size the cake for the hours';
          if (!(hrs > 0)) return 'no time set';
          var shown = Math.round(hrs * 100) / 100;
          return shown + (shown === 1 ? ' hr' : ' hrs') +
            (rule.kind === 'perFauxTier' ? '/tier' : (per ? ' here' : ''));
        }
        function figHtml(el2) {
          el2.className = 'ldc-rate__hr' + (isUnder ? ' ldc-rate__hr--under' : '');
          el2.innerHTML = pays > 0
            ? Math.round(pays) + '<span>/hr</span>'
            : 'n/a';
        }

        if (openRow !== key) {
          var row = document.createElement('button');
          row.type = 'button';
          row.className = 'ldc-rate';
          row.setAttribute('aria-label', name + ', ' + currencySymbol() + elRate(rule) + basisTxt() +
            (pays > 0 ? ', pays ' + currencySymbol() + Math.round(pays) + ' an hour' : ''));
          var lab = document.createElement('span');
          lab.className = 'ldc-rate__label';
          var n1 = document.createElement('span');
          n1.className = 'ldc-rate__name';
          n1.textContent = name;
          var s1 = document.createElement('span');
          s1.className = 'ldc-rate__sub';
          s1.textContent = currencySymbol() + elRate(rule) + basisTxt() + ' \u00b7 ' + hoursTxt();
          lab.appendChild(n1); lab.appendChild(s1);
          var fig = document.createElement('span');
          fig.className = 'ldc-rate__fig';
          if (isUnder) {
            var dot = document.createElement('span');
            dot.className = 'ldc-rate__dot';
            dot.setAttribute('aria-hidden', 'true');
            fig.appendChild(dot);
          }
          var hrEl = document.createElement('span');
          figHtml(hrEl);
          fig.appendChild(hrEl);
          row.appendChild(lab); row.appendChild(fig);
          row.addEventListener('click', function () { openRow = key; render(); });
          list.appendChild(row);
          return;
        }

        /* ---- the open row: two underlined fields, the shortfall, the
           rate large at the right. No suggested price: the effective
           formula subtracts materials before dividing, so a target
           computed without it would tell her a price clears her floor
           when it does not. ---- */
        var well = document.createElement('div');
        well.className = 'ldc-rate__well';
        var wh = document.createElement('div');
        wh.className = 'ldc-rate__wellhead';
        var whn = document.createElement('span');
        whn.className = 'ldc-rate__name';
        whn.textContent = name;
        wh.appendChild(whn);
        if (isUnder) {
          var flag = document.createElement('span');
          flag.className = 'ldc-rate__flag';
          flag.textContent = 'under floor';
          wh.appendChild(flag);
        }
        well.appendChild(wh);

        var pair = document.createElement('div');
        pair.className = 'ldc-rate__pair';

        function fieldBox(labelTxt, cur, value, unitTxt, step, onCommit) {
          var wrap = document.createElement('div');
          wrap.className = 'ldc-rate__fieldwrap';
          var lb = document.createElement('span');
          lb.className = 'ldc-rate__fieldlabel';
          lb.textContent = labelTxt;
          var fieldEl = document.createElement('div');
          fieldEl.className = 'ldc-rate__field';
          if (cur) {
            var cs = document.createElement('span');
            cs.className = 'ldc-rate__cur';
            cs.textContent = cur;
            fieldEl.appendChild(cs);
          }
          var inp = document.createElement('input');
          inp.type = 'number'; inp.min = '0'; inp.step = step;
          inp.className = 'ldc-rate__input'; inp.inputMode = 'decimal';
          inp.value = String(value);
          inp.setAttribute('aria-label', labelTxt + ' for ' + name);
          inp.addEventListener('focus', function () { fieldEl.classList.add('ldc-rate__field--active'); });
          inp.addEventListener('blur', function () { fieldEl.classList.remove('ldc-rate__field--active'); });
          inp.addEventListener('change', function () { onCommit(parseFloat(inp.value)); });
          fieldEl.appendChild(inp);
          if (unitTxt) {
            var u = document.createElement('span');
            u.className = 'ldc-rate__unit';
            u.textContent = unitTxt;
            fieldEl.appendChild(u);
          }
          /* round 54 (mock): the field is a ± stepper, not a bare input. The
             buttons step by the field's own step and commit like a typed
             edit; typing still works for an exact value. */
          var st = parseFloat(step) || 1;
          function mkStep(dir, aria) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ldc-rate__step ldc-rate__step--' + (dir < 0 ? 'down' : 'up');
            b.setAttribute('aria-label', aria);
            b.tabIndex = -1;
            b.textContent = dir < 0 ? '−' : '+';
            b.addEventListener('click', function () {
              var cur = parseFloat(inp.value);
              if (isNaN(cur)) cur = 0;
              var next = Math.max(0, Math.round((cur + dir * st) * 100) / 100);
              inp.value = String(next);
              onCommit(next);
            });
            return b;
          }
          fieldEl.insertBefore(mkStep(-1, 'lower ' + labelTxt), fieldEl.firstChild);
          fieldEl.appendChild(mkStep(1, 'raise ' + labelTxt));
          wrap.appendChild(lb); wrap.appendChild(fieldEl);
          return wrap;
        }

        pair.appendChild(fieldBox(per ? 'Per serving' : 'Flat fee', currencySymbol(), elRate(rule),
          '', per ? '0.25' : '1', function (v) {
            var next = readElRates();
            if (isNaN(v)) delete next[key]; else next[key] = v;
            writeElRates(next);
            render();
            try { recalc(); } catch (e) { }
          }));
        pair.appendChild(fieldBox(
          /* r211 correction 5: the pair reads "YOU CHARGE / HOURS HERE" -
             "Hours on this cake" wrapped and pushed its field a line below
             the one beside it. */
          rule.kind === 'perFauxTier' ? 'Hours per tier' : 'Hours it takes', '',
          Math.round(hrs * 100) / 100, 'hrs', '0.25', function (v) {
            elSetHoursForCake(rule, v, sv);
            render();
            try { recalc(); } catch (e) { }
          }));
        well.appendChild(pair);

        var readout = document.createElement('div');
        readout.className = 'ldc-rate__readout';
        var gap = document.createElement('span');
        gap.className = 'ldc-rate__gap';
        /* the shortfall only - a subtraction of two figures already on
           screen, never an invented target price */
        gap.textContent = isUnder
          ? currencySymbol() + Math.round(floorRate - pays) + '/hr under your ' +
            currencySymbol() + Math.round(floorRate) + ' floor'
          : (pays > 0 ? 'clears your ' + currencySymbol() + Math.round(floorRate) + ' floor' : 'set the hours to see what this pays');
        var big = document.createElement('span');
        big.className = 'ldc-rate__big' + (isUnder ? '' : ' ldc-rate__big--ok');
        big.innerHTML = pays > 0 ? Math.round(pays) + '<span>/hr</span>' : 'n/a';
        /* round 54 (mock): the $/hr rides top-right in the card head; the
           floor sentence stays as the bottom note */
        wh.appendChild(big);
        readout.appendChild(gap);
        well.appendChild(readout);

        if (elIsCustom(rule) || elHoursCustom(rule) || elUnitCustom(rule)) {
          var reset = document.createElement('button');
          reset.type = 'button';
          reset.className = 'ldc-rate__reset';
          reset.textContent = 'reset to the studio rate';
          reset.addEventListener('click', function () {
            var nr = readElRates(); delete nr[key]; writeElRates(nr);
            var nh = readElHours(); delete nh[key]; delete nh[key + ':mps']; writeElHours(nh);
            if (elUnitTogglable(rule)) { var nu = readElUnits(); delete nu[rule.id]; writeElUnits(nu); }
            render();
            try { recalc(); } catch (e) { }
          });
          well.appendChild(reset);
        }
        list.appendChild(well);
      });
      /* r132: the fold. Built at the END of render() because `head` is
         created there and the panel is rebuilt on every rate edit - a fold
         wired outside would be discarded on the next redraw. */
      (function foldRates() {
        /* r231: in the modal there is no inline fold - the ledger is always
           shown; the modal is the container and its × is the only control. */
        if (MODAL) {
          var rowsM = [].slice.call(panel.children);
          var wrapM = document.createElement('div');
          wrapM.className = 'ldp-elrates__body';
          rowsM.forEach(function (n) { wrapM.appendChild(n); });
          panel.appendChild(wrapM);
          return;
        }
        var rows = [].slice.call(panel.children).filter(function (n) { return n !== head; });
        var wrap = document.createElement('div');
        wrap.className = 'ldp-elrates__body';
        rows.forEach(function (n) { wrap.appendChild(n); });
        panel.appendChild(wrap);
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        var chev = document.createElement('span');
        /* r200: this fold is a div, not a <details>, so r196's suite-wide
           chevron token never reached it - it was still an 11px glyph at
           40% ink. Wearing .ld-collapse__x puts it on the shared 26px
           token; learn-pricing.css only says which state is "closed". */
        chev.className = 'ldp-elrates__x ld-collapse__x';
        chev.setAttribute('aria-hidden', 'true');
        chev.textContent = '▾';
        head.appendChild(chev);
        function paint(on) {
          wrap.hidden = !on;
          panel.classList.toggle('is-open', on);
          head.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
        paint(ratesOpen());
        head.addEventListener('click', function () {
          var on = wrap.hidden; paint(on); setRatesOpen(on);
        });
        head.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); head.click(); }
        });
      })();

    }
    /* The elements editor rewrites its own innerHTML on every render, which
       silently ate this panel: it appended once, then vanished with the next
       redraw - no error, nothing in the console, just absent. Same trap as
       the Pantry tabs. Re-attach whenever it goes missing; the check makes
       it idempotent, so reacting to our own write is harmless. */
    /* r231: the elements editor rewrites #ldpElementsBox on its own renders,
       which used to eat the inline ledger; now it is the OPENER row we keep
       re-attaching (the ledger itself lives in the modal). render() refreshes
       both the modal body and the opener's under-floor count. */
    function keepAttached() {
      if (box.querySelector('.ldp-elrates-open')) return;
      if (!opener) opener = buildOpener();
      box.appendChild(opener);
      try { render(); } catch (e) { }
    }
    keepAttached();
    try { new MutationObserver(keepAttached).observe(box, { childList: true }); } catch (eO) { }
    /* the flower band changes which stored rate applies - redraw with it */
    var scale = document.getElementById('ldpElScale');
    if (scale) scale.addEventListener('change', function () { setTimeout(render, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

(function initElementsBlock() {
  var card = document.getElementById('ldpElementsCard');
  var box = document.getElementById('ldpElementsBox');
  if (!card || !box || !elRules().length) return;
  card.hidden = false;
  var ownerTier = gaTier() === 'premium';
  function money(n) { return formatMoney(n); }
  /* ---------- r9 (Mariya, 2026-07-31) ----------
     "It doesn't force me to redirect to an older stage in the process
     like it does now." It did: with a file attached the elements were
     read-only and the only way to change one was a trip to the Planner
     and back. They are editable right here now, each chip carrying the
     money it adds, and a tap writes straight to the file — the same
     round trip every other tool already makes. The file is still the one
     home; Pricing just stopped being the one tool that couldn't reach
     it. */
  function elChipLabel(r) {
    var suffix = '';
    if (r.scale) {
      suffix = ' +' + money(+r.scale[flowerScale()] || 0);
    } else if (elKind(r) === 'perServing') {
      /* r60: the chip's unit follows the member's override, and the money
         shown is THEIR rate, not the studio default the master carries */
      suffix = ' +' + money(elRate(r)) + ' /sv';
    } else if (r.kind === 'perFauxTier') {
      /* r42: the unit has to be on the chip. "+$45" alone on a two-dummy
         cake would read as a total and the $90 in the quote as an error. */
      suffix = ' +' + money(+r.amount || 0) + ' /faux tier';
    } else if (elRate(r) > 0) {
      /* r60: a flat chip shows the member's own rate too — a per-serving
         element flipped to flat would otherwise show the studio number */
      suffix = ' +' + money(elRate(r));
    } else if (ownerTier) {
      /* kept from the read-only version: an element with no rule would
         otherwise sit there silently adding nothing to the quote */
      return r.label + '<em class="ldp-el__norule">no price rule set</em>';
    }
    return r.label + '<span class="ldp-el__add">' + suffix + '</span>';
  }
  /* r48 (Mariya, 2026-08-18): Pricing is THE editor for elements now — the
     Planner's edit form dropped its chips. That only works if every element
     fact Pricing shows actually lands on the file, so the boolean writer
     grew a general sibling for the two that weren't booleans: the flower
     band and (in the premium bundle) the kitchen-sheet flag. */
  function writeFileField(key, val) {
    if (!quoteBooking) return;
    quoteBooking[key] = val;          /* keep the in-memory copy in step */
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || !v.bookings) return;
      for (var i = 0; i < v.bookings.length; i++) {
        if (v.bookings[i].id === quoteBooking.id) { v.bookings[i][key] = val; break; }
      }
      localStorage.setItem(BOOKINGS_KEY, JSON.stringify(v));
      /* the same announcement every other save makes, so the client-file
         bar and the Planner re-read without a reload */
      window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'pricing' } }));
    } catch (e) { /* private mode - the session copy still prices */ }
  }
  window.ldpWriteFileField = writeFileField;   /* the premium bundle's door */
  /* the read half of that door — quoteBooking is closure-scoped, not a
     window global, so the premium bundle can't see it directly */
  window.ldpQuoteBooking = function () { return quoteBooking; };
  function writeElementToFile(id, on) { writeFileField(id, !!on); }
  /* r114 (handoff 11b): the rate as its own string. The build shipped
     "Hand-painting / sculpting+CA$8.00 /sv" — name and price concatenated
     into one label — and the handoff calls that out by name: the rate must
     be a right-aligned column, not glued text. Same numbers, same rules as
     elChipLabel; only the packaging differs. */
  /* r211 correction 3: the currency is stated ONCE, in the eyebrow
     ("ELEMENTS \u00B7 CA$"), so the figure is `320 flat`, not
     `CA$320.00 flat` - which ate more than half the row and wrapped every
     long name to two lines. A whole amount drops its cents for the same
     reason; the unit is 11px beside it. */
  function elFigNum(n) {
    var v = Math.round((+n || 0) * 100) / 100;
    return (v % 1 === 0) ? String(v) : v.toFixed(2);
  }
  function elRateText(r) {
    /* r124: an element that is deliberately not priced says so. Without
       this it would read "+$0.00" and look like a bug. */
    if (r.unpriced) return '<span class="ldp-elrow2__u">in your ingredients</span>';
    function fig(n, unit) {
      return elFigNum(n) + '<span class="ldp-elrow2__u"> ' + unit + '</span>';
    }
    if (r.scale) return fig(+r.scale[flowerScale()] || 0, 'flat');
    if (elKind(r) === 'perServing') return fig(elRate(r), '/sv');
    if (r.kind === 'perFauxTier') return fig(+r.amount || 0, '/tier');
    if (elRate(r) > 0) return fig(elRate(r), 'flat');
    return '';
  }
  function chipsHTML(intro) {
    /* r114: rows, not chips. 48px, a rounded-square mark on the left, the
       name, and the rate right-aligned in its own column. */
    var h = '<p class="ldp-sub ldp-el__none">' + intro + '</p><div class="ld-chips ldp-el__chips ldc-price__opts">';
    /* r207 patch 6: the rows wear the ledger's classes too, so the design's
       44px checkbox row styles them without moving a single handler - every
       listener on this page keys off .ld-chip[data-el]. Past the fifth row
       they carry is-extra and fold behind "Show N more"; a row that is ON
       is never hidden, or a ticked element would vanish from view. */
    var shown = 0;
    elRules().forEach(function (r) {
      /* r42: the faux row is derived from the cake file, so it appears only
         when there ARE dummies — and as a stated line, not a toggle. */
      if (r.id === 'faux') {
        var nf = ldpFauxCount();
        if (!nf) return;
        shown++;
        h += '<span class="ld-chip ldp-elrow2 ldc-price__opt is-derived" aria-disabled="true" ' +
             'title="Set in Recipes. Mark a tier faux there and this follows.">' +
             '<span class="ldp-elrow2__mark ldc-price__box ldp-elrow2__mark--derived" aria-hidden="true"></span>' +
             '<span class="ldp-elrow2__n ldc-price__optname">' + nf + '\u00D7 ' + esc(r.label) + '</span>' +
             '<span class="ldp-elrow2__r ldc-price__optfig">' + money(elRate(r) * nf) + '</span></span>';
        return;
      }
      var on = elementOn(r.id);
      var rate = elRateText(r);
      var norule = (!rate && ownerTier)
        ? '<em class="ldp-el__norule">no price rule set</em>' : '';
      shown++;
      var extra = (!on && shown > 5) ? ' is-extra' : '';
      var dot = elUnderFloorFlag(r, ldpServingsNow())
        ? '<span class="ldp-elrow2__dot" aria-hidden="true"></span>' : '';
      h += '<button type="button" class="ld-chip ldp-elrow2 ldc-price__opt' + (on ? ' is-on' : '') + extra +
           '" data-el="' + r.id + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
           '<span class="ldp-elrow2__mark ldc-price__box" aria-hidden="true">\u2713</span>' +
           '<span class="ldp-elrow2__n ldc-price__optname"><span class="ldp-elrow2__nm">' + esc(r.label) + norule + '</span>' + dot + '</span>' +
           '<span class="ldp-elrow2__r ldc-price__optfig">' + rate + '</span></button>';
    });
    h += '</div>';
    /* r211 correction 7: the fold and the add link are the section's one
       action row - the add link was a bare text link stranded mid-page. */
    h += '<div class="ldp-elactions">' +
      '<button type="button" class="ldc-price__more" id="ldpElMore" hidden></button>' +
      '<span class="ldp-elactions__add"></span></div>';
    /* r48: the band select exists in the SCOPED view too now — the Planner
       form dropped its band chips, so this is the one place left to say how
       many sugar flowers, and it writes b.band (the Planner engine sizes
       its flower sessions from that). */
    if (elementOn('flowers')) {
      var cur = flowerScale();
      h += '<div class="ldp-el__scalewrap">' +
        '<label class="ld-field__label" for="ldpElScale">How many sugar flowers?</label>' +
        '<select id="ldpElScale" class="ldp-el__scale">' +
        '<option value="few"' + (cur === 'few' ? ' selected' : '') + '>A few statement blooms</option>' +
        '<option value="bouquet"' + (cur === 'bouquet' ? ' selected' : '') + '>A bouquet</option>' +
        '<option value="cascade"' + (cur === 'cascade' ? ' selected' : '') + '>A full cascade</option>' +
        '</select></div>';
    }
    return h;
  }
  function draw() {
    if (quoteBooking) {
      box.innerHTML = chipsHTML('Tap what\u2019s on this cake.');
      wireElMore(box);
    } else {
      /* unscoped: local chips, session-only, clearly not file-backed */
      var html2 = '<p class="ldp-sub ldp-el__none">Tap what\u2019s on this cake. These picks live only in this session.</p><div class="ld-chips ldp-el__chips ldc-price__opts">';
      var shown2 = 0;
      elRules().forEach(function (r) {
        /* r60 (gap left by r42): unscoped there is no cake file, so there
           can be no faux tiers — the derived row simply doesn't exist here.
           It used to render as a tickable chip that could never price. */
        if (r.id === 'faux') return;
        shown2++;
        var dot2 = elUnderFloorFlag(r, ldpServingsNow())
          ? '<span class="ldp-elrow2__dot" aria-hidden="true"></span>' : '';
        html2 += '<button type="button" class="ld-chip ldp-elrow2 ldc-price__opt' + (localElements[r.id] ? ' is-on' : '') + ((!localElements[r.id] && shown2 > 5) ? ' is-extra' : '') + '" data-el="' + r.id + '" aria-pressed="' + (localElements[r.id] ? 'true' : 'false') + '">' +
          '<span class="ldp-elrow2__mark ldc-price__box" aria-hidden="true">\u2713</span>' +
          '<span class="ldp-elrow2__n ldc-price__optname"><span class="ldp-elrow2__nm">' + esc(r.label) + '</span>' + dot2 + '</span>' +
          '<span class="ldp-elrow2__r ldc-price__optfig">' + elRateText(r) + '</span></button>';
      });
      html2 += '</div>';
      /* r211 correction 7: the same action row the scoped path builds -
         the fold and the add link paired, not two stray links */
      html2 += '<div class="ldp-elactions">' +
        '<button type="button" class="ldc-price__more" id="ldpElMore" hidden></button>' +
        '<span class="ldp-elactions__add"></span></div>';
      html2 += '<div class="ldp-el__scalewrap" id="ldpElScaleWrap"' + (localElements.flowers ? '' : ' hidden') + '>' +
        '<label class="ld-field__label" for="ldpElScale">How many sugar flowers?</label>' +
        '<select id="ldpElScale" class="ldp-el__scale">' +
        '<option value="few"' + (localFlowerScale === 'few' ? ' selected' : '') + '>A few statement blooms</option>' +
        '<option value="bouquet"' + (localFlowerScale === 'bouquet' ? ' selected' : '') + '>A bouquet</option>' +
        '<option value="cascade"' + (localFlowerScale === 'cascade' ? ' selected' : '') + '>A full cascade</option>' +
        '</select></div>';
      box.innerHTML = html2;
      wireElMore(box);
    }
    /* one wiring for both states, like the chips below it */
    var sc = box.querySelector('#ldpElScale');
    if (sc) sc.addEventListener('change', function () {
      if (quoteBooking) writeFileField('band', sc.value);
      else localFlowerScale = sc.value;
      recalc();
    });
    /* r9: ONE wiring for both states — scoped writes to the file, loose
       work stays in the session. Previously only the unscoped chips were
       clickable, which is why a file sent you to the Planner to edit. */
    box.querySelectorAll('.ld-chip[data-el]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.getAttribute('data-el');
        var on = chip.getAttribute('aria-pressed') !== 'true';
        if (quoteBooking) writeElementToFile(id, on);
        else localElements[id] = on;
        draw();
        recalc();
        try { window.dispatchEvent(new CustomEvent('layerd:pricing-changed')); } catch (e2) { }
      });
    });
    drawCustomAdder(box);
    /* r211 correction 7: the adder's door becomes the right-hand link of
       the section's action row, paired with "Show N more" - it was a bare
       text link stranded mid-page. */
    (function dockAdder() {
      var slot = box.querySelector('.ldp-elactions__add');
      var door = box.querySelector('.ldp-elcustom__door');
      if (slot && door) slot.appendChild(door);
    })();
  }

  /* ---- r38: "add your own element" (her ask, for unique designs) ----
     A name, an amount, and the one thing that actually matters — whether
     it scales with the cake. The row joins elRules() and is priced by the
     same resolver as every studio element.
     r52 (Mariya): free sees and USES the studio elements at studio prices;
     naming your own price is the Pro line — same rule as the r18 rate
     editor. A free visitor sees a quiet locked hint instead of the door. */
  function drawCustomAdder(box) {
    if (!ldpIsPro()) {
      var lockRow = document.createElement('p');
      lockRow.className = 'ldp-elrates__lock';
      lockRow.textContent = 'Add your own elements at your own prices, part of LAYER’D Toolkit Pro.';
      box.appendChild(lockRow);
      return;
    }
    var mine = readCustomEls();
    var wrap = document.createElement('div');
    wrap.className = 'ldp-elcustom';
    var rows = '';
    mine.forEach(function (r) {
      rows += '<div class="ldp-elcustom__row"><span class="ldp-elcustom__n">' + esc(r.label) + '</span>' +
        '<span class="ldp-elcustom__a">' + (r.kind === 'perServing'
          /* r197: formatMoney carries the currency; the old '$' here was
             the one place a per-serving element disagreed with its own
             total two lines down. */
          ? formatMoney(+r.amount) + ' /sv' : formatMoney(+r.amount)) + '</span>' +
        '<button type="button" class="ldp-elcustom__del" data-del="' + esc(r.id) + '" aria-label="Remove ' + esc(r.label) + '">remove</button></div>';
    });
    wrap.innerHTML = rows +
      '<details class="ldp-elcustom__door"><summary>Add an element</summary>' +
      '<div class="ldp-elcustom__form">' +
      '<input type="text" class="ldp-elcustom__name" maxlength="40" placeholder="What is it? e.g. Gold leaf" aria-label="Element name">' +
      '<span class="ldp-elcustom__pre">' + currencySymbol() + '</span>' +   /* r197 */
      '<input type="number" class="ldp-elcustom__amt" min="0" step="1" placeholder="0" aria-label="Amount">' +
      '<button type="button" class="ld-btn ld-btn--secondary ldp-elcustom__add">Add</button>' +
      '<p class="ldp-hint ldp-elcustom__hint">A flat fee added to the quote.</p>' +
      '</div></details>';
    box.appendChild(wrap);

    wrap.querySelectorAll('[data-del]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-del');
        writeCustomEls(readCustomEls().filter(function (r) { return r.id !== id; }));
        if (quoteBooking) writeElementToFile(id, false); else delete localElements[id];
        draw(); recalc();
      });
    });
    /* r223 (Mariya): "unable to add an element". dockAdder() below moves the
       whole .ldp-elcustom__door (name + amount + Add) OUT of `wrap` into the
       action row, so the old handler's wrap.querySelector() found nothing and
       the add silently failed. Capture the field elements themselves - they
       travel with the door, so the references stay valid wherever it's docked.
       Also: a custom element is always a FLAT fee now (she dropped the
       flat/per-serving choice to keep it simple). */
    var elDoor = wrap.querySelector('.ldp-elcustom__door');
    var elNameEl = elDoor && elDoor.querySelector('.ldp-elcustom__name');
    var elAmtEl = elDoor && elDoor.querySelector('.ldp-elcustom__amt');
    var addBtn = elDoor && elDoor.querySelector('.ldp-elcustom__add');
    if (addBtn) addBtn.addEventListener('click', function () {
      var nm = (elNameEl.value || '').trim();
      var amt = parseFloat(elAmtEl.value);
      if (!nm || isNaN(amt) || amt < 0) return;
      var id = 'custom:' + nm.toLowerCase().replace(/[^a-z0-9]+/g, '-') + ':' + Date.now().toString(36);
      var list = readCustomEls().slice();
      list.push({ id: id, label: nm, kind: 'flat', amount: amt, custom: true });
      writeCustomEls(list);
      /* added means it is ON this cake - that is why she added it */
      if (quoteBooking) writeElementToFile(id, true); else localElements[id] = true;
      draw(); recalc();
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* the hidden Calculate button is the engine's entry point (4g.6) */
  function recalc() {
    var b = document.getElementById('ldpCalcBtn');
    if (b) b.click();
  }
  /* r207: "Show N more" - the eleven elements cost a screen and a half of
     height, and five is enough to show what the list is. Expanded state
     lives for the life of the page: re-collapsing under her while she taps
     would be worse than the height. */
  var elMoreOpen = false;
  function wireElMore(box) {
    var wrap = box.querySelector('.ldc-price__opts');
    var btn = box.querySelector('#ldpElMore');
    if (!wrap || !btn) return;
    var hidden = wrap.querySelectorAll('.is-extra').length;
    if (elMoreOpen) wrap.classList.add('is-expanded');
    if (!hidden) { btn.hidden = true; return; }
    btn.hidden = false;
    btn.textContent = elMoreOpen ? 'Show fewer' : 'Show ' + hidden + ' more';
    btn.addEventListener('click', function () {
      elMoreOpen = !elMoreOpen;
      wrap.classList.toggle('is-expanded', elMoreOpen);
      btn.textContent = elMoreOpen ? 'Show fewer' : 'Show ' + hidden + ' more';
    });
  }
  draw();
})();

/* ---- D3.2: the band derives from the file's covering when scoped -----
   Pre-selected only; any manual tap wins and is never re-derived. */
(function deriveBand() {
  if (!quoteBooking || quoteBooking.cover !== 'fondant') return;
  /* deferred a tick: the band buttons' handlers attach later in this
     file - clicking before they exist updated the rate path but left
     the wrong card lit */
  setTimeout(function () { deriveNow(); }, 0);
  function deriveNow() {
  var btn = document.querySelector('.ldp-complexity-btn[data-complexity="fondant"]');
  if (!btn || btn.classList.contains('is-active')) return;
  btn.click();
  var note = document.createElement('p');
  note.className = 'ldp-hint ldp-el__derived';
  note.textContent = 'Suggested from this cake\u2019s covering. Tap another band to override.';
  var grid = document.querySelector('.ldp-complexity-grid');
  if (grid && grid.parentNode) grid.parentNode.insertBefore(note, grid.nextSibling);
  }
})();
function structureUrl() {
  var tabs = document.querySelectorAll('.learn-subnav__tab');
  for (var i = 0; i < tabs.length; i++) {
    var h = tabs[i].getAttribute('href') || '';
    if (/structure/i.test(h)) return h;
  }
  return '/pages/structure';
}
function todayISO() {
  var d = new Date();
  function p(n) { return (n < 10 ? '0' : '') + n; }
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
}
function gaTier() {
  var host = document.querySelector('[data-lh-tier]');
  var t = host && host.getAttribute('data-lh-tier');
  return (t === 'free' || t === 'premium' || t === 'visitor') ? t : 'visitor';
}
function pgaCta(type) {
  try { if (window.lhTrack) window.lhTrack('learn_hub_cta_clicked', { tool_name: 'pricing', cta_type: type, user_tier: gaTier() }); } catch (e) { }
}

/* ---------- step 01: servings ---------- */

var smodeBtns = root.querySelectorAll('.ldp-mode-btn');
var servingsPanel = document.getElementById('ldpServingsPanel');
var tiersPanel = document.getElementById('ldpTiersPanel');
smodeBtns.forEach(function (btn) {
  btn.addEventListener('click', function () {
    smodeBtns.forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-selected', 'true');
    state.servingsMode = btn.getAttribute('data-smode');
    var isServings = state.servingsMode === 'servings';
    servingsPanel.hidden = !isServings;
    tiersPanel.hidden = isServings;
  });
});

/* ---------- delivery flat/distance toggle (defensive copy) ----------
   The premium module wires this too, but its all-or-nothing boot means
   ANY unrelated exception (or a stale asset) used to leave BOTH field
   sets visible — Mariya hit exactly that on live (2026-07-09). Pure UI
   plumbing belongs in the always-running bundle; every element is
   null-guarded because these fields exist only in the premium branch. */
(function deliveryModeToggle() {
  var flatFields = document.getElementById('ldpDeliveryFlatFields');
  var distFields = document.getElementById('ldpDeliveryDistanceFields');
  var btns = root.querySelectorAll('[data-delivery-mode]');
  if (!flatFields || !distFields || !btns.length) return;
  function apply(mode) {
    flatFields.hidden = mode !== 'flat';
    distFields.hidden = mode !== 'distance';
    /* light the whole option CARD, not just the head (2026-07-09) */
    btns.forEach(function (b) {
      var card = b.closest('.ldp-delivopt');
      if (card) card.classList.toggle('is-active', b.getAttribute('data-delivery-mode') === mode);
    });
  }
  var initial = 'flat';
  btns.forEach(function (b) { if (b.classList.contains('is-active')) initial = b.getAttribute('data-delivery-mode'); });
  apply(initial);
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      apply(btn.getAttribute('data-delivery-mode'));
    });
  });
})();

var occasionSeg = tiersPanel.querySelector('.ldp-segmented');
/* r151 (Mariya: Serving said 26 servings, Pricing said 28 for the same
   5" + 7" party cake). state.occasion was hardcoded 'wedding' and nothing
   reconciled it with the file, so a party cake was priced at wedding
   counts - round 7" is 16 party vs 18 wedding, and that 2-serving lie
   flowed into every number on the page. The pills are now a VIEW of the
   file's occasion, in both directions. */
function ldpPaintOccasion(occ) {
  /* r153: EVERY occasion pill on the page - the legacy pair and the drawn
     editor's toggle - so the two controls can never disagree visually */
  document.querySelectorAll('.ldp-seg-btn[data-occasion]').forEach(function (b) {
    var on = b.getAttribute('data-occasion') === occ;
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  state.occasion = occ;
}
/* r153: the drawn editor lives in a SEPARATE top-level IIFE - `state` is
   not in its scope (that reference crashed the whole editor module on
   boot). The engine exports a getter instead, same pattern as
   window.LAYERD.pricingElements. */
window.LAYERD = window.LAYERD || {};
window.LAYERD.pricingOccasion = { get: function () { return state.occasion; } };
function ldpOccasionQuoteRefresh() {
  var res = document.getElementById('ldpResults');
  var btn = document.getElementById('ldpCalcBtn');
  if (res && !res.hidden && btn) btn.click();
}
/* r153: the editor's toggle (and any future occasion pill outside the
   legacy pair) - one delegated wire: paint, write the file, refresh the
   quote. The legacy pair keeps its own direct listeners below. */
document.addEventListener('click', function (ev) {
  var t = ev.target.closest ? ev.target.closest('.ldp-seg-btn[data-occasion]') : null;
  if (!t || (occasionSeg && occasionSeg.contains(t))) return;
  var occ = t.getAttribute('data-occasion');
  ldpPaintOccasion(occ);
  try {
    if (window.LdCakeFile && window.LdCakeFile.writeOccasion) {
      window.LdCakeFile.writeOccasion(occ, 'pricing');
    }
  } catch (e) { }
  ldpOccasionQuoteRefresh();
});
function ldpSyncOccasion() {
  var occ = null;
  try {
    var rc = window.LdCakeFile && window.LdCakeFile.readCake();
    if (rc && rc.meta && rc.meta.occasion) occ = rc.meta.occasion;
  } catch (e) { occ = null; }
  if (occ !== 'party' && occ !== 'wedding') return;
  if (occ === state.occasion) return;
  /* click the real button rather than reaching for recalc(): that lives in
     another scope, and the click path already carries the redraw (the
     delegated .ldp-seg-btn[data-occasion] listener) that the drawn cake
     and every serving count depend on. writeOccasion no-ops on an
     unchanged value, so this cannot loop. */
  var btn = occasionSeg.querySelector('.ldp-seg-btn[data-occasion="' + occ + '"]');
  if (btn) btn.click(); else ldpPaintOccasion(occ);
  /* r153: if she is looking at a quote when another tool moves the
     occasion, the quote follows immediately */
  ldpOccasionQuoteRefresh();
}
occasionSeg.querySelectorAll('.ldp-seg-btn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var occ = btn.getAttribute('data-occasion');
    ldpPaintOccasion(occ);
    /* write back so Serving, the Planner and the file page agree */
    try {
      if (window.LdCakeFile && window.LdCakeFile.writeOccasion) {
        window.LdCakeFile.writeOccasion(occ, 'pricing');
      }
    } catch (e) { }
    /* r153: same behaviour as the editor's toggle - a visible quote
       follows the occasion immediately */
    ldpOccasionQuoteRefresh();
  });
});
ldpSyncOccasion();
/* a file switch (or another tool changing it) repaints the pills */
window.addEventListener('layerd:cakefile', function () { ldpSyncOccasion(); });

var tierRowsEl = document.getElementById('ldpTierRows');
function sizeOptionsFor(shape) {
  return Object.keys(CFG.servings[shape]).map(Number).sort(function (a, b) { return a - b; });
}
/* preset (optional): { d, h, shape } — snaps d to the nearest chart size */
function addTierRow(preset) {
  var row = document.createElement('div');
  row.className = 'ldp-tier-row';
  var shapeSelect = document.createElement('select');
  ['round', 'square', 'heart'].forEach(function (shape) {
    var opt = document.createElement('option');
    opt.value = shape;
    opt.textContent = SHAPE_LABEL[shape];
    shapeSelect.appendChild(opt);
  });
  if (preset && CFG.servings[preset.shape]) shapeSelect.value = preset.shape;
  var sizeSelect = document.createElement('select');
  function populateSizes() {
    var shape = shapeSelect.value;
    sizeSelect.innerHTML = '';
    sizeOptionsFor(shape).forEach(function (size) {
      var opt = document.createElement('option');
      opt.value = size;
      opt.textContent = sizeLabel(size);
      sizeSelect.appendChild(opt);
    });
  }
  populateSizes();
  if (preset && preset.d) {
    var sizes = sizeOptionsFor(shapeSelect.value), best = sizes[0];
    sizes.forEach(function (s) { if (Math.abs(s - preset.d) < Math.abs(best - preset.d)) best = s; });
    sizeSelect.value = String(best);
  }
  shapeSelect.addEventListener('change', populateSizes);
  var heightSelect = document.createElement('select');
  /* r221 (Mariya): a 3" tier - two layers - alongside the taller builds.
     Servings scale with height on the Wilton chart (h / 4), so a 3" cake
     is 3/4 of the 4" count; 4" stays the default. */
  [3, 4, 5, 6, 7, 8].forEach(function (h) {
    var opt = document.createElement('option');
    opt.value = h;
    opt.textContent = sizeLabel(h) + ' tall';
    heightSelect.appendChild(opt);
  });
  heightSelect.value = '4';
  if (preset && preset.h) heightSelect.value = String(Math.max(3, Math.min(8, Math.round(preset.h))));
  var removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'ldp-tier-remove';
  removeBtn.innerHTML = '×';
  removeBtn.setAttribute('aria-label', 'Remove tier');
  removeBtn.addEventListener('click', function () { row.remove(); renumberTierRows(); });
  /* round 29: a bare serif tier number in the leading gutter, matching
     Serving / Batch Math (display only; the calc reads selects by tag) */
  var num = document.createElement('span');
  num.className = 'ldp-tier-num';
  num.setAttribute('aria-hidden', 'true');
  row.appendChild(num);
  row.appendChild(shapeSelect);
  row.appendChild(sizeSelect);
  row.appendChild(heightSelect);
  row.appendChild(removeBtn);
  tierRowsEl.appendChild(row);
  renumberTierRows();
}
function renumberTierRows() {
  var rows = tierRowsEl.querySelectorAll('.ldp-tier-row');
  Array.prototype.forEach.call(rows, function (r, i) {
    var n = r.querySelector('.ldp-tier-num');
    if (n) n.textContent = i + 1;
  });
}
document.getElementById('ldpAddTierBtn').addEventListener('click', function () { addTierRow(); });
addTierRow();

/* Toggle rebuild: re-label the selects IN PLACE - option values stay
   inches, so the current selections, the chart lookup and the shared
   cake are untouched; only the visible text flips. */
function relabelTierRows() {
  tierRowsEl.querySelectorAll('.ldp-tier-row').forEach(function (row) {
    var s = row.querySelectorAll('select');
    Array.prototype.forEach.call(s[1].options, function (opt) {
      opt.textContent = sizeLabel(parseInt(opt.value, 10));
    });
    Array.prototype.forEach.call(s[2].options, function (opt) {
      opt.textContent = sizeLabel(parseInt(opt.value, 10)) + ' tall';
    });
  });
}
unitListeners.push(relabelTierRows);

/* The in/cm pill, at the top of the tiers panel - the only place the
   tool shows pan sizes. */
(function unitsToggle() {
  var box = document.createElement('span');
  box.className = 'lrn-units';
  box.setAttribute('role', 'group');
  box.setAttribute('aria-label', 'Pan size units');
  [['in', 'inches'], ['cm', 'cm']].forEach(function (u) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lrn-units__btn' + (unitPref() === u[0] ? ' is-active' : '');
    b.textContent = u[1];
    b.addEventListener('click', function () {
      try { localStorage.setItem(UNITS_KEY, u[0]); } catch (e) { /* private mode */ }
      Array.prototype.forEach.call(box.children, function (c) { c.classList.remove('is-active'); });
      b.classList.add('is-active');
      unitListeners.forEach(function (fn) { fn(); });
    });
    box.appendChild(b);
  });
  var wrap = document.createElement('div');
  wrap.className = 'ldp-units';
  wrap.appendChild(box);
  tierRowsEl.parentNode.insertBefore(wrap, tierRowsEl);
})();

/* round 29: the column labels ONCE, above the rows (matches Serving /
   Batch Math). Inserted AFTER the units pill so it seats directly on
   top of the tier rows, with the pill above it. */
(function tierColsHeader() {
  var cols = document.createElement('div');
  cols.className = 'ldp-yc__cols';
  cols.setAttribute('aria-hidden', 'true');
  ['Shape', 'Size', 'Height'].forEach(function (t) {
    var s = document.createElement('span');
    s.className = 'ldp-yc__col';
    s.textContent = t;
    cols.appendChild(s);
  });
  tierRowsEl.parentNode.insertBefore(cols, tierRowsEl);
})();

/* ---------- the shared cake (layerd-learn-tiers) ----------
   Serving, Structure and Batch Math write/read the same key, so a cake
   planned anywhere in the suite can be priced without retyping it.
   Convenience only — never an access decision. */
var TIERS_KEY = 'layerd-learn-tiers';
/* CONTRACT v2 (2026-07-09): stamped { tiers, at, from } in BOTH
   localStorage (cross-tab, survives overnight) and sessionStorage
   (legacy readers during the staggered deploy); readers adopt the
   NEWEST stamp — the latest edit anywhere in the suite wins. */
function readSharedCake() {
  var best = null;
  [localStorage, sessionStorage].forEach(function (store) {
    try {
      var v = JSON.parse(store.getItem(TIERS_KEY));
      if (v && v.tiers && v.tiers.length && (!best || (v.at || 1) > (best.at || 1))) best = v;
    } catch (e) { /* private mode / corrupt */ }
  });
  return best ? best.tiers : null;
}
function writeSharedCake() {
  /* Toolkit Fix 01: while a client file is active the booking record is the
     source of truth - quoting never rewrites the anonymous scratch slot */
  if (quoteBooking) return;
  var tiers = [];
  tierRowsEl.querySelectorAll('.ldp-tier-row').forEach(function (row) {
    var s = row.querySelectorAll('select');
    tiers.push({
      d: parseInt(s[1].value, 10),
      h: parseInt(s[2].value, 10) || 4,
      shape: s[0].value === 'square' ? 'square' : s[0].value === 'heart' ? 'heart' : 'round'   // 2026-09-16: heart is supported now
    });
  });
  if (tiers.length) {
    /* tag with the client this cake belongs to (null = unscoped) so it can't
       shadow another client's saved tiers (2026-07-15 shared-cake fix). */
    var payload = JSON.stringify({ tiers: tiers, at: Date.now(), from: 'pricing', bookingId: quoteBooking ? quoteBooking.id : null });
    try { localStorage.setItem(TIERS_KEY, payload); } catch (e) { }
    try { sessionStorage.setItem(TIERS_KEY, payload); } catch (e) { }
  }
}
/* the raw shared-cake object (with its bookingId tag) + a client's SAVED
   tiers, for booking-aware seeding (2026-07-15 fix). */
function readSharedRawP() {
  var best = null;
  [localStorage, sessionStorage].forEach(function (store) {
    try { var v = JSON.parse(store.getItem(TIERS_KEY)); if (v && v.tiers && v.tiers.length && (!best || (v.at || 1) > (best.at || 1))) best = v; } catch (e) { }
  });
  return best;
}
function pricingTiersFromBooking(b) {
  /* sizes derive EXACTLY like the Planner's tierSpecOf: explicit spec entries
     win, missing ones pad from the same presets — so Pricing quotes the sizes
     the Planner shows even for files without an explicit tierSpec. */
  var BP = { 1: [8], 2: [8, 6], 3: [10, 8, 6], 4: [12, 10, 8, 6], 5: [12, 10, 8, 6, 4], 6: [14, 12, 10, 8, 6, 4] };
  var spec = Array.isArray(b.tierSpec) ? b.tierSpec : [];
  var n = Math.max(1, +b.tiers || spec.length || 2);
  var preset = BP[n] || BP[6];
  var h = b.tall ? 6 : 4;
  var rows = [];
  for (var i = 0; i < n; i++) { var s = spec[i] || {}; rows.push({ d: +s.d || preset[i] || 6, h: h, shape: 'round' }); }
  return rows.sort(function (a, c) { return (c.d || 0) - (a.d || 0); });
}
/* r146 (Mariya: "let's just fully remove it ... It should auto-translate
   over for client files too"). The "Use my cake from the other Toolkit
   tools" button is retired. It rebuilt the tier rows, so in "just the
   math" it had nothing to act on, and on a client file quotingBanner
   below already seeds those tiers on load - it offered to do something
   that had happened a moment earlier. writeSharedCake() is untouched:
   Pricing still publishes its cake TO the other tools. */

/* r149 (Mariya: "the top client chip states a different size than what's
   showing in pricing"). Not a cache: unscoped Pricing WRITES every edit
   to the shared slot the chip reads, but never restored from it at boot -
   the editor woke on template defaults while the chip described the
   suite's newest cake. This is the r146 button, made automatic: the
   shared slot was already this page's persistence, now it reads it back.
   Scoped pages skip it - the booking record is the source of truth. */
(function seedFromSharedCake() {
  if (quoteBooking) return;
  var tiers = readSharedCake();
  if (!tiers || !tiers.length) return;
  tierRowsEl.innerHTML = '';
  tiers.forEach(function (t) { addTierRow(t); });
})();

/* When we arrived from a client file, fill the tiers from the cake the
   Planner just seeded — the baker prices the right cake without a click.
   r5 (2026-07-30): the "Quoting for X" pill is RETIRED. It named the file a
   second time (the shared bar above already does), and it was inserted at
   root.firstChild — which on this template is the subnav section, so it
   floated above the tab bar. One bar, one name, same as every other tool. */
(function quotingBanner() {
  if (!quoteBooking) return;
  /* pre-fill the tiers (Toolkit Fix 01): the booking record is the source
     of truth. A cake explicitly set on the file seeds the quote; a file
     whose cake was never set gets the honest §3.4 empty-state instead of
     preset placeholders being priced as client data. */
  var seeded = null;
  if (window.LdCakeFile) {
    var rcp = window.LdCakeFile.readCake();
    if (rcp.source === 'booking') seeded = rcp.tiers;
    else {
      var pnm = (quoteBooking.name || '').trim() || 'this file';
      var pcard = document.createElement('div');
      pcard.className = 'ld-callout ld-callout--check ldp-fileempty';
      pcard.innerHTML = '<span class="ld-callout__label">No tiers on ' + pnm.replace(/</g, '&lt;') + '’s file yet</span>' +
        'Set the cake’s tiers first, then quote it: <a href="/pages/serving-size-calculator">size them in Serving →</a>';
      root.insertBefore(pcard, root.firstChild.nextSibling);
    }
  } else {
    seeded = pricingTiersFromBooking(quoteBooking);
  }
  if (seeded && seeded.length) {
    tierRowsEl.innerHTML = '';
    seeded.forEach(function (t) { addTierRow(t); });
    var tiersModeBtn = root.querySelector('.ldp-mode-btn[data-smode="tiers"]');
    if (tiersModeBtn && state.servingsMode !== 'tiers') tiersModeBtn.click();
  }
  pgaCta('quote_opened');
})();

/* r5 (2026-07-30): the standalone client <select> is RETIRED here and in
   every other tool. The shared bar in the template owns the file list, and
   it only appears when you tap "change" — Mariya: "I'm confused why there's
   suddenly a dropdown for client file with a progress dots." */

/* Tier count is only known in tiers mode; 0 = unknown (typed servings). */
function getTierCount() {
  if (state.servingsMode !== 'tiers') return 0;
  return tierRowsEl.querySelectorAll('.ldp-tier-row').length;
}

function getTotalServings() {
  if (state.servingsMode === 'servings') {
    var n = parseInt(document.getElementById('ldpServingsCount').value, 10);
    return isNaN(n) ? 0 : n;
  }
  var rows = tierRowsEl.querySelectorAll('.ldp-tier-row');
  var total = 0;
  rows.forEach(function (row) {
    var selects = row.querySelectorAll('select');
    // Standardized 4"-tall serving via cakeCore, the one shared owner (SPINE
    // r229): the chart numbers ARE the 4" count; taller tiers cut into
    // proportionally more slices of the same size.
    var h = parseInt(selects[2].value, 10) || 4;
    total += ldpServingsFor(selects[0].value, parseInt(selects[1].value, 10), state.occasion, h);
  });
  return total;
}

/* ---------- r212: the cake this page is quoting, for the cost door ----------
   Mariya (2026-09-03): "the tool should immediately estimate how many
   batches of each recipe will be needed to make that exact cake sizing
   ... a cake for 56 guests as needing only one batch of each recipe is
   not true." The door only ever sized from a CLIENT FILE; on this page
   with no file it left every recipe at one batch and let her type the
   servings, which is how 63 servings sat above one batch each.
   ONE answer to "what cake is this": the tier rows when she built a
   stack, and when she only typed a count, the smallest standard round
   stack that seats it - said out loud as an estimate, never silently. */
window.LAYERD = window.LAYERD || {};
window.LAYERD.pricingCake = (function () {
  function layersFor(h) {
    try { if (window.LdCakeFile && window.LdCakeFile.standardLayers) return window.LdCakeFile.standardLayers(h); } catch (e) { }
    return Math.max(1, Math.round(+h || 4) - 1);
  }
  function fromRows() {
    var out = [];
    if (!tierRowsEl) return out;
    tierRowsEl.querySelectorAll('.ldp-tier-row').forEach(function (row) {
      var s = row.querySelectorAll('select');
      if (s.length < 3) return;
      var h = parseInt(s[2].value, 10) || 4;
      out.push({ d: parseInt(s[1].value, 10) || 6, h: h,
        shape: s[0].value === 'square' ? 'square' : s[0].value === 'heart' ? 'heart' : 'round',
        layers: layersFor(h), flavour: '', faux: false });
    });
    return out;
  }
  /* r218 (Mariya): the cake's WEDDING-serving count, used as the fixed
     basis the ingredient cost is anchored to. The tiers come from the
     builder rows when unscoped, from the client file when scoped. */
  function currentTiers() {
    var t = fromRows();
    if (t.length) return t;
    try {
      var rc = window.LdCakeFile && window.LdCakeFile.readCake && window.LdCakeFile.readCake();
      if (rc && rc.tiers && rc.tiers.length) return rc.tiers;
    } catch (e) { }
    return [];
  }
  function servingsOfTiers(tiers, occ) {
    var total = 0;
    (tiers || []).forEach(function (t) {
      if (t.faux) return;
      var shape = t.shape === 'square' ? 'square' : (t.shape === 'heart' ? 'heart' : 'round');
      total += ldpServingsFor(shape, +t.d, occ, +t.h || 4);   /* SPINE r229: one owner */
    });
    return total;
  }
  /* the smallest round stack (2" steps, 4"-tall tiers) whose chart count
     covers N - the same chart and the same 4" rule getTotalServings uses */
  function stackFor(n) {
    var chart = (CFG.servings && CFG.servings.round) || {};
    var occ = state.occasion;
    var sizes = Object.keys(chart).map(Number).filter(function (d) { return d % 2 === 0 && d >= 4 && d <= 16; }).sort(function (a, b) { return a - b; });
    function seats(stack) { var t = 0; stack.forEach(function (d) { t += ldpServingsFor('round', d, occ, 4); }); return t; }   /* SPINE r229: one owner */
    var best = null;
    for (var tiers = 1; tiers <= 5; tiers++) {
      for (var i = 0; i + tiers <= sizes.length; i++) {
        var stack = sizes.slice(i, i + tiers);
        var ok = true;
        for (var k = 1; k < stack.length; k++) if (stack[k] - stack[k - 1] !== 2) ok = false;
        if (!ok) continue;
        var s = seats(stack);
        if (s >= n && (!best || s < best.seats)) best = { stack: stack, seats: s };
      }
    }
    if (!best) return [];
    return best.stack.slice().reverse().map(function (d) {
      return { d: d, h: 4, shape: 'round', layers: layersFor(4), flavour: '', faux: false };
    });
  }
  return {
    mode: function () { return state.servingsMode === 'servings' ? 'servings' : 'tiers'; },
    servings: getTotalServings,
    occasion: function () { return state.occasion; },
    /* r218 (Mariya: quoting the same cake as party (fewer, larger slices)
       should not make it cost less than as wedding). The ingredient cost is
       a property of the CAKE, so it is anchored to this fixed wedding-
       serving basis; switching to party then raises the per-serving cost
       and holds the total, instead of dropping it. In typed-servings mode
       the count is the count - there is no separate wedding basis - so the
       reference equals the live count and nothing is anchored. */
    referenceServings: function () {
      if (state.servingsMode === 'servings') return getTotalServings();
      var w = servingsOfTiers(currentTiers(), 'wedding');
      return w > 0 ? w : getTotalServings();
    },
    /* { tiers, estimated } - estimated is true when the stack was chosen
       from a typed count rather than built */
    read: function () {
      if (state.servingsMode !== 'servings') return { tiers: fromRows(), estimated: false };
      var n = getTotalServings();
      return { tiers: n > 0 ? stackFor(n) : [], estimated: true };
    }
  };
})();

/* ---------- step 02: the base cover (labels are public) ----------
   r38 (2026-08-02): these are BASE COVERS now, not design levels. The
   third band ('Intricate custom') retired because it priced the sugar
   flowers and hand-painting the elements charge for — Mariya: "isn't
   that technically double counting?" */

/* MIGRATION: a file or session saved before r38 can still hold
   complexity 'intricate'. Left alone it falls through to CFG.bands.simple
   (see the || at the band lookup) and would quietly quote a sculpted cake
   at BUTTERCREAM rates — a silent underprice, the worst kind. Map it to
   the ganache & fondant base and tick the labour it used to include. One
   read-time normaliser, so every entry point gets it. */
var LDP_RETIRED_BANDS = { intricate: { band: 'fondant', elements: ['paint'] } };
function ldpMigrateBand(cx) {
  var m = LDP_RETIRED_BANDS[cx];
  if (!m) return cx;
  try {
    m.elements.forEach(function (id) {
      if (quoteBooking) { if (!quoteBooking[id]) writeElementToFile(id, true); }
      else localElements[id] = true;
    });
  } catch (e) { /* the band mapping matters more than the tick */ }
  return m.band;
}

var complexityBtns = root.querySelectorAll('.ldp-complexity-btn');
complexityBtns.forEach(function (btn) {
  btn.addEventListener('click', function () {
    complexityBtns.forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    state.complexity = btn.getAttribute('data-complexity');
  });
});
/* r52: the card's detail slot ships empty from the template (it used to
   duplicate the description on the free tier). The premium bundle writes
   the exact rate into it; here the free tier writes the band's honest
   range, so a visitor sees what each cover costs before picking one. */
if (!ldpIsPro()) {
  complexityBtns.forEach(function (btn) {
    var d = btn.querySelector('.ldp-complexity-detail');
    var band = CFG.bands && CFG.bands[btn.getAttribute('data-complexity')];
    /* r184 (2026-08-29, Mariya): ONE NUMBER, NOT A RANGE. "It should be an
       exact number - let's go with the studio defaults for both." A range
       asked a first-time visitor to pick a number out of a spread before
       she had picked a cover, which is the opposite of what this card is
       for.
       WHICH number: band.lo, which is exactly the $6.25 / $9.50 she named.
       It is deliberately NOT complexity.base ($6.28 / $9.54) - ballpark_bands
       exists so the free tier publishes rounded endpoints and never the
       exact base rate, and lo is already public through Serving's budget
       mode. So this shows a real studio rate without leaking the derivation
       behind it. If the ingredient costs or the margin move, this number
       moves with them on the next build. */
    if (d && band) d.textContent = formatMoney(band.lo) + ' /serving';
  });
}

/* 2026-09-18 (Mariya: "the endless save thing"). A quote's identity for the
   save affordance is its lo/hi/servings — the numbers on screen. Used to make
   the save IDEMPOTENT (a repeat click can't stack an identical quote) and to
   decide, on every recompute, whether the on-screen quote is already saved so
   the confirmation can persist instead of resetting to a fresh Save button. */
function ldpQuoteSig(q) {
  if (!q) return '';
  return [Math.round(+q.lo || 0), Math.round(+q.hi || 0), Math.round(+q.servings || 0)].join('|');
}
function ldpLatestSavedQuoteSig() {
  if (!quoteBooking) return null;
  try {
    var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
    if (!v || !v.bookings) return null;
    for (var i = 0; i < v.bookings.length; i++) {
      if (v.bookings[i].id === quoteBooking.id) {
        var qs = v.bookings[i].quotes || [];
        return qs.length ? ldpQuoteSig(qs[qs.length - 1]) : null;
      }
    }
  } catch (e) { }
  return null;
}

/* ---------- save the quote back onto the client file (§2.5) ----------
   Re-read the live store on save (never clobber a concurrent Planner edit,
   the same discipline Batch Math uses for its batch sheet), append to
   quotes[], and promote Inquiry -> Quoted. Booked / Quoted / Archived files
   keep their status; we only ever ADD a quote, never downgrade. */
function saveQuoteToBooking(rec) {
  try {
    var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
    if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
    var bk = null;
    for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === quoteBooking.id) { bk = v.bookings[i]; break; }
    if (!bk) return null;
    if (!Array.isArray(bk.quotes)) bk.quotes = [];
    /* round 30: stamp WHICH cake this price was quoted for, straight from
       the file's own tiers. If the cake is resized later, the client file
       can say so instead of letting the quote quietly go stale. Older
       quotes carry no stamp, so they never raise a false alarm. */
    try {
      rec.cakeSig = (bk.tierSpec || []).map(function (t) {
        return (+t.d || 0) + '\u2033\u00d7' + (+t.h || 4) + '\u2033';
      }).join(' / ') || null;
    } catch (e) { /* a quote without a stamp simply never warns */ }
    /* idempotent: a repeat save of the SAME quote (same lo/hi/servings) just
       re-confirms - it never stacks a duplicate onto quotes[]. */
    var lastQ = bk.quotes.length ? bk.quotes[bk.quotes.length - 1] : null;
    var isDup = lastQ && ldpQuoteSig(lastQ) === ldpQuoteSig(rec);
    if (!isDup) bk.quotes.push(rec);
    var promoted = false;
    if (bk.status === 'inquiry') { bk.status = 'quoted'; promoted = true; }
    /* nothing changed on a duplicate with an already-Quoted file - skip the
       write + event so a repeat click can't kick off another recompute cycle */
    if (!isDup || promoted) {
      localStorage.setItem(BOOKINGS_KEY, JSON.stringify(v));
      try { window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'pricing' } })); } catch (e) { }
    }
    return { count: bk.quotes.length, promoted: promoted };
  } catch (e) { return null; }
}

/* the "Save quote to [client]" affordance appended under any computed price
   when we're in file-quote mode. `q` = { lo, hi, servings, per }. */
function renderSaveQuote(q) {
  if (!quoteBooking || !resultsEl || resultsEl.hidden) return;
  var name = (quoteBooking.name || '').trim() || 'this file';
  /* When the plum quote panel offers an actions row (the premium
     framework panel, design handoff 2026-07-21), the save button joins
     it as the gold primary; otherwise it appends below the result as
     before (the free ballpark path). */
  var actions = resultsEl.querySelector('.ldp-rt-actions');
  /* 2026-09-06 (Mariya): renderSaveQuote runs on every recompute, and it used
     to APPEND a new save block each time — so a saved confirmation stacked up
     over and over. Clear any prior save block first: only one, ever. */
  Array.prototype.forEach.call(resultsEl.querySelectorAll('.ldp-savequote'), function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
  var wrap = document.createElement('div');
  wrap.className = 'ldp-savequote' + (actions ? ' ldp-savequote--inpanel' : '');
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = actions ? 'ldp-rt-gold ldp-savequote__btn' : 'ld-btn ld-btn--primary ldp-savequote__btn';
  /* r114 (handoff 11b): one label in both paths. The arrow belonged to the
     gold in-panel variant; the handoff's button is a centred uppercase pill
     and an arrow inside centred small-caps reads as a stray glyph. The
     client's NAME stays — the frame's "her file" is mockup copy for a
     value the real page knows. */
  btn.textContent = 'Save quote to ' + name;
  var done = document.createElement('div');
  done.className = 'ldp-savequote__done';
  done.hidden = true;
  /* the "saved" confirmation. Extracted so it shows either on click OR right
     away when the on-screen quote is already the file's latest saved quote -
     the sticky path that survives a recompute rebuilding the results. */
  function showSaved(promoted) {
    btn.hidden = true;
    done.innerHTML = '';
    /* 2026-07-17 (Mariya): saving used to dead-end with a quiet "Back to the
       file" — confusing for someone who has never SEEN the file. The
       confirmation says where the quote went and the next move is a real
       button to the file's Quote section. */
    var ok = document.createElement('span');
    ok.className = 'ldp-savequote__ok';
    ok.textContent = 'Saved ✓. The quote is on ' + name + '’s client file' + (promoted ? ', now marked Quoted' : '');
    var back = document.createElement('a');
    back.className = 'ld-btn ld-btn--primary ldp-savequote__view';
    /* the #quote hash makes the Planner land at the file's Quote section */
    back.href = plannerUrl() + '?file=' + encodeURIComponent(quoteBooking.id) + '#quote';
    back.textContent = 'See it on ' + name + '’s file →';
    done.appendChild(ok);
    done.appendChild(back);
    done.hidden = false;
  }
  btn.addEventListener('click', function () {
    var rec = { lo: q.lo, hi: q.hi, servings: q.servings || 0, per: q.per || null, at: todayISO() };
    /* CO#1 D5: element lines + the band land on the quote version */
    rec.elements = selectedElements(rec.servings);
    rec.complexity = state.complexity;
    /* CO#1 C7: the Margin Check's verdict rides the quote version */
    var pm44 = window.LAYERD && window.LAYERD.premium && window.LAYERD.premium.pricing;
    if (pm44 && pm44.lastMargin) rec.marginCheck = pm44.lastMargin;
    var res = saveQuoteToBooking(rec);
    if (!res) { btn.textContent = 'Couldn’t save, please try again'; return; }
    showSaved(res.promoted);
    pgaCta('quote_saved');
  });
  wrap.appendChild(btn);
  wrap.appendChild(done);
  (actions || resultsEl).appendChild(wrap);
  /* 2026-09-18 (Mariya: "the endless save thing"). A recompute rebuilds the
     results and would reset this to a fresh Save button, so the confirmation
     never stuck and re-clicking piled up duplicate quotes. If the on-screen
     quote is already the file's latest saved quote, show the saved state right
     away so it persists across every recompute. */
  var savedSig = ldpLatestSavedQuoteSig();
  if (savedSig && savedSig === ldpQuoteSig(q)) showSaved(false);
}

/* ---------- calculate ---------- */

function round5(n) { return Math.max(5, Math.round(n / 5) * 5); }

document.getElementById('ldpCalcBtn').addEventListener('click', function () {
  var errorEl = document.getElementById('ldpServingsError');
  errorEl.hidden = true;
  resultsEl.hidden = true;
  var servings = getTotalServings();
  if (!servings || servings <= 0) {
    errorEl.textContent = state.servingsMode === 'servings'
      ? 'Please enter a total servings count greater than 0.'
      : 'Add at least one tier to calculate servings.';
    errorEl.hidden = false;
    return;
  }
  /* SPINE: publish the count THIS quote is computed with, so the premium
     cake rate (derived per serving) reads the real count on the very first
     press. Before this, in tiers mode the servings box is empty and neither
     __ldpFreeQuote nor the results panel exists yet, so ldpServingsNow()
     returned 0 and the first premium quote priced at the studio-typical
     count - the base rate and quote landed wrong until the next recalc. */
  window.__ldpLiveServings = servings;
  if (state.servingsMode === 'tiers') writeSharedCake();

  var P = premium();
  if (P) {
    var pq = P.calculate({
      servings: servings,
      tierCount: getTierCount(),
      formatMoney: formatMoney,
      timesSign: TIMES_SIGN,
      resultsEl: resultsEl,
      leadCard: leadCard
    });
    /* framework quote: one exact number -> lo === hi */
    if (quoteBooking && pq && pq.total != null) {
      renderSaveQuote({ lo: Math.round(pq.total), hi: Math.round(pq.total), servings: pq.servings || servings, per: null });
      /* SPINE r230: charge/sv is the actually-charged cake rate (activeCakeRateFor),
         cost/sv is the cake-only break-even (cakeFloorFor) - the same figures the
         02/03 cards show; the quote is the exact framework total. */
      var _acr = null;
      try { _acr = (window.LDP_COSTFIRST && window.LDP_COSTFIRST.activeCakeRateFor) ? window.LDP_COSTFIRST.activeCakeRateFor(state.complexity) : null; } catch (e) { }
      ldpPersistMoney({ servings: pq.servings || servings, costSv: ldpCakeFloor(state.complexity), chargeSv: _acr, quote: pq.total, occasion: state.occasion });
    }
    return;
  }

  /* Free ballpark: two rounded per-serving endpoints from the island —
     nothing here to reverse-engineer. */
  /* r38: normalise a retired band BEFORE the fallback, so a pre-r38
     'intricate' quote never lands on buttercream by accident */
  state.complexity = ldpMigrateBand(state.complexity);
  var band = CFG.bands[state.complexity] || CFG.bands.simple;
  /* r64 (Mariya, 2026-08-22): the lo–hi RANGE headline retired. Since r38
     the model is base + exact elements, and since r63 lo IS the
     recommended rate — so the only thing the old spread still expressed
     was the market multiplier. Say that instead: ONE anchored number at
     the recommended rates, then the market top named as exactly what it
     is. `lo`/`hi` keep their names because the saved-quote record and the
     client file's Quote row read that shape. */
  /* r147: the visitor's own market scales the anchor. lo stays the
     recommended rate; the band multiplier is now theirs to set. */
  var mkMult = (typeof ldpFreeMkt !== 'undefined' && ldpFreeMkt.mult) || 1;
  var loRate = band.lo * mkMult;
  var loTotal = round5(loRate * servings);
  var hiTotal = round5(band.hi * servings);
  /* CO#1 D1: selected elements ride BOTH figures as their own exact adder -
     zero elements = the anchor is exactly rate × servings */
  var elTotal39 = Math.round(elementsTotal(servings));
  loTotal += elTotal39; hiTotal += elTotal39;

  /* Small cakes: clamp to the order minimum — fixed costs (consult,
     design, baking day) don't shrink with the cake. */
  var minApplied = false;
  if (CFG.orderMin && loTotal < CFG.orderMin) {
    loTotal = CFG.orderMin;
    if (hiTotal < CFG.orderMin) hiTotal = CFG.orderMin;
    minApplied = true;
  }

  /* r147: add-ons ride the total; rush is a % of cake + elements */
  var fa = (typeof ldpFreeAddons === 'function') ? ldpFreeAddons(loTotal) : { total: 0, names: [], any: false };
  var grand = loTotal + Math.round(fa.total);

  var html = '';
  html += '<div class="ld-result ld-result--outcome ldp-result-total">';
  html += '<span class="ldp-big-label">' + (mkMult !== 1
    ? 'At our recommended rates · ' + ldpFreeMkt.label
    : 'At our recommended rates') + '</span>';
  html += '<span class="ldp-big">' + formatMoneyWhole(grand) + '</span>';
  if (fa.any) {
    html += '<div class="ldp-fa-line">includes ' + fa.names.join(', ').toLowerCase() + '</div>';
  }
  if (mkMult === 1 && hiTotal > loTotal) {
    html += '<div class="ldp-marketline">In a high-cost market this same cake runs up to ' +
      formatMoneyWhole(hiTotal) + '<span class="ldp-noprint">. Set <strong>your market</strong> above to price it in.</span></div>';
  }
  html += '<div class="ldp-per-serving">' + formatMoney(loRate) +
          ' per serving for the cake itself' +
          /* r184: the "up to $X in the highest-cost markets" tail is gone with
             the ranges above it - the market multiplier is a free control on
             this page now, so a visitor who wants her metro's number sets it
             in step 03 rather than reading a spread. */
          (mkMult !== 1 ? ' in your market' : ' at our studio rates') +
          '</div>';
  /* 2026-09-11 (Mariya): the floor LEADS. The break-even per serving sits
     right in the quote band next to what you charge, with the alarm state if
     the rate ever dips below it (CLAUDE.md: the "working for free" floor is
     not buried). */
  var floorSv = ldpCakeFloor(state.complexity);
  if (floorSv != null && floorSv > 0) {
    var below = loRate < floorSv;
    html += '<div class="ldp-breakeven' + (below ? ' ldp-breakeven--alarm' : '') + '">' +
      (below
        ? '<strong>&#9888; Below break-even.</strong> The cake costs ' + formatMoney(floorSv) + ' a serving to make. At this rate you are paying to work.'
        : 'Break-even is ' + formatMoney(floorSv) + ' a serving, so this clears the floor by ' + formatMoney(loRate - floorSv) + '.') +
      '</div>';
  }
  /* CO#1 C1: the count's methodology lives in Serving - one attribution line.
     r50: the LINK is the baker's tooling, not the client's — the printed
     quote keeps the servings count and drops the link (ldp-noprint). */
  /* r147: the link goes for the same reason r144 removed it on Pro -
     leaving the page loses the quote */
  html += '<div class="ldp-fromserving">' + servings + ' servings</div>';
  /* r197 (her call, 2026-08-31): "show it, clearly labelled USD".
     These two endpoints are researched from real US and Canadian supplier
     prices - they are a US studio average, not a local market rate. Now
     that the page quotes in any currency, printing them with a euro sign
     would restate a dollar figure as a euro one, which is precisely the
     lie the no-conversion rule exists to prevent. So the free tier keeps
     its whole model - break-even, market bands, add-ons, all of it - and
     the ONE number that came from somewhere else says where.
     Pro is unaffected: those numbers are hers. */
  if (currencyCode() !== 'USD') {
    html += '<div class="ldp-usdnote">Our starting rates are researched in US dollars. ' +
      'Read these as a starting point, then set your own rates in ' +
      '<strong>LAYER’D Toolkit Pro</strong>.</div>';
  }
  html += '</div>';
  if (minApplied) {
    html += '<div class="ld-callout ld-callout--check ldp-floor">Small cake? The range starts at ' + formatMoneyWhole(CFG.orderMin) +
            ' because a custom order carries the same consult, design and baking day whatever its size. Most studios set an order minimum for exactly this reason.</div>';
  }
  /* r64: the "Why a range?" box retired with the range itself — the
     market line under the headline now carries that whole job in one
     sentence (r54's shortening taste, one box shorter again). */
  /* r112 (Mariya, 2026-08-25): the "Most bakers undercharge / Just starting
     out" nudge is RETIRED. Her reasoning: the form is fully customizable to
     the studio's own numbers with LAYER'D defaults underneath, so coaching
     her to price above a figure she set herself is redundant. The order
     minimum note stays - that one explains a number the page imposed. */
  resultsEl.innerHTML = html;
  resultsEl.hidden = false;
  /* S-4: never ask a logged-in member for the email you already have */
  leadCard.hidden = ldpHideLead();
  /* r46: printing is not lead capture — the row shows with the results
     for every tier. (It used to sit inside the card S-4 hides, which
     silently removed printing for members.) */
  var ldpPr = document.getElementById('ldpPrintRow');
  if (ldpPr) ldpPr.hidden = false;
  /* r147: the free tier previews instead of printing */
  var ldpPv = document.getElementById('ldpPreviewRow');
  if (ldpPv) ldpPv.hidden = false;
  if (typeof ldpIsFreePage === 'function' && ldpIsFreePage()) {
    var qlines = [{ t: 'Cake · ' + servings + ' servings × ' + formatMoney(loRate) +
      (minApplied ? ' (order minimum)' : ''), v: formatMoneyWhole(loTotal - elTotal39) }];
    selectedElements(servings).forEach(function (l) {
      qlines.push({ t: l.label, v: formatMoneyWhole(Math.round(l.amount)) });
    });
    fa.lines.forEach(function (l) {
      qlines.push({ t: l.name, v: formatMoneyWhole(Math.round(l.amt)) });
    });
    /* r175: the SAMPLE renders the real sheet, so the model has to speak
       the sheet's language. Every field is a fact this page already
       holds - the r67 rule stands: what we do not know, we omit rather
       than invent. No client name, no event date, no quote number: a
       free visitor has no client file, and inventing one would make the
       sample a lie about what Pro does. The deposit split is the studio
       standard and is labelled as such. */
    var dpNow = new Date();
    var dpMonths = ['January','February','March','April','May','June','July',
      'August','September','October','November','December'];
    var dpIssued = dpNow.getDate() + ' ' + dpMonths[dpNow.getMonth()] + ' ' + dpNow.getFullYear();
    var dpTotal = grand;
    var dpDeposit = Math.round(dpTotal * 0.5);
    /* r207: ONE signal. Every surface that shows a derived price - the
       rate ledger, step one's break-even, the Margin Check - re-renders
       from this, so ticking an element moves them together instead of
       leaving two of the three stale. */
    try { window.dispatchEvent(new CustomEvent('layerd:pricing-changed')); } catch (ePC) { }
    window.__ldpFreeQuote = {
      issued: dpIssued,
      servings: String(servings),
      tiers: (function () {
        var n = document.querySelectorAll('.ldp-tier-row').length;
        var W = ['One','Two','Three','Four','Five','Six'];
        return n > 1 ? (W[n - 1] || n) + ', stacked' : (n === 1 ? 'One' : '');
      })(),
      lines: qlines,
      subtotal: formatMoneyWhole(dpTotal),
      total: formatMoneyWhole(dpTotal),
      depositLabel: 'deposit · 50%',
      deposit: formatMoneyWhole(dpDeposit),
      balance: formatMoneyWhole(dpTotal - dpDeposit),
      balanceWhen: 'Due before delivery.'
    };
    ldpFreeFloorLine(servings, document.querySelectorAll('.ldp-tier-row').length);
  }

  /* file-quote mode: save the ballpark range straight onto the client file */
  if (quoteBooking) {
    renderSaveQuote({ lo: loTotal, hi: hiTotal, servings: servings, per: { lo: band.lo, hi: band.hi } });
    /* SPINE r230: free tier - charge/sv is the anchored recommended cake rate
       (band.lo x the visitor's market), cost/sv the cake-only break-even, the
       quote the ballpark total (grand). */
    ldpPersistMoney({ servings: servings, costSv: ldpCakeFloor(state.complexity), chargeSv: loRate, quote: grand, occasion: state.occasion });
  }
});

/* ---------- lead capture (native Shopify contact form) ---------- */

/* r50: DELEGATED — the premium bundle draws its own Print button inside
   the quote panel (#ldpPrintBtn2, beside Copy quote) and that panel is
   rebuilt by innerHTML on every recalc, which kills node-bound listeners.
   One document listener serves both buttons and survives every rebuild. */
document.addEventListener('click', function (ev) {
  var t = ev.target && ev.target.closest ? ev.target.closest('#ldpPrintBtn, #ldpPrintBtn2') : null;
  /* r148c: the sheet prints from its own document so the browser's
     URL/date footers (margin chrome) have no margins to live in. The
     popup path exists only when the premium bundle loaded; blocked
     popups fall back to printing in place. */
  if (t) {
    if (window.ldqPopupPrint) window.ldqPopupPrint();
    else window.print();
  }
});
/* r52: the lead form is a native CUSTOMER form now (the contact form it
   replaced emailed Mariya a manual "send them their range" request and
   subscribed nobody — the same lie Serving's form told until v3). Tag
   sync mirrors Serving: pricing-calculator always, academy-waitlist when
   ticked. The breakdown-body fill went with the contact form. */
var leadForm = document.getElementById('ldpLeadForm');
if (leadForm) {
  var ldpTagsIn = document.getElementById('ldpTags');
  var ldpWaitIn = document.getElementById('ldpWaitlist');
  function ldpSyncTags() {
    if (!ldpTagsIn) return;
    ldpTagsIn.value = 'pricing-calculator' + (ldpWaitIn && ldpWaitIn.checked ? ',academy-waitlist' : '');
  }
  if (ldpWaitIn) ldpWaitIn.addEventListener('change', ldpSyncTags);
  ldpSyncTags();
  leadForm.addEventListener('submit', function (e) {
    var hp = document.getElementById('ldp-web');
    if (hp && hp.value.trim() !== '') { e.preventDefault(); return false; }
    ldpSyncTags();
  });
}

/* after a successful lead-form post, bring the confirmation into view
   (replaces the old inline script — no JS in .liquid files) */
var sentEl = document.getElementById('ldp-sent');
if (sentEl) ldNav(sentEl, { block: 'center' });

/* ---------- center active Learn tab ---------- */

var srow = root.querySelector('.learn-subnav__row');
if (srow) {
  var sact = srow.querySelector('[aria-current="page"]');
  var smax = srow.scrollWidth - srow.clientWidth;
  if (sact && smax > 0) {
    var sl = sact.getBoundingClientRect().left - srow.getBoundingClientRect().left + srow.scrollLeft;
    var st = sl - (srow.clientWidth - sact.offsetWidth) / 2;
    if (st < 0) st = 0;
    if (st > smax) st = smax;
    srow.scrollLeft = st;
  }
}

/* ============ RESIZE POPUP (2026-09-16, Mariya) ============
   She wanted resizing to be a quick popup that keeps her on the quote,
   so she can compare pricing options without losing her place — and
   without losing the delivery/policy inputs, which live only in memory
   and were wiped by the round-trip to Serving.

   Serving itself can't be framed here — storefront pages send
   X-Frame-Options DENY + CSP frame-ancestors 'none', the wall the studio
   spine hit too — so this opens THIS page's own tier editor
   (#ldpTiersPanel, already the model the engine reads) in a modal instead
   of navigating away. The panel is relocated INTO the modal (still a
   descendant of #ldpPriceCalc, so the capture-phase live recompute in
   initLive still fires) and moved back on close.

   Resizing left Pricing for Serving because this page READ tiers but never
   wrote them (the S-2 note in initLdpServingsSec). That gap is closed here:
   a scoped edit persists to the booking through LdCakeFile.writeCake, so
   the popup saves the real client file, not just the anonymous scratch. */
(function initLdpResizePopup() {
  var panel = document.getElementById('ldpTiersPanel');
  if (!panel || !root || !tierRowsEl) return;   /* soft-fail -> doors keep navigating to Serving */

  var modeToggle = root.querySelector('.ldp-mode-toggle');

  var overlay = document.createElement('div');
  overlay.className = 'ldp-resize-overlay';
  overlay.hidden = true;
  var box = document.createElement('div');
  box.className = 'ldp-resize-box';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Resize this cake');
  var head = document.createElement('div');
  head.className = 'ldp-resize-head';
  var title = document.createElement('h3');
  title.className = 'ldp-resize-title';
  title.textContent = 'Resize this cake';
  var xBtn = document.createElement('button');
  xBtn.type = 'button';
  xBtn.className = 'ldp-resize-x';
  xBtn.setAttribute('aria-label', 'Close');
  xBtn.innerHTML = '&times;';
  head.appendChild(title);
  head.appendChild(xBtn);
  var body = document.createElement('div');
  body.className = 'ldp-resize-body';
  var foot = document.createElement('div');
  foot.className = 'ldp-resize-foot';
  var readout = document.createElement('span');
  readout.className = 'ldp-resize-sv';
  var doneBtn = document.createElement('button');
  doneBtn.type = 'button';
  doneBtn.className = 'ld-btn ldp-resize-done';
  doneBtn.textContent = 'Done';
  foot.appendChild(readout);
  foot.appendChild(doneBtn);
  box.appendChild(head);
  box.appendChild(body);
  box.appendChild(foot);
  overlay.appendChild(box);
  root.appendChild(overlay);                    /* inside #ldpPriceCalc on purpose */

  function isScoped() {
    try { return !!(window.LdCakeFile && window.LdCakeFile.resolveScope && window.LdCakeFile.resolveScope()); }
    catch (e) { return false; }
  }
  function currentTiers() {
    try {
      if (window.LdCakeFile && window.LdCakeFile.readCake) {
        var rc = window.LdCakeFile.readCake();
        if (rc && rc.tiers && rc.tiers.length) return rc.tiers;
      }
    } catch (e) { }
    var sc = readSharedCake();
    return (sc && sc.length) ? sc : null;
  }
  function collect() {
    var out = [];
    tierRowsEl.querySelectorAll('.ldp-tier-row').forEach(function (row) {
      var s = row.querySelectorAll('select');
      if (s.length < 3) return;
      out.push({
        d: parseInt(s[1].value, 10) || 6,
        h: parseInt(s[2].value, 10) || 4,
        shape: s[0].value === 'square' ? 'square' : s[0].value === 'heart' ? 'heart' : 'round'
      });
    });
    return out;
  }
  function svTotal(tiers) {
    var occ = state.occasion || 'wedding';
    return tiers.reduce(function (a, t) { return a + (ldpServingsFor(t.shape, t.d, occ, t.h) || 0); }, 0);
  }
  function sizeString(tiers) {
    return tiers.slice().sort(function (a, b) { return b.d - a.d; })
      .map(function (t) { return sizeLabel(t.d); }).join(' + ');
  }
  /* keep the compact scoped readout (.ldp-tierro) in step with an edit */
  function syncReadout(tiers) {
    var spec = root.querySelector('.ldp-tierro__spec');
    if (spec) spec.textContent = sizeString(tiers) || 'No tiers on this file yet';
  }
  function commit() {
    var tiers = collect();
    if (!tiers.length) return;
    if (isScoped() && window.LdCakeFile && window.LdCakeFile.writeCake) {
      /* persists to the booking + emits 'cake' (the summary/paint listeners refresh) */
      window.LdCakeFile.writeCake(tiers, 'pricing', { occasion: state.occasion });
    } else {
      writeSharedCake();
      try { window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'pricing' } })); } catch (e) { }
    }
    readout.textContent = svTotal(tiers) + ' servings';
    syncReadout(tiers);
    /* the capture-phase listener (initLive) recomputes the on-page quote when a
       result is already showing; nudge it so an unscoped scratch write lands too */
    try {
      var calcBtn = document.getElementById('ldpCalcBtn');
      if (calcBtn && document.querySelector('.ldp-result-total')) calcBtn.click();
    } catch (e2) { }
  }

  var isOpen = false;
  function openModal() {
    if (isOpen) return;
    isOpen = true;
    var t = currentTiers();
    tierRowsEl.innerHTML = '';
    if (t && t.length) t.forEach(function (r) { addTierRow(r); });
    if (!tierRowsEl.querySelector('.ldp-tier-row')) addTierRow();
    body.appendChild(panel);
    panel.hidden = false;
    if (modeToggle) modeToggle.hidden = true;   /* the servings/tiers switch has no place in a resize modal */
    readout.textContent = svTotal(collect()) + ' servings';
    overlay.hidden = false;
    try { document.documentElement.style.overflow = 'hidden'; } catch (e) { }
    var first = panel.querySelector('select');
    if (first) { try { first.focus(); } catch (e2) { } }
  }
  function closeModal() {
    if (!isOpen) return;
    isOpen = false;
    commit();                                    /* final save + recompute */
    overlay.hidden = true;
    try { document.documentElement.style.overflow = ''; } catch (e) { }
    panel.hidden = true;                         /* the panel stays parked in the hidden
                                                    modal - it's still the model the engine
                                                    reads by .ldp-tier-row (location-free),
                                                    and openModal re-seeds it next time */
  }

  panel.addEventListener('change', function (e) {
    if (e.target && e.target.tagName === 'SELECT') commit();
  });
  doneBtn.addEventListener('click', closeModal);
  xBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (!overlay.hidden && (e.key === 'Escape' || e.key === 'Esc')) closeModal();
  });

  /* every "Resize ->" door opens the modal instead of leaving the page.
     Delegated so it survives the summary re-render on each cakefile event. */
  document.addEventListener('click', function (e) {
    var d = e.target && e.target.closest &&
      e.target.closest('.ldp-tierro__edit, .ldp-cakesum__edit, .ldp-serving-door');
    if (!d) return;
    e.preventDefault();
    openModal();
  });
})();
})();

/* ============================================================
   B3.1 (round 47): the section rail + folding cards. Mobile
   arrives folded (servings open, the rest closed); desktop all
   open. A rail tap opens its fold first, then scrolls -
   scroll-margin-top does the offset math. Runs for every tier. */
(function initLdpRail() {
  var nav = document.querySelector('.ldp-jump');
  if (!nav) return;
  var folds = Array.prototype.slice.call(document.querySelectorAll('details[data-ldpacc]'));
  if (!window.matchMedia('(min-width: 900px)').matches) {
    folds.forEach(function (d, i) { d.open = (i === 0); });
  }
  nav.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a || !nav.contains(a)) return;
    var id = (a.getAttribute('href') || '').slice(1);
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var d = target.querySelector('details[data-ldpacc]');
    if (d) d.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var here = nav.querySelector('a.is-here');
    if (here) here.classList.remove('is-here');
    a.classList.add('is-here');
  });
})();

/* Redesign round 4 (2026-07-30): (a) the existing country/currency control
   moves into the header slot - same buttons, same listeners, just a new
   home; (b) the running quote strip mirrors whatever the results panel
   says, so the two can never disagree. */
(function initLdpChrome() {
  var strip = document.getElementById('ldpQuoteStrip');
  var stripTotal = document.getElementById('ldpStripTotal');
  var stripSub = document.getElementById('ldpStripSub');
  var results = document.getElementById('ldpResults');
  if (!strip || !results) return;

  function sync() {
    /* read what the panel already rendered - never a second calculation */
    /* both tiers render the headline into .ldp-big (premium: the suggested
       price; free: the starting range), with the per-serving beside it. */
    var big = results.querySelector('.ldp-big');
    var per = results.querySelector('.ldp-rt-per');
    if (results.hidden || !big) { strip.hidden = true; return; }
    stripTotal.textContent = (big.textContent || '').trim();
    var cur = (document.querySelector('.ldpc') || {}).getAttribute
      ? (document.querySelector('.ldpc').getAttribute('data-currency') || '') : '';
    /* r211 correction 6: the summary's per-serving is the whole quote
       over the servings - the same figure 04 prints - so it carries the
       same label. It differs from 03's cake-only rate on purpose. */
    /* r54 follow-up (Mariya: "why does it say everything in") - the jargon is
       gone; the sub is just the per-serving figure. */
    stripSub.textContent = per
      ? (per.textContent || '').trim() + ' / serving' + (cur ? ' · ' + cur : '')
      : '';
    strip.hidden = false;
  }
  new MutationObserver(sync).observe(results, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  sync();
})();

/* ============================================================
   REDESIGN round 4 (her mockup): the page becomes two columns -
   what you build on the left, what it costs on the right, with
   the quote card sticky so the number is always in view. Done by
   re-parenting after render (the Structure twoCol pattern), so no
   card markup or handler changes. Below 960px it stacks, and the
   order is unchanged: build first, quote second. */
(function initLdpCols() {
  var wrap = document.querySelector('.ldp-wrap');
  var results = document.getElementById('ldpResults');
  if (!wrap || !results || document.querySelector('.ldp-cols')) return;

  var cols = document.createElement('div');
  cols.className = 'ldp-cols';
  var build = document.createElement('div');
  build.className = 'ldp-col ldp-col--build';
  var quote = document.createElement('div');
  quote.className = 'ldp-col ldp-col--quote';
  cols.appendChild(build);
  cols.appendChild(quote);
  /* LIVE BUG (2026-07-30): #ldpResults sits inside the #ldp-quote wrapper,
     so the old `results.parentNode === wrap` test was always false and the
     columns landed at wrap.firstChild - ABOVE the header, which pushed the
     header to the foot of the page. Anchor on the header/strip instead. */
  /* LIVE BUG 2 (found 2026-07-30, r4g verification): the cake bar mounts
     BEFORE this runs and is skipped by the routing below because it spans
     both columns - so inserting the grid straight after the strip pushed
     the bar underneath the entire page. The grid goes after the bar. */
  /* LIVE BUG 4 (found 2026-08-25 building r110): this anchored on whichever
     of the two full-width blocks it found FIRST in the selector list, not in
     the DOM. r108 put the client chip above the quote strip, so the grid
     landed between them and pushed the strip below the whole page — the
     r109 re-parenting hid that. Anchor on whichever comes LAST, so every
     full-width block stays above the columns however they are ordered. */
  var afterEl = wrap.querySelector('.ld-cakechip-row');
  var stripEl = wrap.querySelector('.ldp-strip');
  if (stripEl && (!afterEl || (afterEl.compareDocumentPosition(stripEl) & Node.DOCUMENT_POSITION_FOLLOWING))) afterEl = stripEl;
  if (!afterEl) afterEl = wrap.querySelector('.ldp-head');
  wrap.insertBefore(cols, afterEl ? afterEl.nextSibling : wrap.firstChild);

  /* everything that ASKS goes left; everything that ANSWERS goes right.
     #ldp-quote is the B3.1 wrapper holding the button + the results. The
     lead form and the studio note are neither - they sit full-width under
     both columns, where they don't crowd the quote. */
  var RIGHT = ['ldp-quote'];
  var FOOT = ['ldpLeadCard'];
  var foot = document.createElement('div');
  foot.className = 'ldp-foot';
  var kids = Array.prototype.slice.call(wrap.children);
  kids.forEach(function (el) {
    if (el === cols || el.classList.contains('ldp-strip') || el.tagName === 'SCRIPT') return;
    if (el.classList.contains('ldp-head')) return;
    if (el.classList.contains('ld-cakechip-row')) return;   /* the file bar spans both columns */
    /* LIVE BUG 3 (found 2026-08-04 while building the studio letterhead):
       .ldp-printhead was being swept into the LEFT column, and print hides
       that column — so every quote printed since the two-column layout
       shipped has had NO letterhead at all. The r15 feature was silently
       dead. It belongs to the page, not to a column. */
    if (el.classList.contains('ldp-printhead')) return;
    /* the section rail is retired by this layout - the page is one screen */
    if (el.classList.contains('ldp-jump')) { el.remove(); return; }
    if (FOOT.indexOf(el.id) > -1 || el.classList.contains('ldp-studionote')) { foot.appendChild(el); return; }
    if (RIGHT.indexOf(el.id) > -1 || el.classList.contains('ldp-costplus')) { quote.appendChild(el); return; }
    build.appendChild(el);
  });
  if (foot.children.length) wrap.appendChild(foot);
})();

/* The order minimum, said out loud (2026-07-30). When the floor is what
   sets the price, every other control looks broken - nothing moves. The
   strip now says so, so the page explains itself. */
(function initLdpFloorNote() {
  var results = document.getElementById('ldpResults');
  var sub = document.getElementById('ldpStripSub');
  if (!results || !sub) return;
  new MutationObserver(function () {
    var floored = !!results.querySelector('.ldp-floor');
    sub.classList.toggle('is-floor', floored);
    if (floored && sub.textContent.indexOf('minimum') === -1) {
      /* r110: the free page has no per-serving line, so appending left the
         plum box reading "\u00b7 order minimum applied" \u2014 a separator with
         nothing in front of it. Now that the box leads the page, it starts
         with a word. */
      var had = sub.textContent.trim();
      sub.textContent = (had ? had + ' \u00b7 ' : '') + 'order minimum applied';
    }
  }).observe(results, { childList: true, subtree: true });
})();

/* ============================================================
   REDESIGN round 4, the panels (her photo). Everything here is
   presentation over the SAME controls - the rate input, the
   complexity buttons, the results markup and every handler are
   the originals, just re-homed. No pricing math is touched.
   ============================================================ */
(function initLdpPanels() {
  var root = document.querySelector('.ldpc');
  if (!root) return;

  /* ---------- 1. BASE FINISH: the rate box rides the SELECTED card ----- */
  var grid = document.querySelector('.ldp-complexity-grid');
  var rateField = document.getElementById('ldpBaseRate');
  var rateWrap = rateField && rateField.closest ? rateField.closest('.ldp-field') : null;

  function activeFinishCard() {
    var on = document.querySelector('.ldp-complexity-btn.is-active');
    return on && on.parentNode && on.parentNode.classList.contains('ldp-finish') ? on.parentNode : null;
  }
  /* r137 (Mariya: "it should only be editable if I click it ... I cant
     click it again to close"). r136 left the field open on the selected
     cover, so the page loaded with an input already in her form. It is a
     toggle on the row now, shut on every load. */
  var rateOpen = false;
  function paintRate() {
    if (!rateWrap || !grid) return;
    rateWrap.hidden = !rateOpen;
    var card = activeFinishCard();
    Array.prototype.forEach.call(grid.querySelectorAll('.ldp-finish'), function (c) {
      c.classList.toggle('is-editing', rateOpen && c === card);
    });
  }
  function dockRate() {
    if (!rateWrap) return;
    var card = activeFinishCard();
    if (!card) return;
    if (rateWrap.parentNode !== card) card.appendChild(rateWrap);
    paintRate();
  }
  if (grid) {
    /* the cards are for BOTH tiers — a visitor gets the same three bands,
       just without the rate box (that control is premium and simply isn't
       in their page). Each button gets a card wrapper so the rate row can
       live inside it (an <input> cannot be nested in a <button>). */
    Array.prototype.forEach.call(grid.querySelectorAll('.ldp-complexity-btn'), function (btn) {
      if (btn.parentNode && btn.parentNode.classList.contains('ldp-finish')) return;
      var card = document.createElement('div');
      card.className = 'ldp-finish';
      btn.parentNode.insertBefore(card, btn);
      card.appendChild(btn);
    });
    /* r148: no rate input on this page = free tier. The rows carry a
       marker class so the 'edit' affordance renders as a PRO chip
       instead of a control that does nothing when tapped. */
    if (!rateWrap) grid.classList.add('ldp-coverrows--pro');
    if (rateWrap) {
      rateWrap.classList.add('ldp-finish__rate');
      /* r136: the markup label still said "Plain-version rate", true of
         the old three-card grid and hidden ever since. It is visible in
         the cover row now, so it has to name the row it sits in. */
      var rlab = rateWrap.querySelector('.ld-field__label');
      if (rlab) rlab.textContent = 'your rate for this cover ($ per serving)';
      var hint = document.createElement('p');
      hint.className = 'ldp-finish__hint';
      /* S-7 (2026-08-03): this used to be seeded with the "our suggested
         rate" text, which OVERWROTE what the premium bundle's
         syncFinishHint had already written \u2014 so a saved rate never got to
         say "your saved rate" and the `reset` link never appeared. The
         hint has ONE owner now (syncFinishHint); this only creates the
         empty element for it to fill. */
      rateWrap.appendChild(hint);
      dockRate();
      /* Which row was live BEFORE the bundle's own handler switches
         .is-active - that is what decides toggle vs. switch. Capture
         phase, so it runs first whatever order the listeners bound in. */
      var wasActive = null;
      grid.addEventListener('click', function (ev) {
        var btn = ev.target && ev.target.closest ? ev.target.closest('.ldp-complexity-btn') : null;
        wasActive = btn ? (btn.classList.contains('is-active') ? btn : false) : null;
      }, true);
      grid.addEventListener('click', function (ev) {
        /* a click on the input itself bubbles here too - it must not
           close the box she is typing in */
        var btn = ev.target && ev.target.closest ? ev.target.closest('.ldp-complexity-btn') : null;
        if (!btn) { setTimeout(dockRate, 0); return; }
        if (wasActive === btn) rateOpen = !rateOpen;   /* same row: toggle */
        else rateOpen = false;                          /* other row: just switch */
        setTimeout(dockRate, 0);
      });
    }
  }

  /* ---------- 2. SERVINGS: the figure, in her words ---------- */
  var svCard = document.getElementById('ldp-servings');
  var results = document.getElementById('ldpResults');
  if (svCard && results) {
    var svBlock = document.createElement('div');
    svBlock.className = 'ldp-svblock';
    svBlock.innerHTML = '<span class="ldp-svblock__n"></span>' +
      '<span class="ldp-svblock__k">servings from your cake</span>';
    var body = svCard.querySelector('.ld-collapse__body') || svCard;
    body.insertBefore(svBlock, body.firstChild);
    var svNum = svBlock.querySelector('.ldp-svblock__n');
    new MutationObserver(function () {
      /* the count the calculation actually used - never a second sum */
      var from = results.querySelector('.ldp-fromserving--inline');
      var m = from && /(\d[\d,]*)\s+servings/.exec(from.textContent || '');
      if (m) { svNum.textContent = m[1]; svBlock.classList.add('is-on'); }
    }).observe(results, { childList: true, subtree: true });
  }

  /* ---------- 3. THE QUOTE CARD: two tabs ---------- */
  var quoteCol = document.querySelector('.ldp-col--quote');
  /* the second tab is the Margin check - a premium panel. No panel, no
     tab: a visitor must never see a Pro feature named as if it were on
     their page (the tier rule). */
  /* r115: the margin panel is retired from view (step one owns the costs;
     the check runs silently off its numbers). The card stays in the DOM,
     hidden, because costFromRecipes boots from it - but a hidden panel
     gets no tab. The old marginlink pill self-guards on the tab's absence. */
  var cpEl = document.querySelector('.ldp-costplus');
  var hasMargin = !!(cpEl && !cpEl.hidden);
  if (quoteCol && results && hasMargin) {
    var tabs = document.createElement('div');
    tabs.className = 'ldp-qtabs';
    tabs.setAttribute('role', 'tablist');
    tabs.innerHTML =
      '<button type="button" class="ldp-qtab is-on" data-qtab="quote" role="tab" aria-selected="true">The quote</button>' +
      '<button type="button" class="ldp-qtab" data-qtab="margin" role="tab" aria-selected="false">Margin check</button>';
    quoteCol.insertBefore(tabs, quoteCol.firstChild);

    /* the margin verdict renders inside the results HTML; lift it into its
       own pane after every render so a tab can show one without the other */
    var marginPane = document.createElement('div');
    marginPane.className = 'ldp-qpane ldp-qpane--margin';
    quoteCol.appendChild(marginPane);

    var lifting = false;
    function lift() {
      if (lifting) return;          /* never re-enter from our own writes */
      lifting = true;
      try { liftNow(); } finally { setTimeout(function () { lifting = false; }, 0); }
    }
    function liftNow() {
      var mc = results.querySelector('.ldp-mcheck');
      if (mc) {
        /* r15 (Mariya, 2026-07-31: "there's an endless list of margin check
           messages ... like thirty different boxes"). Exactly that: the
           results panel builds a FRESH verdict on every recalculation, and
           this prepended each new one into the pane without ever removing
           the last, so the pane grew one box per keystroke. Drop the old
           ones - there is only ever one verdict for one quote. */
        var stale = marginPane.querySelectorAll('.ldp-mcheck');
        Array.prototype.forEach.call(stale, function (n) {
          if (n !== mc && n.parentNode) n.parentNode.removeChild(n);
        });
        marginPane.insertBefore(mc, marginPane.firstChild);
      }
      var cp = document.querySelector('.ldp-costplus');
      if (cp && cp.parentNode !== marginPane) marginPane.appendChild(cp);
    }
    /* NO deposit line here: the premium panel already renders one, and
       says it better - "To book: 50% deposit = $468.75 · balance $468.75
       before delivery". Duplicating it was my error (2026-07-30). Check
       what the page already prints before adding a figure. */
    new MutationObserver(lift).observe(results, { childList: true, subtree: true });
    lift();

    tabs.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest('.ldp-qtab') : null;
      if (!b) return;
      var margin = b.getAttribute('data-qtab') === 'margin';
      Array.prototype.forEach.call(tabs.querySelectorAll('.ldp-qtab'), function (x) {
        var on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      quoteCol.classList.toggle('is-margin', margin);
    });
  }
})();

/* ============================================================
   REDESIGN round 4g (2026-07-30) — EXTRACTED from the design
   file (`Toolkit App.dc.html?screen=pricing&client=an`), per
   handoff/FIDELITY.md: the build side is ONE card whose sections
   are separated by hairlines, the market multiplier is a stepper,
   elements read as a single row, and there is no Calculate
   button anywhere — the quote is live.

   Presentation only. Every input id, handler and the whole
   pricing engine are the originals; this file only re-parents
   and re-dresses them.
   ============================================================ */

/* ---------- 4g.1 the ? note (Pricing's copy of the Batch Math
   pattern): long evergreen prose folds behind a small circled
   question mark instead of sitting on screen. ---------- */
function ldpInfoNote(labelText, html) {
  var wrap = document.createElement('span');
  wrap.className = 'ldp-infowrap';
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ldp-info';
  btn.setAttribute('aria-expanded', 'false');
  /* the suite's screen-reader class is learn-visually-hidden (learn-tokens.css).
     Guessing `ld-` left the label VISIBLE inside the 18px button - caught by
     the 375 clip audit, 2026-07-30. */
  btn.innerHTML = '<span class="learn-visually-hidden">' + (labelText || 'More about this') + '</span>';
  var pop = document.createElement('span');
  pop.className = 'ldp-info__pop';
  pop.innerHTML = html;
  wrap.appendChild(btn);
  if (labelText) {
    var lbl = document.createElement('span');
    lbl.className = 'ldp-info__lbl';
    lbl.textContent = labelText;
    wrap.appendChild(lbl);
  }
  wrap.appendChild(pop);
  return wrap;
}
(function initLdpInfo() {
  document.addEventListener('click', function (ev) {
    /* 2026-08-04 (Mariya: "the info icon on the pricing page, when clicked,
       doesn't stay up on the screen to read").

       The note DID open — and then closed itself ~a tick later. Cause: the
       r4g always-live recalculation presses the hidden Calculate button with
       a programmatic `.click()`, that synthetic click bubbles to document,
       and this handler could not tell it from the user clicking somewhere
       else, so it ran the close-everything branch on the note just opened.
       Synthetic clicks are never a user dismissing a popover, so they are
       ignored outright. `isTrusted` is false for any scripted .click(). */
    var btn = ev.target && ev.target.closest ? ev.target.closest('.ldp-info') : null;
    /* only the CLOSE path ignores synthetic clicks: a scripted click that
       landed ON an info button is still a legitimate open (and keeps this
       testable), but a scripted click anywhere else is the recalculation
       firing, not the user dismissing anything. */
    if (!btn && ev.isTrusted === false) return;
    var open = document.querySelectorAll('.ldp-infowrap.is-open');
    Array.prototype.forEach.call(open, function (w) {
      if (btn && w === btn.parentNode) return;
      w.classList.remove('is-open');
      var b = w.querySelector('.ldp-info');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!btn) return;
    ev.preventDefault();
    var w = btn.parentNode;
    var on = !w.classList.contains('is-open');
    w.classList.toggle('is-open', on);
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('.ldp-infowrap.is-open'), function (w) {
      w.classList.remove('is-open');
      var b = w.querySelector('.ldp-info');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* ---------- 4g.2 ONE build card ----------
   The design file's left column is a single card: Servings /
   Base finish / Market / Add-ons stacked behind hairline rules,
   no step numbers and no folds. Live had five separate cards
   each wrapped in a <details>. We unwrap and merge; the bodies,
   ids and handlers move across untouched. */
(function initLdpOneCard() {
  var build = document.querySelector('.ldp-col--build');
  if (!build || build.querySelector('.ldp-buildcard')) return;
  var cards = Array.prototype.slice.call(build.children).filter(function (el) {
    return el.classList && el.classList.contains('ldp-card');
  });
  if (!cards.length) return;

  var one = document.createElement('div');
  one.className = 'ldp-card ldp-buildcard';
  build.insertBefore(one, cards[0]);

  /* r111 (her design 8a move 3 / 9a, 2026-08-25): THE SECTIONS BECOME A
     LEDGER. 4g.2 flattened five cards into one long open card — ~2,500px
     of controls she had to scroll past to reach the quote. Her design puts
     everything except the cake under one "What makes the price" heading, as
     four rows that each say what they add and open in place when tapped.
     Same bodies, same ids, same handlers — only the head changes. */
  /* r114 (design handoff 11b, 2026-08-25): THE LEDGER IS RETIRED.
     r111 folded these four into collapsed rows under "What makes the
     price". The handoff reverses that call in one line — "nothing on this
     page collapses or navigates away to be edited" — and numbers them
     02/03/04 behind step one instead. Emptying this map sends every card
     down the plain-section branch below; initLdpSections then gives the
     four their numeral and gold hairline. The row-building code is left
     in place because a stale cached page must not throw. */
  var LEDGER = {};
  var ledger = null;
  cards.forEach(function (card) {
    var sec = document.createElement('section');
    sec.className = 'ldp-sec';
    /* the id travels with the section: #ldpElementsCard is toggled
       by the elements block, and the ids carry scroll-margin CSS */
    if (card.id) { sec.id = card.id; card.removeAttribute('id'); }
    if (card.hidden) sec.hidden = true;

    var fold = card.querySelector('details[data-ldpacc]');
    var head = card.querySelector('.ldp-heading-sm');
    var led = LEDGER[sec.id];
    var body = card.querySelector('.ld-collapse__body') || card;

    if (led) {
      /* the row: title + what is chosen + what it adds + a chevron */
      sec.classList.add('ldp-led');
      var bodyId = 'ldpLed-' + sec.id;
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'ldp-led__row';
      row.setAttribute('aria-expanded', 'false');
      row.setAttribute('aria-controls', bodyId);
      row.innerHTML =
        '<span class="ldp-led__txt"><span class="ldp-led__k"></span>' +
        '<span class="ldp-led__sub"></span></span>' +
        '<span class="ldp-led__v"></span><span class="ldp-led__u"></span>' +
        '<span class="ldp-led__x" aria-hidden="true">›</span>';
      row.querySelector('.ldp-led__k').textContent = led.k;
      if (head) head.remove();          /* the row IS the heading now */
      sec.appendChild(row);

      var wrap = document.createElement('div');
      wrap.className = 'ldp-led__body';
      wrap.id = bodyId;
      wrap.hidden = true;
      while (body.firstChild) wrap.appendChild(body.firstChild);
      if (fold) fold.remove();
      if (body !== card) {
        while (card.firstChild) {
          var n2 = card.firstChild;
          if (n2.nodeType === 1 && (n2.tagName === 'DETAILS' || n2.classList.contains('ld-collapse'))) { n2.remove(); continue; }
          wrap.appendChild(n2);
        }
      }
      sec.appendChild(wrap);
      row.addEventListener('click', function () {
        var open = wrap.hidden;
        wrap.hidden = !open;
        sec.classList.toggle('is-open', open);
        row.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (!ledger) {
        ledger = document.createElement('div');
        ledger.className = 'ldp-ledger';
        ledger.innerHTML = '<div class="ldp-ledger__head"><h3>What makes the price</h3>' +
          '<span class="ldp-ledger__rule"></span></div>';
        one.appendChild(ledger);
      }
      ledger.appendChild(sec);
      card.remove();
      return;
    }

    if (head) {
      var num = head.querySelector('.ldp-step-num');
      if (num) num.remove();
      var eyebrowRow = document.createElement('div');
      eyebrowRow.className = 'ldp-sec__head';
      eyebrowRow.appendChild(head);
      sec.appendChild(eyebrowRow);
    }
    while (body.firstChild) sec.appendChild(body.firstChild);
    if (fold) fold.remove();
    /* anything that lived outside the fold (the elements box) */
    if (body !== card) {
      while (card.firstChild) {
        var n = card.firstChild;
        if (n.nodeType === 1 && (n.tagName === 'DETAILS' || n.classList.contains('ld-collapse'))) { n.remove(); continue; }
        sec.appendChild(n);
      }
    }
    one.appendChild(sec);
    card.remove();
  });
})();

/* ---------- r111: what each ledger row SAYS ----------
   Every figure here is READ from what the page already rendered — the
   results panel's own itemised lines, the active covering card, the market
   stepper. Nothing on this row is a second calculation; if the panel and
   the row could disagree, the row would be a liability. */
(function initLdpLedgerSync() {
  var results = document.getElementById('ldpResults');
  var ledger = document.querySelector('.ldp-ledger');
  if (!results || !ledger) return;

  var ELEMENT_LABELS = [];
  try {
    var isl = document.getElementById('ldp-config');
    var cfgx = isl ? JSON.parse(isl.textContent) : null;
    ELEMENT_LABELS = ((cfgx && cfgx.elements) || []).map(function (e) { return e.label; });
  } catch (e) { ELEMENT_LABELS = []; }

  function money(txt) {
    var n = parseFloat(String(txt || '').replace(/[^0-9.\-]/g, ''));
    return isNaN(n) ? 0 : n;
  }
  /* r197: one formatter for the whole page. This had its own '$' and
     its own rounding rule, so the ledger could disagree with the quote
     it summarises the moment the currency was anything but USD. */
  function fmt(n) { return (n % 1) ? formatMoney(n) : formatMoneyWhole(n); }
  /* the itemised lines above the subtotal, split into the three buckets the
     ledger names. "Cake" and the per-tier fee are the cake itself; anything
     matching a configured element label is an element; the rest are add-ons */
  function buckets() {
    var out = { cake: [], els: [], adds: [] };
    var lines = [].slice.call(results.querySelectorAll('.ldp-rt-line'));
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      if (l.classList.contains('is-subtotal') || l.classList.contains('is-grand')) break;
      var sp = l.querySelectorAll('span');
      var k = sp[0] ? sp[0].textContent.trim() : '';
      var v = sp[1] ? sp[1].textContent.trim() : '';
      var isEl = ELEMENT_LABELS.some(function (lab) { return lab && k.indexOf(lab) === 0; });
      if (isEl) out.els.push({ k: k, v: v });
      else if (/^cake\b|^tiered construction|^order minimum/i.test(k)) out.cake.push({ k: k, v: v });
      else out.adds.push({ k: k, v: v });
    }
    return out;
  }
  function set(id, sub, val, unit) {
    var sec = document.getElementById(id);
    if (!sec) return;
    var s = sec.querySelector('.ldp-led__sub'), v = sec.querySelector('.ldp-led__v'), u = sec.querySelector('.ldp-led__u');
    if (s) s.textContent = sub || '';
    if (v) v.textContent = val || '';
    if (u) u.textContent = val ? (unit || '') : '';
  }
  function sync() {
    var b = buckets();

    /* BASE COVER — the covering she chose and its per-serving rate, taken
       from the "Cake — N servings × $X" line the panel prints */
    var cover = document.querySelector('.ldp-complexity-btn.is-active .ldp-complexity-title');
    var rate = '';
    b.cake.forEach(function (l) {
      /* r197: match the NUMBER, not a dollar sign. These two scrapes read
         text this page already rendered, so hard-coding the symbol meant
         the ledger silently lost its rate row in every other currency. */
      var m = /×\s*[^\d-]*(-?[\d,]+(?:\.\d+)?)/.exec(l.k);
      if (m) rate = formatMoney(parseFloat(m[1].replace(/,/g, '')));
    });
    if (!rate) {
      var rf = document.getElementById('ldpBaseRate');
      if (rf && rf.value && !isNaN(parseFloat(rf.value))) rate = formatMoney(parseFloat(rf.value));
    }
    if (!rate) {
      /* the FREE page itemises nothing — it prints one sentence, "$6.25 per
         serving recommended for the cake itself". Same number, same source,
         just the other tier's way of saying it. */
      var free = /([\d,]+(?:\.\d+)?)\s*per serving/.exec(results.textContent || '');
      if (free) rate = formatMoney(parseFloat(free[1].replace(/,/g, '')));
    }
    set('ldp-design', cover ? cover.textContent.trim() : 'Not chosen yet', rate, rate ? '/sv' : '');

    /* ELEMENTS — how many are on the cake and what they add together */
    var elTotal = b.els.reduce(function (n, l) { return n + money(l.v); }, 0);
    var scopedEl = false;
    try { scopedEl = !!(window.LdCakeFile && window.LdCakeFile.resolveScope && window.LdCakeFile.resolveScope()); } catch (eS) { }
    set('ldpElementsCard',
      b.els.length ? (b.els.length + (scopedEl ? ' from her file' : ' on the cake')) : 'None yet',
      b.els.length ? '+ ' + fmt(elTotal) : '', '');

    /* YOUR MARKET — the region and its multiplier, as the stepper shows it */
    var mv = document.getElementById('ldpMStepVal');
    var regSel = document.getElementById('ldpRegionSelect');
    var regTxt = '';
    if (regSel && regSel.options && regSel.selectedIndex > -1 && regSel.options[regSel.selectedIndex]) {
      regTxt = regSel.options[regSel.selectedIndex].textContent.trim();
    }
    set('ldp-market', regTxt || 'National baseline', mv ? mv.textContent.replace(/\s+/g, '') : '', '');

    /* ADD-ONS — delivery, rush, setup: whatever the panel itemised that is
       neither the cake nor an element */
    var addTotal = b.adds.reduce(function (n, l) { return n + money(l.v); }, 0);
    set('ldp-addons',
      b.adds.length ? b.adds.map(function (l) { return l.k.toLowerCase(); }).join(' · ') : 'None yet',
      b.adds.length ? '+ ' + fmt(addTotal) : '', '');
  }
  new MutationObserver(sync).observe(results, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  /* the covering/market controls can change without the panel re-rendering
     (the rate box, the region select), so listen to the build card too */
  var build = document.querySelector('.ldp-buildcard');
  if (build) {
    build.addEventListener('change', function () { setTimeout(sync, 0); });
    build.addEventListener('click', function () { setTimeout(sync, 0); });
  }
  sync();
  /* later blocks in this file BUILD some of what the rows report — the
     market stepper (#ldpMStepVal) is created after this one runs, so the
     first sync found no multiplier to show. Two deferred passes, then the
     listeners above keep it current. */
  setTimeout(sync, 0);
  setTimeout(sync, 400);
})();

/* ---------- 4g.3 SERVINGS, the design file's shape ----------
   Eyebrow left, Wedding/Party segmented right; the count as a
   figure; a link out to where tiers are actually edited. The
   tier builder itself stays (an unscoped cake has to be
   describable somewhere) but folds away once a file is attached,
   because then the tiers come from the file. */
(function initLdpServingsSec() {
  var sec = document.getElementById('ldp-servings');
  /* r196: the run-once guard used to look for the .ldp-tierfold this
     function built. That fold is gone (her "it doesn't do anything"), so
     the guard now marks the section itself - it has to be something this
     function CREATES, or a second call would re-run the DOM moves below. */
  if (!sec || sec.getAttribute('data-ldp-svsec') === '1') return;
  sec.setAttribute('data-ldp-svsec', '1');
  var headRow = sec.querySelector('.ldp-sec__head');

  /* the occasion pills ride up beside the eyebrow */
  var seg = sec.querySelector('.ldp-segmented[aria-label="Occasion"]');
  if (seg && headRow) {
    var oldField = seg.closest('.ldp-field');
    headRow.appendChild(seg);
    if (oldField && !oldField.querySelector('.ldp-segmented')) oldField.remove();
  }

  /* the figure sits directly under the eyebrow row */
  var fig = sec.querySelector('.ldp-svblock');
  if (fig && headRow) sec.insertBefore(fig, headRow.nextSibling);

  /* r52 (Mariya, free mode): "'I know my tiers' is pre-selected but the
     actual tier entry section is hidden." The old test sniffed the DOM for
     the client chip — but the chip renders on its own schedule, so this
     check raced it and the answer changed run to run. Resolve the scope
     from the cake-file layer itself, exactly as the engine's own
     readQuoteBooking does. (NOT `quoteBooking` — that var lives inside the
     engine IIFE and is unreachable here; the r48 notes already warn it is
     no window global, and this IIFE proved it by throwing.) */
  var scoped = false;
  try {
    scoped = !!(window.LdCakeFile && window.LdCakeFile.resolveScope && window.LdCakeFile.resolveScope());
  } catch (e0) { scoped = false; }
  var mode = sec.querySelector('.ldp-mode-toggle');
  var tiersPanel = document.getElementById('ldpTiersPanel');
  var svPanel = document.getElementById('ldpServingsPanel');

  /* ===== S-2 (Simplification brief, 2026-08-03) =====
     "Five paths, three destinations, one array. A user who edits in Batch
     Math and then opens the Planner editor has no way to know which one
     'won'." For Pricing that is not merely redundant, it is WRONG: this
     page READS the file's tiers (`LdCakeFile.readCake()`) and never calls
     `writeCake`. Editing them here moved the quote without moving the file,
     and the edit vanished on the next load — so a quote could be saved
     against a stack the client file never had.

     Scoped to a file, the editor is replaced by what the file says plus ONE
     door to the canonical editor. Unscoped, the builder stays exactly as it
     was: a cake with no file has to be describable somewhere. */
  if (scoped && tiersPanel) {
    var ro = document.createElement('div');
    ro.className = 'ldp-tierro';
    var spec = [];
    try {
      var rc = window.LdCakeFile && window.LdCakeFile.readCake();
      if (rc && rc.source === 'booking') spec = rc.tiers || [];
    } catch (e) { }
    var sizes = spec.map(function (t) { return (+t.d || 0); })
      .sort(function (a, b) { return b - a; })
      .map(function (d) { return d + '″'; }).join(' + ');
    ro.innerHTML = '<span class="ldp-tierro__spec">' +
      (sizes || 'No tiers on this file yet') + '</span>';
    var bid = '';
    try {
      var ab = window.LdCakeFile && window.LdCakeFile.getActiveBooking && window.LdCakeFile.getActiveBooking();
      bid = (ab && ab.id) || '';
    } catch (e2) { }
    var edit = document.createElement('a');
    edit.className = 'ldp-tierro__edit';
    /* 2026-09-14 (Mariya): resizing lives in Serving now, not here. */
    edit.href = '/pages/serving-size-calculator' + (bid ? '?file=' + encodeURIComponent(bid) : '');
    edit.textContent = 'Resize →';
    ro.appendChild(edit);
    if (mode) mode.hidden = true;
    tiersPanel.hidden = true;
    if (svPanel) svPanel.hidden = true;
    var anchorRo = (mode && mode.parentNode) || sec;
    anchorRo.insertBefore(ro, mode || null);
  } else if (mode && tiersPanel) {
    /* r196 (Mariya, 2026-08-31): "there's a button that says 'set your
       tiers' right under the shape buttons, but it doesn't do anything.
       Please remove it."

       She is right, and it was worse than inert. This wrapped the mode
       toggle and both panels in a <details> whose summary read "Set your
       tiers" — and the branch only ever runs UNSCOPED, where the line
       above set fold.open = true. So it rendered permanently open: a
       heading with a chevron that could only ever CLOSE the editor she was
       already using, sitting directly under the r109 cake builder that
       edits the same tiers by tapping them. (The `scoped ?` ternary in its
       label was dead code too — a scoped file takes the .ldp-tierro branch
       above and never reaches this one.)

       The fold is gone; the mode toggle and the panels stay exactly where
       they were, which is where they already appeared. Only the summary
       row disappears. The r52 sync below is NOT part of the fold and is
       kept — it fixes a real mode/panel disagreement at boot. */
    /* 2026-09-14 (Mariya): Pricing no longer edits tiers - resizing lives in
       Serving (it writes the file, which this page READS). The tier BUILDER and
       the servings/tiers mode toggle go; unscoped keeps the quick servings-count
       input, with a door to Serving for anyone pricing a specific stack. The
       engine tracks mode by the active button, so switch it to servings FIRST,
       then hide the toggle. */
    var svBtn = mode.querySelector('.ldp-mode-btn[data-smode="servings"]');
    if (svBtn && !svBtn.classList.contains('is-active')) svBtn.click();
    mode.hidden = true;
    tiersPanel.hidden = true;
    if (svPanel) svPanel.hidden = false;
    if (!sec.querySelector('.ldp-serving-door')) {
      var door = document.createElement('a');
      door.className = 'ldp-tierro__edit ldp-serving-door';
      door.href = '/pages/serving-size-calculator';
      door.textContent = 'Pricing a tiered cake? Size it first →';
      (svPanel || sec).appendChild(door);
    }
  }

  /* r110 (Mariya, 2026-08-25): the "Edit tiers in Batch Math →" link is
     gone. S-2 had already cut it for scoped cakes; since r109 the tiers are
     edited HERE, on the cake itself, so the link sent her to a second place
     to do the thing this page now does — and Batch Math is reachable from
     the nav anyway. */
})();

/* ---------- 4g.4 MARKET: the multiplier as a stepper ----------
   The design file shows the region list with a −/+ stepper beside
   it. The range input keeps every existing handler and stays the
   single source of the value — the stepper just writes to it. */
(function initLdpMarketStepper() {
  var slider = document.getElementById('ldpLocationSlider');
  var sec = document.getElementById('ldp-market');
  if (!slider || !sec || sec.querySelector('.ldp-mstep')) return;
  /* r147: the market card renders for FREE pages now. There the multiplier
     is the picked band - fine-tuning it is Pro. Skip the stepper, keep the
     hint fold below (jump past the stepper build, not out of the module). */
  var isFreePage = !document.getElementById('ldp-premium');
  /* r229 (Mariya): the market is "pull your location or pick from the
     dropdown" only - the manual +/- multiplier is retired on Pro too. The
     region pick and Detect both drive the (hidden) slider the engine reads,
     so the quote is unchanged; only the manual fine-tune control goes.
     buildStepper is kept defined for an easy revert but is no longer called. */
  /* was: if (!isFreePage) buildStepper(); */
  function buildStepper() {
  var select = document.getElementById('ldpRegionSelect');
  var field = slider.closest('.ldp-field');

  var row = document.createElement('div');
  row.className = 'ldp-mrow';
  var step = document.createElement('span');
  step.className = 'ldp-mstep';
  step.innerHTML =
    '<button type="button" class="ldp-mstep__b" data-mstep="-1" aria-label="Lower the market multiplier">−</button>' +
    '<span class="ldp-mstep__v" id="ldpMStepVal">× 1.00</span>' +
    '<button type="button" class="ldp-mstep__b" data-mstep="1" aria-label="Raise the market multiplier">+</button>';

  if (select && select.parentNode) {
    var selField = select.closest('.ldp-field') || select;
    selField.parentNode.insertBefore(row, selField);
    row.appendChild(selField);
    row.appendChild(step);
  } else {
    sec.appendChild(row);
    row.appendChild(step);
  }

  var val = step.querySelector('.ldp-mstep__v');
  function paint() { val.textContent = '× ' + (parseFloat(slider.value) || 1).toFixed(2); }
  step.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('.ldp-mstep__b') : null;
    if (!b) return;
    var dir = parseFloat(b.getAttribute('data-mstep')) || 0;
    var min = parseFloat(slider.min), max = parseFloat(slider.max);
    var next = Math.round(((parseFloat(slider.value) || 1) + dir * 0.05) * 100) / 100;
    if (!isNaN(min)) next = Math.max(min, next);
    if (!isNaN(max)) next = Math.min(max, next);
    slider.value = next;
    slider.dispatchEvent(new Event('input', { bubbles: true }));
    slider.dispatchEvent(new Event('change', { bubbles: true }));
    paint();
  });
  slider.addEventListener('input', paint);
  slider.addEventListener('change', paint);
  paint();
  }
  var field = slider.closest('.ldp-field');
  if (field) field.classList.add('ldp-sliderfield--quiet');

  /* the long location prose is dropped from the page; the ? carries a short
     concise version instead */
  var detect = document.getElementById('ldpDetectBtn');
  var hints = sec.querySelectorAll('.ldp-hint');
  Array.prototype.forEach.call(hints, function (h) { h.remove(); });
  var sub = sec.querySelector('.ldp-sub');
  if (sub) sub.remove();
  /* r54 follow-up (Mariya: "detect my area centred + plum, the info note below
     it, centred and significantly shortened; I cannot read the popup"). The
     button and the note stack, centred, in their own box; the note's prose is
     three short sentences, not the region essay that ran off the screen. */
  var box = document.createElement('div');
  box.className = 'ldp-detectbox';
  if (detect && detect.parentNode) {
    detect.parentNode.insertBefore(box, detect.nextSibling);
    detect.classList.add('ldp-detectbtn');
    box.appendChild(detect);
  } else {
    sec.appendChild(box);
  }
  var shortProse = '<p>uses your browser location to pick the closest market. ' +
    'nothing leaves your device. you can set it by hand instead.</p>';
  box.appendChild(ldpInfoNote('how this works', shortProse));
})();

/* ---------- 4g.4 THE MARKET, AS TWO LEDGER ROWS (r211 correction 4) ----------
   Two settings were wearing six controls: a label, a 41-option select, a
   second label, a second select, a stepper and a full-width Detect button.
   She asked for what the setting IS and what it SAYS - `Currency  CAD` and
   `Your market  Baseline  x1.00` - each opening its control in place. */
(function initLdpMarketRows() {
  /* the section's .ldp-secbody wrapper does not exist yet at this point -
     initLdpSections builds it further down the file - so this works off
     the controls themselves and lets the wrapper collect them later. */
  var sec = document.getElementById('ldp-market');
  if (!sec || sec.querySelector('.ldp-mktrow')) return;
  var cur = document.getElementById('ldpCurrencySelect');
  var reg = document.getElementById('ldpRegionSelect');
  if (!cur || !reg) return;

  var wells = [];
  function row(label, host, readValue) {
    var wrap = document.createElement('div');
    wrap.className = 'ldp-mkt';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ldp-mktrow';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="ldp-mktrow__k"></span>' +
      '<span class="ldp-mktrow__v"></span>' +
      '<span class="ldp-mktrow__x" aria-hidden="true">\u203A</span>';
    btn.querySelector('.ldp-mktrow__k').textContent = label;
    var well = document.createElement('div');
    well.className = 'ldp-mktwell';
    well.hidden = true;
    wrap.appendChild(btn); wrap.appendChild(well);
    host.parentNode.insertBefore(wrap, host);
    well.appendChild(host);
    wells.push(well);

    function paint() { btn.querySelector('.ldp-mktrow__v').textContent = readValue(); }
    btn.addEventListener('click', function () {
      var open = well.hidden;
      /* one well open at a time, the same rule the sections follow */
      wells.forEach(function (w) { if (w !== well) w.hidden = true; });
      well.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      wrap.classList.toggle('is-open', open);
    });
    return paint;
  }

  var curField = cur.closest('.ldp-field') || cur;
  var mrow = reg.closest('.ldp-mrow') || reg.closest('.ldp-field') || reg;

  var paintCur = row('Currency', curField, function () { return cur.value || ''; });
  var paintReg = row('Your market', mrow, function () {
    var name = reg.options[reg.selectedIndex] ? reg.options[reg.selectedIndex].text : '';
    var slider = document.getElementById('ldpLocationSlider');
    var m = slider ? (parseFloat(slider.value) || 1) : 1;
    return name + '  \u00D7' + m.toFixed(2);
  });
  paintCur(); paintReg();
  cur.addEventListener('change', paintCur);
  reg.addEventListener('change', paintReg);
  var sl = document.getElementById('ldpLocationSlider');
  if (sl) { sl.addEventListener('input', paintReg); sl.addEventListener('change', paintReg); }
  /* the row states the currency, so the field's own label is a repeat */
  var curLbl = curField.querySelector ? curField.querySelector('.ld-field__label') : null;
  if (curLbl) curLbl.hidden = true;
})();

/* ---------- 4g.45 TAX, AS ONE ROW (r211 correction 7) ----------
   The tick and the label are the row; the name and the rate open in a
   well under it, so the row reads `Tax on the quote   HST 13%` at 44px
   instead of carrying two live inputs across its right half. */
(function initLdpTaxRow() {
  var row = document.querySelector('.ldp-taxrow');
  if (!row || row.parentNode.querySelector('.ldp-taxwell')) return;
  var amt = row.querySelector('.ldp-addon-amt2');
  var name = document.getElementById('ldpTaxLabel');
  var rate = document.getElementById('ldpTaxRate');
  if (!amt || !name || !rate) return;

  var well = document.createElement('div');
  well.className = 'ldp-taxwell';
  well.hidden = true;
  row.parentNode.insertBefore(well, row.nextSibling);

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ldp-taxval';
  btn.setAttribute('aria-expanded', 'false');
  row.appendChild(btn);
  well.appendChild(amt);

  function paint() {
    btn.innerHTML = '<span></span><span class="ldp-taxval__x" aria-hidden="true">\u203A</span>';
    btn.firstChild.textContent = (name.value || 'Tax').trim() + ' ' +
      (parseFloat(rate.value) || 0) + '%';
  }
  paint();
  name.addEventListener('input', paint);
  rate.addEventListener('input', paint);
  btn.addEventListener('click', function () {
    well.hidden = !well.hidden;
    btn.setAttribute('aria-expanded', well.hidden ? 'false' : 'true');
  });
})();

/* ---------- 4g.5 ELEMENTS as one row ----------
   Name + what is on the cake + EDIT, with the picker itself
   folded until EDIT is tapped (design file, Pricing screen). */
(function initLdpElementsRow() {
  var sec = document.getElementById('ldpElementsCard');
  var box = document.getElementById('ldpElementsBox');
  if (!sec || !box || sec.querySelector('.ldp-elrow')) return;
  var head = sec.querySelector('.ldp-sec__head');
  if (head) head.remove();

  /* r111: inside the ledger this section already HAS its row — the ledger
     row is the door, and it reports the count. Building a second
     "Elements on the cake / Edit" head inside it would double the heading
     (and the old insert assumed the box was still a direct child of the
     section, which the ledger's body wrapper broke — an uncaught throw
     here killed every block after it in this file, the cake included). */
  /* r114 (handoff 11b): Elements is an OPEN numbered section now, never a
     folded row behind an Edit button — "nothing on this page collapses".
     The box stays visible and initLdpSections writes the count into the
     head. The .ldp-elrow builder below is unreachable and kept only so a
     stale cached page cannot throw. */
  if (true) {
    box.classList.add('ldp-elbox');
    box.hidden = false;
    if ((location.hash || '') === '#elements') {
      var ledRow = sec.querySelector('.ldp-led__row');
      if (ledRow && ledRow.getAttribute('aria-expanded') !== 'true') ledRow.click();
      setTimeout(function () {
        try { sec.scrollIntoView({ block: 'start' }); } catch (e) { }
      }, 300);
    }
    return;
  }

  var row = document.createElement('div');
  row.className = 'ldp-elrow';
  row.innerHTML =
    '<span class="ldp-elrow__main">' +
      '<span class="ldp-elrow__name">Elements on the cake</span>' +
      '<span class="ldp-elrow__sum"></span>' +
    '</span>' +
    '<button type="button" class="ldp-elrow__edit" aria-expanded="false">Edit</button>';
  sec.insertBefore(row, box);
  box.classList.add('ldp-elbox');
  box.hidden = true;

  var sum = row.querySelector('.ldp-elrow__sum');
  var edit = row.querySelector('.ldp-elrow__edit');
  function names() {
    var out = [];
    Array.prototype.forEach.call(box.querySelectorAll('.ld-chip[data-el][aria-pressed="true"]'), function (c) {
      out.push((c.textContent || '').trim());
    });
    Array.prototype.forEach.call(box.querySelectorAll('.ldp-el__name'), function (c) {
      out.push((c.textContent || '').trim());
    });
    return out.filter(function (x, i, a) { return x && a.indexOf(x) === i; });
  }
  function paint() {
    var n = names();
    /* r38: the old line said "each adds to the per-serving rate", which was
       wrong twice — they add to the TOTAL, and only the labour ones are
       per-serving. Say what is actually true of the model. */
    sum.textContent = n.length ? n.join(' · ') : 'None yet. Everything on the cake is priced here';
  }
  edit.addEventListener('click', function () {
    var on = box.hidden;
    box.hidden = !on;
    edit.setAttribute('aria-expanded', on ? 'true' : 'false');
    edit.textContent = on ? 'Done' : 'Edit';
  });
  new MutationObserver(paint).observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
  paint();
  /* r49 (Mariya): arriving from the client file's ELEMENTS row — she tapped
     "edit in Pricing" over there, so the picker opens itself and the page
     lands on it. Click-triggered on the other page = a sanctioned jump,
     same contract as the batch sheet's #batter/#ganache anchors. */
  if ((location.hash || '') === '#elements') {
    box.hidden = false;
    edit.setAttribute('aria-expanded', 'true');
    edit.textContent = 'Done';
    setTimeout(function () {
      try { sec.scrollIntoView({ block: 'start' }); } catch (e) { }
    }, 300);
  }
})();

/* ---------- 4g.6 no Calculate button ----------
   The design file has no Calculate anywhere: the quote is simply
   always current. The button stays in the DOM (it IS the engine's
   entry point and every handler hangs off it) but is hidden, and
   we press it whenever the inputs can produce a number. The guard
   below only decides WHETHER to press — it never does any math. */
(function initLdpAlwaysLive() {
  var btn = document.getElementById('ldpCalcBtn');
  var wrap = document.querySelector('.ldp-wrap');
  if (!btn || !wrap) return;

  function priceable() {
    var svPanel = document.getElementById('ldpServingsPanel');
    var typed = document.getElementById('ldpServingsCount');
    if (svPanel && !svPanel.hidden) return !!(typed && parseFloat(typed.value) > 0);
    return !!document.querySelector('.ldp-tier-row');
  }
  var t = null;
  function ping() {
    clearTimeout(t);
    t = setTimeout(function () { if (priceable()) btn.click(); }, 220);
  }
  wrap.addEventListener('input', ping, true);
  wrap.addEventListener('change', ping, true);
  wrap.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('button, .ld-chip') : null;
    if (!el || el === btn) return;
    if (el.closest('.ldp-col--quote')) return;   /* Save / Copy / tabs are not inputs */
    /* r59 (Mariya's bug): the client chip is file NAVIGATION, not a pricing
       input — this capture-phase listener saw her "change" tap, pinged, and
       the 220ms Calc press bubbled to the document as an outside click that
       closed the file popover she had just opened. */
    if (el.closest('.ld-cakechip-row, [data-ld-cakechip], .ld-filepop')) return;
    ping();
  }, true);

  btn.classList.add('ldp-calc--auto');
  if (priceable()) btn.click();
  else {
    /* a scoped file's tiers arrive a tick later */
    var tries = 0;
    var iv = setInterval(function () {
      if (priceable()) { btn.click(); clearInterval(iv); }
      if (++tries > 20) clearInterval(iv);
    }, 100);
  }
})();

/* ---------- 4h: the quote card's two design-file pieces ----------
   The panel's HTML is rebuilt on every recalculation, so both of
   these are (re-)placed by an observer, guarded against reacting
   to their own writes. Presentation only — no figure is computed
   here; the margin link just presses the tab that already exists. */
(function initLdpQuoteFace() {
  var results = document.getElementById('ldpResults');
  if (!results) return;
  /* NO re-entrancy guard here (2026-07-30): a `busy` flag swallowed the
     panel's own rebuild notification when it landed in the same tick as
     our insert, and the margin link vanished after the first recalc.
     dressNow() is idempotent - it inserts only what is missing - so
     reacting to our own writes is harmless and cannot loop. */
  function dress() {
    var head = results.querySelector('.ldp-rt-head');
    if (head && head.parentNode && !results.querySelector('.ldp-rt-lede')) {
      var p = document.createElement('p');
      p.className = 'ldp-rt-lede';
      /* r144 (her call): "this is rather self explanatory and not
         necessary" - the number visibly moves as she builds. */
      p.textContent = '';
      head.parentNode.insertBefore(p, head.nextSibling);
    }
    /* the margin check is Pro: no tab on the page means no link to it */
    var tab = document.querySelector('.ldp-qtab[data-qtab="margin"]');
    var note = results.querySelector('.ldp-deposit');
    if (tab && note && note.parentNode && !results.querySelector('.ldp-marginlink')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ldp-marginlink';
      b.innerHTML = '<span>Check your margin on this quote</span><span aria-hidden="true">→</span>';
      b.addEventListener('click', function () { tab.click(); });
      note.parentNode.insertBefore(b, note.nextSibling);
    }
  }
  new MutationObserver(dress).observe(results, { childList: true, subtree: true });
  dress();
})();

/* r15: name the client on the printed quote, the way Serving does. */
(function initLdpPrintHead() {
  /* 2026-08-04 (Mariya): the printed quote is the baker's own sales
     document, so the letterhead is THEIRS — business name, contact line and
     optional logo, set once in Toolkit settings. Nothing here is LAYER'D's
     any more; the template's hardcoded brand is only the fallback for
     someone who has set nothing, and even that is replaced the moment a
     business name exists. */
  function paintStudio() {
    var head = document.querySelector('.ldp-printhead');
    if (!head) return;
    function get(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
    var name = get('layerd-studio-name').trim();
    var contact = get('layerd-studio-contact').trim();
    var logo = get('layerd-studio-logo');

    var brand = head.querySelector('.ldp-printhead__brand');
    var sub = head.querySelector('.ldp-printhead__sub');
    var mark = head.querySelector('.ldp-printhead__logo');

    if (logo) {
      if (!mark) {
        mark = document.createElement('img');
        mark.className = 'ldp-printhead__logo';
        mark.alt = '';
        head.insertBefore(mark, head.firstChild);
      }
      if (mark.getAttribute('src') !== logo) mark.setAttribute('src', logo);
      /* with a logo the wordmark would say the same thing twice */
      if (brand) brand.style.display = name ? '' : 'none';
    } else if (mark) {
      mark.parentNode.removeChild(mark);
      if (brand) brand.style.display = '';
    }
    if (brand && name) brand.textContent = name;
    if (sub) sub.textContent = contact || (name ? 'Cake quote' : sub.textContent);
  }
  function paint() {
    paintStudio();
    var el = document.getElementById('ldpPrintClient');
    if (!el) return;
    var b = null;
    try { b = window.LdCakeFile && window.LdCakeFile.getActiveBooking ? window.LdCakeFile.getActiveBooking() : null; } catch (e) { }
    if (!b) { el.textContent = ''; return; }
    var name = (b.name || '').trim();
    var when = '';
    try {
      if (b.date) {
        var p = String(b.date).split('-');
        var d = new Date(+p[0], +p[1] - 1, +p[2]);
        if (!isNaN(d.getTime())) {
          when = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()] + ' ' +
                 ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()] +
                 ' ' + d.getDate() + ', ' + d.getFullYear();
        }
      }
    } catch (e2) { }
    el.textContent = name ? (when ? name + ' \u00b7 ' + when : name) : '';
  }
  paint();
  window.addEventListener('layerd:cakefile', paint);
  window.addEventListener('beforeprint', paint);

})();

/* ============================================================
   r109 (her design 8a, 2026-08-25) — BUILD THE CAKE, WATCH THE
   PRICE MOVE.

   The page led with three competing ways to describe one cake — a
   tiers/servings toggle, an import, and a Shape/Size/Height row —
   and the number all of it existed to produce sat five screens
   below. The cake leads now: it is drawn, you tap a tier to edit
   it in place, and the total moves under your thumb.

   ENGINE UNTOUCHED, ON PURPOSE. The legacy `.ldp-tier-row` selects
   remain the ONE source every calculation reads (getTotalServings,
   writeSharedCake, the premium bundle, the quote sheet). They are
   hidden, not removed: this block is an EDITOR for them, and every
   edit writes to the select and fires the same `change` the old
   dropdown fired — so the recalculation path is the one that has
   always run. Nothing here computes a price.

   SELF-CONTAINED BY DESIGN: it reads the #ldp-config island itself
   and takes its labels from the selects' own option text (which the
   page already keeps in the right units), so it borrows nothing
   from the main module's scope and cannot be broken by it.
   ============================================================ */
(function ldpCakeFirst() {
  var mount = document.getElementById('ldpCake');
  var rowsEl = document.getElementById('ldpTierRows');
  if (!mount || !rowsEl) return;
  var CFGX = null;
  try {
    var isl = document.getElementById('ldp-config');
    CFGX = isl ? JSON.parse(isl.textContent) : null;
  } catch (e) { CFGX = null; }
  if (!CFGX || !CFGX.servings) return;

  /* SPINE r229: this editor is a separate module (it borrows nothing from the
     main scope, see the header above), so it gets its own thin bridge to the
     ONE servings owner, cakeCore. Same table, same *h/4 rule, one place. */
  var EDCORE = window.LAYERD && window.LAYERD.cakeCore;
  if (EDCORE && EDCORE.SERVINGS) CFGX.servings = EDCORE.SERVINGS;
  function edServingsFor(shape, size, occ, h) {
    if (EDCORE && EDCORE.servingsFor) return EDCORE.servingsFor(shape, size, occ, h);
    var entry = CFGX.servings[shape] && CFGX.servings[shape][size];
    if (!entry || entry[occ] == null) return 0;
    return Math.round(entry[occ] * (h || 4) / 4);
  }

  var sel = 0;
  var HEIGHTS = [3, 4, 5, 6, 7, 8];   /* r221: 3" (two layers) is the new floor of the height stepper */
  /* r111 (her design 9a): with a client file attached the cake is already
     decided upstream, so the editor arrives COLLAPSED behind one "Adjust
     tiers" row. adjOpen survives the redraws draw() does. */
  var adjOpen = false;
  function scopedNow() {
    try { return !!(window.LdCakeFile && window.LdCakeFile.resolveScope && window.LdCakeFile.resolveScope()); }
    catch (e) { return false; }
  }
  function clientName() {
    try {
      var ab = window.LdCakeFile && window.LdCakeFile.getActiveBooking && window.LdCakeFile.getActiveBooking();
      return ((ab && ab.name) || '').trim();
    } catch (e) { return ''; }
  }
  /* 9a rule 3, "say that it writes back": an edit here IS an edit to the
     client's cake, so it is written to the file — the same writeCake the
     other tools use, in the same largest-first geometry. S-2 removed tier
     editing from this page precisely BECAUSE it moved the quote without
     moving the file; editing returns only now that it writes. */
  var writeTimer = null;
  function writeBackToFile() {
    if (!scopedNow() || !window.LdCakeFile || !window.LdCakeFile.writeCake) return;
    clearTimeout(writeTimer);
    writeTimer = setTimeout(function () {
      var geo = rows().map(function (row) {
        var p = partsOf(row);
        var sh = p.shape.value;
        return {
          d: parseInt(p.size.value, 10),
          h: parseInt(p.height.value, 10) || 4,
          shape: sh === 'square' ? 'square' : sh === 'heart' ? 'heart' : 'round'
        };
      }).sort(function (a, b) { return b.d - a.d; });
      if (!geo.length) return;
      try { window.LdCakeFile.writeCake(geo, 'pricing'); } catch (e) { /* the quote still stands */ }
    }, 260);
  }
  function esc2(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function rows() { return [].slice.call(rowsEl.querySelectorAll('.ldp-tier-row')); }
  function partsOf(row) {
    var s = row.querySelectorAll('select');
    return { shape: s[0], size: s[1], height: s[2] };
  }
  /* the label the page itself is showing — inches or cm, already handled */
  function optText(selEl) {
    var o = selEl.options[selEl.selectedIndex];
    return o ? o.textContent.trim() : selEl.value;
  }
  function occasion() {
    /* r153: state.occasion is THE source (r151b seeds it from the file).
       This helper used to read the active DOM pill - but on a client file
       the pills leave with the folded section head (r114), so it silently
       fell back to 'wedding' and this editor rendered wedding math on a
       party cake while the engine (state-driven) said otherwise. The DOM
       read survives only as a stale-boot fallback. */
    var api = window.LAYERD && window.LAYERD.pricingOccasion;
    var v = api && api.get ? api.get() : null;
    if (v === 'party' || v === 'wedding') return v;
    var on = document.querySelector('.ldp-seg-btn.is-active[data-occasion]');
    return (on && on.getAttribute('data-occasion')) || 'wedding';
  }
  function tierData(row) {
    var p = partsOf(row);
    var shape = p.shape.value, d = parseInt(p.size.value, 10), h = parseInt(p.height.value, 10) || 4;
    /* the SAME serving math getTotalServings uses — cakeCore is the one owner
       (SPINE r229). Never a second formula. */
    var sv = edServingsFor(shape, d, occasion(), h);
    return { shape: shape, d: d, h: h, sv: sv, dLabel: optText(p.size), hLabel: optText(p.height) };
  }
  function sizesFor(shape) {
    return Object.keys(CFGX.servings[shape] || {}).map(Number).sort(function (a, b) { return a - b; });
  }
  function labelForSize(row, d) {
    var p = partsOf(row), out = String(d);
    [].forEach.call(p.size.options, function (o) { if (parseInt(o.value, 10) === d) out = o.textContent.trim(); });
    return out;
  }
  /* fire `change` on the ONE select that actually changed. Firing it on all
     three re-entered the page's own shape handler, which repopulates the
     size list and resets it to the smallest option — so choosing 8in landed
     back on 4in. One edit, one event. */
  function commit(selEl) {
    if (selEl) selEl.dispatchEvent(new Event('change', { bubbles: true }));
    writeBackToFile();   /* r111: scoped, the file is the record — see 9a rule 3 */
    draw();
  }

  function draw() {
    var list = rows();
    if (!list.length) { mount.innerHTML = ''; return; }
    if (sel >= list.length) sel = list.length - 1;
    if (sel < 0) sel = 0;
    var data = list.map(tierData);
    var maxD = data.reduce(function (m, t) { return Math.max(m, t.d || 0); }, 0) || 1;

    /* r110 (Mariya): "the cake rendering should be exactly like the one in
       serving and structure" — so it IS that one. window.LAYERD.cakeCore's
       renderStack is the suite's single drawing (r92 gave it the interactive
       + highlight options Batch Math uses); this page just asks for the same
       picture and lets the tap land on its `<g data-tier-i>` groups. The
       hand-drawn bars stay ONLY as a fallback for a page served without the
       core script — never a second look on a working page. */
    var CORE = window.LAYERD && window.LAYERD.cakeCore;
    var stage;
    if (CORE && CORE.renderStack && CORE.renderStackInteractive) {
      var stack = data.map(function (t) {
        /* 2026-09-16: heart now draws as a heart (the illustration is back on),
           so pass the real shape through to renderStack. */
        return { size: t.d, height: t.h, shape: t.shape === 'square' ? 'square' : t.shape === 'heart' ? 'heart' : 'round' };
      });
      /* r141: the section header right above this card already says "Your
         cake" - saying it again on the card was the repeat in her
         screenshot. Batch Math calls the same slot "The build"; one word
         across both tools.
         2026-09-14 (Mariya: "use batch math as a size reference for the read
         only tier visual and match the pricing one to it"). Pricing no longer
         edits tiers, so the illustration is drawn EXACTLY as Batch Math draws
         its read-only cake — the same renderStack call, { interactive: false },
         no lavender highlight, no focusable tier buttons. Same picture, both
         tools. */
      stage = '<div class="ldp-cakesum__fig">' +
        CORE.renderStack(stack, { interactive: false }) + '</div>';
    } else {
      stage = '<div class="ldp-cakesum__fig ldp-cake__stage">' + data.map(function (t, i) {
        var w = Math.max(42, Math.round((t.d / maxD) * 100));
        var hpx = Math.max(34, Math.min(56, 26 + t.h * 3));
        return '<button type="button" class="ldp-cake__tier' + (i === sel ? ' is-sel' : '') + '"' +
          ' style="width:' + w + '%;height:' + hpx + 'px" data-ldptier="' + i + '"' +
          ' aria-pressed="' + (i === sel ? 'true' : 'false') + '"' +
          ' aria-label="Tier ' + (i + 1) + ', ' + esc2(t.dLabel) + ', ' + t.sv + ' servings. Edit it.">' +
          '<span class="ldp-cake__d">' + esc2(t.dLabel) + '</span>' +
          '<span class="ldp-cake__sv">' + t.sv + ' sv</span></button>';
      }).reverse().join('') + '<span class="ldp-cake__board" aria-hidden="true"></span></div>';
    }

    var scoped = scopedNow();
    var who = clientName();
    var totalSv = data.reduce(function (n, t) { return n + t.sv; }, 0);
    /* biggest first, the way a stack is read and the way every other tool
       in the suite lists it */
    var summary = list.length + ' tier' + (list.length === 1 ? '' : 's') + ' · ' +
      data.slice().sort(function (a, b) { return b.d - a.d; })
        .map(function (t) { return t.dLabel + ' · ' + t.sv + ' sv'; }).join(' + ');

    /* round 54 (Mariya: "put a summary of the shape and sizing right under
       the cake so that it's very clear what the cake's dimensions are").
       Biggest tier first, imperial first, the chip's own vocabulary.
       2026-09-14: the caption now mirrors Batch Math's scoped spec line exactly
       — "N-tier · <sizes> · <shape>" — so the two read-only cakes carry the same
       size reference; the serving total trails it (Pricing needs the count). */
    var dimT = data.slice().sort(function (a, b) { return b.d - a.d; });
    var oneShape = dimT.every(function (t) { return t.shape === dimT[0].shape; });
    /* 2026-09-15 (Mariya: "edit the top cake summary to be exactly like batch
       math"). Illustration, then "N-tier · size · shape" (no serving count - the
       way Batch Math writes its scoped spec), then the Resize door - all centered
       in the same shape as .bmath-scoped. The Wedding/Party slicing toggle (a
       PRICING choice, not a size) and the provenance line sit BELOW the summary,
       the way Batch Math keeps its occasion + client block under the cake. */
    /* 2026-09-16 (Mariya: the summary only showed width, so she kept going back
       to Serving to check the height). Each size now carries its tier height. */
    var specLine = data.length + '-tier · ' +
      dimT.map(function (t) { return esc2(t.dLabel) + ' × ' + esc2(t.hLabel); }).join(' + ') +
      ' · ' + (oneShape ? esc2(dimT[0].shape) : 'mixed shapes');
    var bid = '';
    try {
      var abx = window.LdCakeFile && window.LdCakeFile.getActiveBooking && window.LdCakeFile.getActiveBooking();
      bid = (abx && abx.id) || '';
    } catch (eB) { bid = ''; }
    var door = '<a class="ldp-cakesum__edit ldp-serving-door" href="/pages/serving-size-calculator' +
      (bid ? '?file=' + encodeURIComponent(bid) : '') + '">Resize →</a>';
    var h = '<div class="ldp-cakesum">' + stage +
      '<p class="ldp-cakesum__spec">' + specLine + '</p>' + door + '</div>';

    var occNow = occasion();
    var occHtml = '<span class="ldp-cake__occ" role="radiogroup" aria-label="How this cake is sliced">' +
      ['wedding', 'party'].map(function (o) {
        var on = occNow === o;
        return '<button type="button" class="ld-chip ldp-seg-btn' + (on ? ' is-active' : '') +
          '" data-occasion="' + o + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
          (o === 'wedding' ? 'Wedding' : 'Party') + '</button>';
      }).join('') + '</span>';
    h += '<div class="ldp-cake__meta ldp-cake__meta--ro">' + occHtml + '</div>';
    if (scoped) {
      /* one provenance line, so she never wonders which cake she is pricing */
      h += '<p class="ldp-cake__from">From ' +
        (who ? esc2(who) + '’s file' : 'this client file') + ' · sized in Step 1</p>';
    }

    mount.innerHTML = h;
  }

  /* the drawing's tiers are <g data-tier-i> groups, not buttons — one
     delegated hit test covers both them and the editor's buttons */
  function pickFromEvent(ev) {
    var g = ev.target.closest ? ev.target.closest('[data-tier-i]') : null;
    if (!g) return false;
    var i = parseInt(g.getAttribute('data-tier-i'), 10);
    if (isNaN(i)) return false;
    sel = i; draw();
    var again = mount.querySelector('[data-tier-i="' + i + '"]');
    if (again && again.focus) { try { again.focus(); } catch (e) { /* SVG focus, older browsers */ } }
    return true;
  }
  mount.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
    if (pickFromEvent(ev)) ev.preventDefault();
  });
  mount.addEventListener('click', function (ev) {
    if (pickFromEvent(ev)) return;
    var b = ev.target.closest ? ev.target.closest('button') : null;
    if (!b) return;
    if (b.hasAttribute('data-ldpadj')) { adjOpen = !adjOpen; draw(); return; }
    var list = rows();
    if (b.hasAttribute('data-ldptier')) { sel = parseInt(b.getAttribute('data-ldptier'), 10); draw(); return; }
    if (b.hasAttribute('data-ldpaddtier')) {
      var addBtn = document.getElementById('ldpAddTierBtn');
      if (addBtn) { addBtn.click(); var l2 = rows(); sel = l2.length - 1; commit(partsOf(l2[sel]).size); }
      return;
    }
    if (b.hasAttribute('data-ldprmtier')) {
      var i = parseInt(b.getAttribute('data-ldprmtier'), 10);
      var row = list[i];
      if (!row || list.length < 2) return;
      var rm = row.querySelector('.ldp-tier-remove');
      if (rm) rm.click();
      sel = Math.max(0, i - 1);
      var left = rows();
      if (left.length) commit(partsOf(left[0]).size); else draw();
      return;
    }
    var row2 = list[sel];
    if (!row2) return;
    var p = partsOf(row2);
    if (b.hasAttribute('data-ldpsize')) { p.size.value = b.getAttribute('data-ldpsize'); commit(p.size); return; }
    if (b.hasAttribute('data-ldph')) {
      var dir = parseInt(b.getAttribute('data-ldph'), 10);
      var cur = HEIGHTS.indexOf(parseInt(p.height.value, 10) || 4);
      p.height.value = String(HEIGHTS[Math.max(0, Math.min(HEIGHTS.length - 1, (cur < 0 ? 0 : cur) + dir))]);
      commit(p.height); return;
    }
    if (b.hasAttribute('data-ldpshape')) {
      var want = b.getAttribute('data-ldpshape');
      var keepD = parseInt(p.size.value, 10);
      p.shape.value = want;
      p.shape.dispatchEvent(new Event('change', { bubbles: true }));   /* repopulates the size list */
      var sizes = sizesFor(want), best = sizes[0];
      sizes.forEach(function (d) { if (Math.abs(d - keepD) < Math.abs(best - keepD)) best = d; });
      p.size.value = String(best);
      commit(p.size); return;
    }
  });

  /* redraw whenever anything else changes the cake — an import, a client
     file seeding tiers, the unit flip relabelling the selects, the
     wedding/party switch changing every serving count */
  rowsEl.addEventListener('change', function () { draw(); });
  new MutationObserver(function () { draw(); }).observe(rowsEl, { childList: true, subtree: true });
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest ? ev.target.closest('.ldp-seg-btn[data-occasion]') : null;
    if (t) setTimeout(draw, 0);
  });

  draw();
  /* the page leads with the cake now: the legacy toggle and the select
     rows stay in the DOM (the engine reads them) but leave the screen */
  var card = document.getElementById('ldp-servings');
  if (card) card.classList.add('ldp-cakefirst');

  /* r110 (Mariya, 2026-08-25): THE PAGE LEADS WITH THE QUOTE. r109 moved
     the plum box down under the cake; she wants it back at the very top —
     under the client chip, above the inches toggle — where the template
     already puts it. So there is nothing to move: the re-parenting is gone
     and the box stays put. It is sticky, so the number still follows her
     down the page while she edits the cake below it. */

  /* THE INCHES CHIP JOINS IT. learn-components mounts that chip beside the
     page's own units pill, which lives inside the tier controls this design
     hides — so it is lifted to the top strip, left-aligned under the quote,
     as soon as it appears (it is mounted on the component's own schedule,
     hence the observer rather than a straight query). */
  function liftUnitChip() {
    var row = document.querySelector('.ld-unitchip-row');
    if (!row) {
      /* older learn-components mounts the chip with no row of its own —
         give it one, so it lands on the page's left edge either way */
      var bare = document.querySelector('.ld-unitchip');
      if (bare) {
        row = document.createElement('div');
        row.className = 'ld-unitchip-row';
        bare.parentNode.insertBefore(row, bare);
        row.appendChild(bare);
      }
    }
    var stripEl = document.getElementById('ldpQuoteStrip');
    if (!row || !stripEl || !stripEl.parentNode) return false;
    /* r227 (Mariya: Pricing was flashing/unclickable). Once railShell mounts,
       IT owns the inches pill's position (rail on desktop, below the quote on
       mobile). This function and railShell were moving the SAME row to two
       different spots, each move re-firing the other's document.body observer -
       an infinite loop that saturated the main thread. When `.ldc-pr` exists,
       do NOT reposition here; still hide the box below and return true so this
       observer disconnects. */
    if (!document.querySelector('.ldc-pr') && row.previousElementSibling !== stripEl) {
      stripEl.parentNode.insertBefore(row, stripEl.nextSibling);
    }
    /* the wrapper it came out of now holds nothing but the hidden pill —
       the chip still drives that pill by clicking it, hidden or not */
    var box = document.querySelector('.ldp-units');
    if (box && !box.querySelector('.ld-unitchip')) box.style.display = 'none';
    return true;
  }
  if (!liftUnitChip()) {
    var umo = new MutationObserver(function () { if (liftUnitChip()) umo.disconnect(); });
    umo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { umo.disconnect(); }, 8000);
  }
})();

/* ---------- r114: the numbered sections (design handoff 11b) ----------
   The handoff replaces r111's collapsed ledger with open sections behind
   step one: 02 Elements, 03 Your market, 04 Add-ons. Each head is a
   Marcellus numeral, a Marcellus 22px heading, an optional count, and a
   gold hairline running out to the right.

   Base cover keeps a section of its own. The handoff's 11b frame omits it
   and its reconciliation table supersedes exactly two things from 10a —
   margin-as-verdict and cost-behind-a-door — neither of which is the cover
   picker. So 10a's two 52px option rows carry forward, restyled to the
   same vocabulary 11b uses for element rows, and each now states the saved
   price step one wrote.

   Presentation only. Every control underneath is the original node with
   its original id and handlers; nothing here computes a price. */
(function initLdpSections() {
  /* 2026-09-15 (Mariya, pricing reshape): the page reads like the quote sheet
     now — every main section is a booking row (label · answer · chevron), closed
     by default with its answer in the head, and ONE open at a time, the way
     Batch Math and the Studio steps work. This reverses the 09-14 "always open"
     mains (that is what pushed the page to five screens). The first question,
     "Your cake", opens on load; the rest are shut. See head() + openState. */
  var MAIN_STATIC = false;  /* mains are collapsible booking rows again */
  var build = document.querySelector('.ldp-col--build');
  if (!build) return;

  /* her fold state, per section. Default OPEN: the handoff's page is meant
     to be read down in one pass, and a section that opens shut hides the
     rate a first-time visitor needs to see. */
  var FOLD_KEY = 'layerd-pricing-sections';
  function foldState() {
    /* 2026-09-15: bumped to v2 with the reshape. Old v1 state remembered the
       "all open" defaults, which would defeat the closed/one-open grammar, so
       it is ignored and everyone starts fresh on the new defaults once. */
    try { var v = JSON.parse(localStorage.getItem(FOLD_KEY)); return (v && v.v === 2 && v.shut) || {}; }
    catch (e) { return {}; }
  }
  function openState(id) {
    var f = foldState();
    if (Object.prototype.hasOwnProperty.call(f, id)) return f[id] !== true;
    return !SHUT_BY_DEFAULT[id];
  }
  function remember(id, open) {
    try {
      var all = foldState();
      if (open === !SHUT_BY_DEFAULT[id]) delete all[id]; else all[id] = !open;
      localStorage.setItem(FOLD_KEY, JSON.stringify({ v: 2, shut: all }));
    } catch (e) { /* private mode — the fold still works, it just won't stick */ }
  }

  /* r116 (Mariya): Base cover is the real step 01. The cost build-up moved
     to the foot as an unnumbered fine-tuning section — studio setup, not a
     step in quoting this cake. */
  /* r209 (her round 51, the screenshots): the page answers FOUR questions
     - 01 your cake, 02 what it costs you, 03 what you charge, 04 the
     quote. Elements, market and add-ons are not questions of their own:
     they are parts of 03's answer, so they wear quiet eyebrow heads with
     no numeral. ONE head system for all seven - r207 bolted a second one
     on top of this one, and the page wore both. */
  var NUM = {
    'ldp-servings': '01',
    'mcs1Card': '02',
    'ldp-design': '03',
    'ldpElementsCard': '',
    'ldp-market': '',
    'ldp-addons': '',
    'ldp-quote': '04'
  };
  var TITLE = {
    'ldp-servings': 'Your cake',
    'mcs1Card': 'What it costs you',
    'ldp-design': 'What you charge',
    'ldpElementsCard': 'Elements',
    'ldp-market': 'Your market',
    'ldp-addons': 'Add-ons',
    'ldp-quote': 'The quote'
  };
  /* eyebrow heads: parts of 03, not questions */
  var EYEBROW = { 'ldpElementsCard': 1, 'ldp-market': 1, 'ldp-addons': 1 };
  /* r209: the market is one glance ('x1.00 · baseline') unless she opens
     it - the design shows it as a single quiet row */
  /* r211 correction 2 (her round 52): every section arrives COLLAPSED.
     Expanded-by-default was why the page ran ~5,600px and read as more
     confusing than what it replaced; collapsed, the whole thing is one
     screen - the price, the per-serving and the four answers together.
     One open at a time, held as ONE value, never four booleans. */
  /* 2026-09-15 (pricing reshape): closed by default, one open at a time. "Your
     cake" (the first question) opens on load; everything else is shut with its
     answer in the head. A section a user opens/collapses is still remembered. */
  var SHUT_BY_DEFAULT = {
    'mcs1Card': 1, 'ldp-design': 1, 'ldp-quote': 1,
    'ldpElementsCard': 1, 'ldp-market': 1, 'ldp-addons': 1
  };
  var QUESTIONS = ['ldp-servings', 'mcs1Card', 'ldp-design', 'ldp-quote'];
  var openSection = null;          /* null | one of QUESTIONS */
  var painters = {};               /* id -> paint(open) */

  function head(sec) {
    var id = sec.id;
    if (!(id in NUM)) return null;
    var existing = sec.querySelector('.ldp-sechead');
    if (existing) return existing;

    /* the card's own heading is replaced by the handoff's head */
    var old = sec.querySelector('.ldp-sec__head') || sec.querySelector('.ldp-heading-sm');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    /* r209: 01 keeps its occasion toggle - it lived inside the old head,
       and removing the head must not take the control with it */
    var keep = sec.querySelector('.ldp-segmented');
    /* 2026-09-15 (Mariya): the MAIN numbered sections (Your cake, What it costs
       you, What you charge, The quote) keep their header but DO NOT collapse -
       a static heading with no chevron, body always open. Only the `--sub`
       eyebrow blocks (Elements, Your market, Add-ons) stay collapsible. */
    var isSub = !!EYEBROW[id];
    var isStatic = MAIN_STATIC && !isSub;
    var h = document.createElement(isStatic ? 'div' : 'button');
    if (!isStatic) h.type = 'button';
    h.className = 'ldp-sechead' + (isSub ? ' ldp-sechead--sub' : '') + (isStatic ? ' ldp-sechead--static' : '');
    if (!isStatic) h.setAttribute('aria-expanded', 'true');
    /* r211 correction 1: the row IS the control - title, answer and a 28px
       chevron CELL. The static mains drop the chevron; the sub blocks keep it. */
    h.innerHTML =
      '<h3 class="ldp-sechead__t">' + TITLE[id] + '</h3>' +
      '<span class="ldp-sechead__c"></span>' +
      (isStatic ? '' : '<span class="ldp-sechead__x" aria-hidden="true">⌄</span>');

    /* everything the section already held becomes its body */
    var body = document.createElement('div');
    body.className = 'ldp-secbody';
    while (sec.firstChild) body.appendChild(sec.firstChild);
    sec.appendChild(h);
    if (keep) sec.appendChild(keep);
    sec.appendChild(body);

    function paint(open) {
      if (isStatic) open = true;   /* mains never collapse */
      body.hidden = !open;
      sec.classList.toggle('is-shut', !open);
      if (!isStatic) h.setAttribute('aria-expanded', open ? 'true' : 'false');
      var x = h.querySelector('.ldp-sechead__x');
      if (x) x.textContent = open ? '⌃' : '⌄';
    }
    painters[id] = paint;
    if (isStatic) {
      paint(true);
    } else {
      paint(openState(id));
      h.addEventListener('click', function () {
        var willOpen = body.hidden;
        /* 2026-09-15 (pricing reshape): one MAIN open at a time — opening a
           numbered question closes the others, so the page never stacks to five
           screens. Sub-blocks (Elements, Market, Add-ons) toggle independently
           inside "What you charge". */
        if (willOpen && !isSub) {
          QUESTIONS.forEach(function (qid) {
            if (qid !== id && painters[qid]) { painters[qid](false); remember(qid, false); }
          });
        }
        paint(willOpen);
        remember(id, willOpen);
        secSync();
        /* 2026-09-16 (Mariya, test-user report: opening "The quote" landed on
           the Pro/Academy block below it, not the quote). Opening a main closes
           the mains ABOVE it, so the page shrinks and this section jumps up —
           with the scroll fixed, the viewport ends on the paywall under the
           quote. Tapping a head IS explicit navigation (the one case the
           no-auto-scroll rule allows), so pull the opened section's head to the
           top: the answer you opened is what you see first. Instant, not smooth
           — a smooth scroll animates to a target computed before the collapse
           finishes and overshoots. Re-assert once after the auto-calc re-price
           (a head click pings the ~220ms live-calc, which re-renders and shifts
           the layout out from under the first scroll). */
        if (willOpen && !isSub && window.matchMedia('(max-width: 899px)').matches) {
          /* mobile only: the desktop rail swaps panels, no collapse-above. */
          var pullToTop = function () { try { h.scrollIntoView({ block: 'start' }); } catch (e) { } };
          setTimeout(pullToTop, 0);
          setTimeout(pullToTop, 340);
        }
      });
    }
    return h;
  }

  Object.keys(NUM).forEach(function (id) {
    var sec = document.getElementById(id);
    if (!sec) return;
    var mine = sec.querySelector(':scope > .ldc-price__shead');
    if (mine) mine.parentNode.removeChild(mine);
    /* 01 and the quote ship as template <details> folds; the chrome owns
       folding now, so their summaries would be a second head */
    var det = sec.querySelector(':scope > details.ld-collapse');
    if (det) {
      det.open = true;
      var sum = det.querySelector(':scope > summary');
      if (sum) sum.style.display = 'none';
    }
    sec.classList.add('ldp-sec2');
    head(sec);
  });

  /* r211 corrections 2 + 5: elements, the market and the add-ons are not
     questions of their own - they are what 03's answer is MADE of, so
     they live inside it (her screenshot 02). Moved after every head is
     built, so each keeps its own eyebrow, its mount and its handlers. */
  (function nestInto03() {
    var host = document.getElementById('ldp-design');
    var body = host && host.querySelector('.ldp-secbody');
    if (!body) return;
    ['ldpElementsCard', 'ldp-market', 'ldp-addons'].forEach(function (id) {
      var sec = document.getElementById(id);
      if (sec && sec.parentNode !== body) body.appendChild(sec);
    });
  })();

  /* r211: the break-even module is a member's, so a visitor's page has no
     02 and used to run 01, 03, 04 - which reads as a missing step rather
     than a locked one. The numerals count the questions that are actually
     on the page. */
  (function renumber() {
    var n = 0;
    QUESTIONS.forEach(function (id) {
      var sec = document.getElementById(id);
      if (!sec) return;
      var slot = sec.querySelector(':scope > .ldp-sechead .ldp-sechead__n');
      if (!slot) return;
      n++;
      slot.textContent = (n < 10 ? '0' : '') + n;
    });
  })();

  /* the long form, for the baker who wants it (her "Expand all") */
  (function expandAll() {
    /* 2026-09-11 (Mariya): the "Saved as you work · Expand all" row is chrome
       for an accordion that already shows its live values in each head. Cut. */
    return;
    var page = document.getElementById('ldpPriceCalc');
    var quote = document.getElementById('ldp-quote');
    if (!page || !quote || document.getElementById('ldpExpandAll')) return;
    var row = document.createElement('div');
    row.className = 'ldp-expandrow';
    row.innerHTML = '<span class="ldp-expandrow__k">Saved as you work.</span>' +
      '<button type="button" class="ldp-expandrow__go" id="ldpExpandAll">Expand all</button>';
    if (quote.parentNode) quote.parentNode.insertBefore(row, quote.nextSibling);
    var btn = row.querySelector('#ldpExpandAll');
    btn.addEventListener('click', function () {
      var anyShut = QUESTIONS.some(function (id) {
        var sec = document.getElementById(id);
        return sec && sec.classList.contains('is-shut');
      });
      QUESTIONS.forEach(function (id) {
        if (painters[id]) { painters[id](anyShut); remember(id, anyShut); }
      });
      openSection = null;
      btn.textContent = anyShut ? 'Collapse all' : 'Expand all';
      secSync();
    });
  })();

  /* ---- the heads carry their own answers (the design's right slot) ----
     Skimming the page by answers alone is the point of numbering it. */
  function secAnswers() {
    function put(id, txt) {
      var el = document.getElementById(id);
      var c = el && el.querySelector('.ldp-sechead__c');
      if (c) c.textContent = txt || '';
    }
    var PE = window.LAYERD && window.LAYERD.pricingElements;
    var sv = PE && PE.servingsNow ? PE.servingsNow() : 0;
    /* r54 follow-up (Mariya: the collapsed dollar lines dropped the $) - the
       summary answers on 02/03/04 carry the currency again. CF.fmt and the
       quote total already format with the symbol the baker set in toolkit
       settings, so we just stop stripping it. */
    put('ldp-servings', sv > 0 ? sv + ' servings' : '');
    try {
      var CF = window.LDP_COSTFIRST;
      var band = document.querySelector('.ldp-complexity-btn.is-active');
      var k = band ? band.getAttribute('data-complexity') : 'simple';
      /* r215: 02 answers with the CAKE break-even (its card is cake-only
         now); 03 answers with the everything-in BASE PRICE (the cake rate
         it charges plus the flat element fees) - the same number the base
         price rows show. */
      if (CF && CF.cakeFloorFor && CF.fmt) {
        var f = CF.cakeFloorFor(k || 'simple');
        put('mcs1Card', f > 0 ? CF.fmt(f) + '/sv' : '');
      }
      if (CF && CF.activeCakeRateFor && CF.fmt) {
        var cakeR = CF.activeCakeRateFor(k || 'simple');
        var elSvAns = 0;
        try { if (PE && PE.total && sv > 0) elSvAns = PE.total(sv) / sv; } catch (eEA) { elSvAns = 0; }
        var base0 = cakeR + elSvAns;
        put('ldp-design', base0 > 0 ? CF.fmt(base0) + '/sv' : '');
      }
    } catch (e) { }
    var n = 0;
    try { n = (PE && PE.list ? PE.list(sv || 0) : []).length; } catch (eN) { n = 0; }
    /* round 54 (Mariya): just the count - "2", not "2 on" */
    put('ldpElementsCard', n ? String(n) : '');
    /* r54 follow-up: the elements answer is a bare count ("2"), no dollar
       figure, so the eyebrow is just "Elements" - the currency indicator it
       used to carry was for the bare-number model, now reverted. */
    (function elCurrency() {
      var t = document.querySelector('#ldpElementsCard .ldp-sechead__t');
      if (t) t.textContent = 'Elements';
    })();
    /* r211: the headline is the cake's price, pre-tax - that is what the
       margin and the break-even are built on. With tax ticked the card
       under it ends on a bigger Total, so the answer says which one it is
       rather than leaving two figures on screen that disagree. */
    var tot = document.getElementById('ldpStripTotal');
    var quoteTxt = tot && tot.textContent ? tot.textContent.trim() : '';
    var taxOn = document.getElementById('ldpTaxToggle');
    if (quoteTxt && taxOn && taxOn.checked) {
      var tn = document.getElementById('ldpTaxLabel');
      quoteTxt += ' + ' + ((tn && tn.value ? tn.value : 'tax').trim() || 'tax');
    }
    put('ldp-quote', quoteTxt);
  }
  /* r210 (Mariya, live view): the running total and the units pill BELONG
     AT THE TOP — "the first thing they see". r209 moved the strip's slot
     to the page's end so sticky-bottom would pin; that traded the thing
     she wants seen first for a behaviour she never asked for. The slot
     stays exactly where the template puts it. */
  /* ONE handler for every derived line outside the modules - the heads'
     answers and the cover verdicts move together or the page lies. Wired
     to every trigger, because the heads updating while the verdicts sat
     stale is exactly the bug this round replaces. */
  function secSync() {
    secAnswers();
    try { if (window.LDP_SECTIONS && window.LDP_SECTIONS.refresh) window.LDP_SECTIONS.refresh(); } catch (e) { }
  }
  secSync();
  window.addEventListener('layerd:pricing-changed', function () { setTimeout(secSync, 0); });
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.id === 'ldpServingsCount') setTimeout(secSync, 0);
  });
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && (t.id === 'ldpCalcBtn' || (t.closest && t.closest('#ldpCalcBtn, .ldp-complexity-btn')))) setTimeout(secSync, 80);
  });

  /* ============ r220 (round 53 design): the index-rail shell ============
     Placement only - the four sections keep every field, control and value.
     Desktop (>=900): a sticky left rail (identity + the four steps as a live
     index) and a right column (the pinned quote + the one open step as a
     panel). The rail steps are NAVIGATION - opening one closes the others.
     Mobile (<900): the rail hides and the existing accordion stands, under
     the quote. Reuses the painters, the answers and secSync above - no new
     open/close machinery, no duplicated math. */
  (function railShell() {
    /* 2026-09-17 (Mariya: "full match" — Pricing takes the shared nav sidebar
       like every other tool, not its own bespoke rail). The rail is retired
       (kept behind one return so it is one line to restore): learn-components.js
       mounts the .lh-tabbar sidebar on .ldpc and Pricing runs its normal
       single-column content beside it. */
    return;
    /* eslint-disable no-unreachable */
    var wrap = document.querySelector('.ldp-wrap');
    if (!wrap || document.querySelector('.ldc-pr')) return;
    var cols = wrap.querySelector('.ldp-cols');
    var strip = document.getElementById('ldpQuoteStrip');
    var chipRow = wrap.querySelector('.ld-cakechip-row');
    var headBand = wrap.querySelector('.ldp-head');
    if (!cols) return;
    /* whichever of the numbered steps this tier actually renders - the free
       page has no "What it costs you" (that cost breakdown is Pro), so it runs
       three steps, not four. The rail builds from what is present. */
    var PRESENT = QUESTIONS.filter(function (id) { return document.getElementById(id); });
    if (PRESENT.length < 2) return;

    function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
    /* the section's own numeral - the page renumbers per tier (visitor is
       01-03), so read it live rather than trust the static map. */
    function numOf(id) {
      var sec = document.getElementById(id);
      var n = sec && sec.querySelector(':scope > .ldp-sechead .ldp-sechead__n');
      return (n && n.textContent.trim()) || NUM[id] || '';
    }
    var stepWord = ({ 2: 'two', 3: 'three', 4: 'four', 5: 'five' })[PRESENT.length] || String(PRESENT.length);

    /* r225 (Mariya, from the design-system mockup): the DESKTOP view is the
       round-53 rail - a plum identity card (the page title + the client chip
       relocated into it), the inches pill, and the step index down the left;
       and a working column with the quote bar (the running total + a Next
       button) and the one open step as a panel. This is desktop-only chrome:
       below 900px the CSS keeps the phone view untouched - the hero band, the
       chip in place, the accordion. The quote is the app's LIVE strip element,
       moved in (not a mirror - r220's mirror-into-a-span went stale + printed
       empty). */
    wrap.classList.add('ldc-pr-host');
    var pr = el('div', 'ldc-pr'); var grid = el('div', 'ldc-pr__grid');
    var rail = el('div', 'ldc-pr__rail'); var main = el('div', 'ldc-pr__main');
    pr.appendChild(grid); grid.appendChild(rail); grid.appendChild(main);

    /* identity card: the page title (read from the hero band) + the client
       chip, relocated. On mobile the CSS strips it back to the bare chip and
       shows the hero band above, so the phone view is unchanged. */
    var idc = el('div', 'ldc-pr__id');
    /* 2026-09-17 (Mariya: every page needs a "← Toolkit" back link like the
       Planner). The rail hides .ldp-head (with its own back link, layout.css ~35),
       so carry that link into the rail so Pricing keeps the back door on desktop. */
    try {
      var backEl = document.querySelector('.ldp-head__back');
      var backA = el('a', 'ldc-pr__idback', (backEl && backEl.textContent.trim()) || '← Toolkit');
      backA.setAttribute('href', (backEl && backEl.getAttribute('href')) || '/pages/studio');
      idc.appendChild(backA);
    } catch (eBk) { }
    var kick = '', title = 'Pricing';
    try {
      if (headBand) {
        var kEl = headBand.querySelector('.ld-headband__kicker, [class*=kicker], [class*=eyebrow]');
        var tEl = headBand.querySelector('.ld-headband__title, h1, h2, [class*=title]');
        if (kEl) kick = kEl.textContent.trim();
        if (tEl) title = tEl.textContent.trim();
      }
    } catch (e) { }
    idc.appendChild(el('div', 'ldc-pr__idkick', kick || 'LAYER’D TOOLKIT'));
    idc.appendChild(el('div', 'ldc-pr__idtitle', title || 'Pricing'));
    idc.appendChild(el('div', 'ldc-pr__idbar'));
    if (chipRow) { chipRow.classList.add('ldc-pr__clientmount'); idc.appendChild(chipRow); }
    rail.appendChild(idc);

    /* a rail slot for the inches pill; it is populated once the quote exists
       (below), because on mobile the pill rides with the quote instead. */
    var unitSlot = el('div', 'ldc-pr__unitslot');
    rail.appendChild(unitSlot);

    /* the index - the steps this tier has, desktop nav */
    var index = el('div', 'ldc-pr__index');
    index.appendChild(el('div', 'ldc-pr__indexlabel', 'The ' + stepWord + ' steps'));
    var railSteps = {};
    PRESENT.forEach(function (id) {
      var step = el('button', 'ldc-pr__step');
      step.type = 'button';
      step.innerHTML = '<span class="ldc-pr__num">' + numOf(id) + '</span>' +
        '<span class="ldc-pr__stepname">' + TITLE[id] + '</span>' +
        '<span class="ldc-pr__stepans"></span>';
      step.addEventListener('click', function () { openOnly(id); });
      index.appendChild(step);
      railSteps[id] = step;
    });
    rail.appendChild(index);

    /* the quote bar: the app's live strip, moved in, + the Next button. The
       Next button is the design-system pipeline control that sits WITH the
       quote (not a stray redirect); its target is the next tool, discovered
       from the subnav and scoped to the open file. */
    var quote = el('div', 'ldc-pr__quote');
    if (strip) { strip.style.display = ''; quote.appendChild(strip); }
    /* 2026-09-17 (Mariya: remove the "Next: →" buttons on every tool). The rail's
       "Next: Structure →" is gone; the sidebar + the "← Toolkit" back link are the
       navigation now, same as every other tool. */
    main.appendChild(quote);

    /* place the inches pill: the rail slot on DESKTOP (the design), the quote
       on MOBILE (the phone view is untouched). A media-query listener re-places
       it across the break; a short observer catches its async mount + any
       re-glue by liftUnitChip. */
    var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: true };
    /* round 54 (Mariya: "the client chip is not attached to the hero, like
       the other pages"). The suite attaches the chip in learn-components.css
       via `header.ld-headband + .ld-cakechip-row` - a SIBLING selector - so
       the moment railShell moved the chip into the identity card, every
       page-standard attachment rule stopped matching. On mobile the chip
       goes back to being the headband's next sibling and the suite's own
       rules take over; the identity card keeps it on desktop. */
    function placeChip() {
      if (!chipRow) return;
      if (mqDesk.matches) {
        if (chipRow.parentNode !== idc) idc.appendChild(chipRow);
        chipRow.classList.add('ldc-pr__clientmount');
      } else {
        var hb = document.querySelector('.ldp-head');
        if (hb && hb.parentNode && chipRow.previousElementSibling !== hb) {
          hb.parentNode.insertBefore(chipRow, hb.nextSibling);
        }
        chipRow.classList.remove('ldc-pr__clientmount');
      }
    }
    placeChip();
    try { if (mqDesk.addEventListener) mqDesk.addEventListener('change', placeChip); else if (mqDesk.addListener) mqDesk.addListener(placeChip); } catch (eC) { }
    function placeInches() {
      var u = document.querySelector('.ld-unitchip-row');
      if (!u) return;
      u.classList.add('ldc-pr__unitrow');
      if (mqDesk.matches) {
        if (u.parentNode !== unitSlot) unitSlot.appendChild(u);
      } else {
        /* round 54 (Mariya: "should not be inside of the overall quote box
           ... its own button at the bottom"): its own pill row directly
           BELOW the plum quote block, never inside it. */
        if (!(u.parentNode === main && u.previousElementSibling === quote)) {
          main.insertBefore(u, quote.nextSibling);
        }
      }
    }
    placeInches();
    try { if (mqDesk.addEventListener) mqDesk.addEventListener('change', placeInches); else if (mqDesk.addListener) mqDesk.addListener(placeInches); } catch (e) { }
    /* r227 (Mariya: Pricing flashing/unclickable): the pill mounts async, so a
       few bounded retries catch it - NOT a persistent document.body observer.
       That observer, firing setTimeout(placeInches) on every page mutation
       while liftUnitChip kept gluing the same pill back to the strip, was the
       infinite reflow loop. liftUnitChip now yields to the rail (above), and
       there is no body observer left to loop. */
    [300, 900, 1800].forEach(function (ms) { setTimeout(placeInches, ms); });

    /* each section gets a static panel head for the desktop panel (the design
       shows the open step titled inside its card); its chevron head stays for
       the mobile accordion. */
    var pheads = {};
    PRESENT.forEach(function (id) {
      var sec = document.getElementById(id);
      var ph = el('div', 'ldc-pr__phead',
        '<span class="ldc-pr__pnum">' + numOf(id) + '</span>' +
        '<span class="ldc-pr__ptitle">' + TITLE[id] + '</span>' +
        '<span class="ldc-pr__pline"></span>' +
        '<span class="ldc-pr__pans"></span>');
      sec.insertBefore(ph, sec.firstChild);
      pheads[id] = ph;
    });

    /* seat the shell where the section column was, then move the sections +
       foot into the working column. */
    wrap.insertBefore(pr, cols);
    main.appendChild(cols);
    var foot = wrap.querySelector('.ldp-foot');
    if (foot) main.appendChild(foot);

    /* one open at a time on the rail (design: nav, not accordion) */
    function openOnly(id) {
      PRESENT.forEach(function (other) {
        var want = (other === id);
        if (painters[other]) { painters[other](want); remember(other, want); }
      });
      paintRail();
      secSync();
    }
    function paintRail() {
      PRESENT.forEach(function (id) {
        var sec = document.getElementById(id);
        var open = sec && !sec.classList.contains('is-shut');
        if (railSteps[id]) railSteps[id].setAttribute('aria-current', open ? 'true' : 'false');
      });
    }

    /* mirror each head's answer into the rail step AND the panel head. The
       quote step reports the running total from the strip. */
    var mirror = function () {
      var tot = document.getElementById('ldpStripTotal');
      PRESENT.forEach(function (id) {
        var sec = document.getElementById(id);
        var c = sec && sec.querySelector(':scope > .ldp-sechead .ldp-sechead__c');
        var ans = c ? c.textContent : '';
        if (id === 'ldp-quote' && tot && tot.textContent.trim()) ans = tot.textContent.trim();
        var rs = railSteps[id] && railSteps[id].querySelector('.ldc-pr__stepans');
        var ps = pheads[id] && pheads[id].querySelector('.ldc-pr__pans');
        if (rs) rs.textContent = ans;
        if (ps) ps.textContent = ans;
      });
      paintRail();
    };
    /* fold the mirror into secSync so the rail never goes stale */
    var _secSync = secSync;
    secSync = function () { _secSync(); mirror(); };
    window.addEventListener('layerd:pricing-changed', function () { setTimeout(mirror, 0); });
    /* the strip total re-renders on the pricing engine's own schedule (not
       always through secSync), so watch it directly - that keeps the quote
       step in step with the pinned total. */
    var totEl = document.getElementById('ldpStripTotal');
    if (totEl && window.MutationObserver) {
      new MutationObserver(function () { mirror(); }).observe(totEl, { childList: true, characterData: true, subtree: true });
    }

    /* start on "what you charge" (the design's open step) when the tier has
       it, else the first step, one open */
    /* round 54 (Mariya): the flow starts where the quote starts - step 01,
       the cake - open by default; everything else collapsed to its answer. */
    openOnly(PRESENT.indexOf('ldp-servings') >= 0 ? 'ldp-servings' : PRESENT[0]);
    /* r54 follow-up (Mariya): on the phone the quote reads open by default too,
       like your cake, so the running total is in view without a tap. The
       desktop rail stays one-panel-at-a-time (its nav model), so this is
       mobile-only. Painted, not remembered - same as 01, it reopens each load. */
    if (!mqDesk.matches && PRESENT.indexOf('ldp-quote') >= 0 && painters['ldp-quote']) {
      painters['ldp-quote'](true);
    }
    mirror();
  })();

  /* ---- the note at the top of step 01 ----
     Her instruction: base cover carries a note pointing at the cost
     section. It is the one place the two connect — these rows show the
     prices, that section decides them. */
  (function coverNote() {
    var sec = document.getElementById('ldp-design');
    if (!sec || sec.querySelector('.ldp-covernote')) return;
    var body = sec.querySelector('.ldp-secbody') || sec;
    var p = document.createElement('p');
    p.className = 'ldp-covernote';
    /* r132 (Mariya: "what is the base price I'm using before the add ons
       and the elements? ... There is a missing flow here"). Nothing on
       screen said which number actually prices the cake. THIS one does;
       the floor is the minimum it has to clear. The old copy also
       pointed "below" at a module r130 moved ABOVE it - stale twice. */
    /* r147, her approved short copy */
    /* r176 (Mariya: "I find it rather wordy now. Maybe it should just
       stick to the first line saying, this rate must clear your
       breakeven"). The derivation line above now explains where the
       number comes from, so this one only has to say what it must
       beat. */
    p.hidden = true;   /* r209: the cover rows say it themselves now */
    p.innerHTML = 'this rate must clear ' +
      '<button type="button" class="ldp-covernote__go">your break-even</button>.';
    body.insertBefore(p, body.firstChild);
    p.querySelector('.ldp-covernote__go').addEventListener('click', function () {
      /* an explicit navigation click - the one case the scroll rule allows */
      var card = document.getElementById('mcs1Card') || document.getElementById('ldpFreeFloor');
      if (!card) return;
      var expand = document.getElementById('mcs1ExpandBtn');
      if (expand) expand.click();
      try { card.scrollIntoView({ block: 'start' }); } catch (e) { }
    });
  })();

  /* ---- base cover: 10a's two option rows, each stating its saved price ---- */
  (function coverRows() {
    var grid = document.querySelector('.ldp-complexity-grid');
    if (!grid) return;
    grid.classList.add('ldp-coverrows');

    /* r215 (Mariya's redesign): the profit margin is set HERE, in "what you
       charge" - not in "what it costs you". It sits above the two cover
       rows it prices. The math lives in the premium closure; this reads and
       writes it through LDP_COSTFIRST.margin and repaints. */
    function CF() { return window.LDP_COSTFIRST; }
    function marginPct() { var c = CF(); return (c && c.margin) ? c.margin.get() : 30; }
    if (CF() && CF().margin && !grid.parentNode.querySelector('.ldp-marginctl')) {
      var mc = document.createElement('div');
      mc.className = 'ldp-marginctl';
      mc.innerHTML =
        '<span class="ldp-marginctl__k">Profit margin</span>' +
        '<span class="ldp-marginctl__s">on top of your break-even</span>' +
        '<button type="button" class="ldp-marginctl__b" data-mstep="-1" aria-label="Lower the profit margin">−</button>' +
        '<span class="ldp-marginctl__v"></span>' +
        '<button type="button" class="ldp-marginctl__b" data-mstep="1" aria-label="Raise the profit margin">+</button>';
      grid.parentNode.insertBefore(mc, grid);
      var mval = mc.querySelector('.ldp-marginctl__v');
      function paintMargin() { mval.textContent = marginPct() + '%'; }
      paintMargin();
      mc.addEventListener('click', function (ev) {
        var b = ev.target && ev.target.closest ? ev.target.closest('[data-mstep]') : null;
        if (!b) return;
        var c = CF();
        if (!c || !c.margin) return;
        c.margin.set(marginPct() + parseInt(b.getAttribute('data-mstep'), 10));
        if (c.render) c.render();
        paintMargin();
        sync();
        if (c.recalc) c.recalc();
      });
    }

    /* r209: the design's BASE COVER eyebrow above the two rows */
    if (!grid.parentNode.querySelector('.ldp-subeyebrow')) {
      var eb = document.createElement('div');
      eb.className = 'ldp-subeyebrow';
      eb.textContent = 'Base price';
      grid.parentNode.insertBefore(eb, grid);
    }

    /* r215 (her note: the studio rate is a default starting point, not the
       best option - her own data is. So the tool leads with her computed
       price and offers the studio number as a reset). This line reflects
       the ACTIVE cover's rate: on her computed price by default, with a
       reset to studio; on studio, it recommends going back to her own. */
    var rmc = null;
    if (CF() && CF().rateModeFor) {
      rmc = document.createElement('div');
      rmc.className = 'ldp-ratemode';
      grid.parentNode.insertBefore(rmc, grid.nextSibling);
      rmc.addEventListener('click', function (ev) {
        var b = ev.target && ev.target.closest ? ev.target.closest('[data-rate-act]') : null;
        if (!b) return;
        var c = CF(); if (!c) return;
        var on = grid.querySelector('.ldp-complexity-btn.is-active') || grid.querySelector('.ldp-complexity-btn');
        var key = on ? on.getAttribute('data-complexity') : 'simple';
        var act = b.getAttribute('data-rate-act');
        if (act === 'studio' && c.resetToStudio) c.resetToStudio(key);
        else if (act === 'computed' && c.useComputedRate) c.useComputedRate(key);
        if (c.render) c.render();
        sync();
        if (c.recalc) c.recalc();
      });
    }

    function sync() {
      var c = CF();
      var mp = marginPct();
      var mv = grid.parentNode.querySelector('.ldp-marginctl__v');
      if (mv) mv.textContent = mp + '%';
      if (rmc && c && c.rateModeFor) {
        var onB = grid.querySelector('.ldp-complexity-btn.is-active') || grid.querySelector('.ldp-complexity-btn');
        var ak = onB ? onB.getAttribute('data-complexity') : 'simple';
        var mode = c.rateModeFor(ak);
        if (mode === 'studio') {
          rmc.innerHTML = '<span class="ldp-ratemode__k ldp-ratemode__k--warn">using the studio default</span>' +
            '<button type="button" class="ldp-ratemode__b" data-rate-act="computed">use your computed price</button>';
        } else if (mode === 'custom') {
          /* 2026-09-27: a saved rate had no direct way back to her computed
             price (only "reset to studio", then a second tap). Offer both. */
          rmc.innerHTML = '<span class="ldp-ratemode__k">your saved rate</span>' +
            '<span style="display:inline-flex;flex-wrap:wrap;gap:14px">' +
              '<button type="button" class="ldp-ratemode__b" data-rate-act="computed">use your computed price</button>' +
              '<button type="button" class="ldp-ratemode__b" data-rate-act="studio">reset to studio</button>' +
            '</span>';
        } else {
          rmc.innerHTML = '<span class="ldp-ratemode__k">priced from your costs</span>' +
            '<button type="button" class="ldp-ratemode__b" data-rate-act="studio">use the studio default</button>';
        }
      }
      Array.prototype.forEach.call(grid.querySelectorAll('.ldp-complexity-btn'), function (btn) {
        var key = btn.getAttribute('data-complexity');
        var slot = btn.querySelector('.ldp-complexity-detail');
        if (!slot) return;
        /* r215: the row shows the EXPECTED BASE PRICE per serving, the same
           everything-in number the quote charges:
             cake break-even -> + margin -> cake price (cakeBaseFor)
             + the flat fees for the elements chosen (their own prices)
           So 03 and the quote can never disagree. */
        if (c && c.activeCakeRateFor && c.cakeFloorFor) {
          var cakeAtMargin = c.activeCakeRateFor(key);   /* what the quote charges: computed default, or pinned */
          var beCake = c.cakeFloorFor(key);        /* cake break-even, cost only */
          var PEl = window.LAYERD && window.LAYERD.pricingElements;
          var sv = 0;
          try { sv = (window.LAYERD.pricingCake && window.LAYERD.pricingCake.servings()) || 0; } catch (eS) { sv = 0; }
          if (!(sv > 0)) { try { sv = (PEl && PEl.servingsNow ? PEl.servingsNow() : 0) || 0; } catch (eS2) { sv = 0; } }
          var elFeeSv = 0;
          try { if (PEl && PEl.total && sv > 0) elFeeSv = PEl.total(sv) / sv; } catch (eE) { elFeeSv = 0; }
          var base = cakeAtMargin + elFeeSv;
          slot.innerHTML = '<span class="ldp-cover__v">' +
            (c.fmt ? c.fmt(base) : base.toFixed(2)) + '</span>' +
            '<span class="ldp-cover__u">/sv</span>';
          var subOld = btn.querySelector('.ldp-cover__sub');
          if (subOld) subOld.parentNode.removeChild(subOld);
          if (beCake > 0 && base > 0) {
            var sub = document.createElement('span');
            sub.className = 'ldp-cover__sub';
            var fm = function (v) { return c.fmt ? c.fmt(v) : v.toFixed(2); };
            var elTxt = (elFeeSv > 0.005 ? ' + elements ' + fm(elFeeSv) + '/sv' : '');
            /* 2026-09-27 (Mariya: "break even is $3.52 + 30% margin but it's
               calculating $9.70 - that seems way off"). This line always said
               "break-even + target margin", but a PINNED rate (applied earlier
               and saved, reset to studio, or typed) is not derived from today's
               break-even at all - it is a fixed number, so the two disagreed.
               Computed: unchanged wording. Pinned: say it is a saved rate and
               show the margin that rate actually makes on today's break-even.
               Display only - the rate charged is untouched. */
            var rmode = c.rateModeFor ? c.rateModeFor(key) : 'computed';
            if (rmode === 'computed') {
              sub.innerHTML = 'break-even ' + fm(beCake) + ' + ' + mp + '% margin' + elTxt;
            } else {
              var who = rmode === 'studio' ? 'studio default' : 'your saved rate';
              var realM = cakeAtMargin > 0 ? Math.round((cakeAtMargin - beCake) / cakeAtMargin * 100) : 0;
              sub.innerHTML = cakeAtMargin >= beCake
                ? who + ' &middot; ' + realM + '% margin on break-even ' + fm(beCake) + elTxt
                : who + ' &middot; below break-even ' + fm(beCake) + elTxt;
            }
            var t = btn.querySelector('.ldp-complexity-title');
            if (t && t.parentNode) t.parentNode.insertBefore(sub, t.nextSibling);
          }
        }
      });
    }
    sync();
    grid.addEventListener('click', function () { setTimeout(sync, 0); });
    window.addEventListener('load', sync);
    /* r209: the verdicts divide by the serving count, so they re-derive
       with the quote - without this they were computed once at load,
       against the studio-typical count instead of the page's */
    var syncPending = false;
    window.addEventListener('layerd:pricing-changed', function () {
      if (syncPending) return;
      syncPending = true;
      setTimeout(function () { syncPending = false; sync(); }, 0);
    });
    window.LDP_SECTIONS = { refresh: sync };
  })();

  /* ---- r116b: the cost fold nested inside step 01 ----
     Its own remembered state, separate from the four section folds: this
     one is studio setup and most quotes never open it. */
  (function costFold() {
    var fold = document.getElementById('mcs1Fold');
    var box = document.getElementById('mcs1Box');
    if (!fold || !box) return;
    var KEY = 'layerd-pricing-costfold';
    function paint(open) {
      box.hidden = !open;
      fold.setAttribute('aria-expanded', open ? 'true' : 'false');
      fold.classList.toggle('is-open', open);
    }
    var start = false;
    try { start = localStorage.getItem(KEY) === '1'; } catch (e) { }
    paint(start);
    fold.addEventListener('click', function () {
      var open = box.hidden;
      paint(open);
      try { localStorage.setItem(KEY, open ? '1' : '0'); } catch (e) { }
    });
  })();

  /* ---- the counts in the heads ---- */
  (function counts() {
    var res = document.getElementById('ldpResults');
    function sync() {
      /* r216 (Mariya: the elements header flashes between "1 on" and "1 on
         this cake"). secAnswers owns the elements answer now (and its
         currency eyebrow); this older writer was racing it on every
         recalc. It keeps the market and add-on counts, which secAnswers
         does not set. */
      var mk = document.getElementById('ldp-market');
      if (mk) {
        var mv = document.getElementById('ldpMStepVal');
        var s3 = mk.querySelector('.ldp-sechead__c');
        if (s3) s3.textContent = mv ? mv.textContent.replace(/\s+/g, '') : '';
      }
      var ad = document.getElementById('ldp-addons');
      if (ad) {
        var n = ad.querySelectorAll('input[type="checkbox"]:checked').length;
        var s2 = ad.querySelector('.ldp-sechead__c');
        if (s2) s2.textContent = n ? n + ' added' : '';
      }
    }
    sync();
    document.addEventListener('click', function () { setTimeout(sync, 0); }, true);
    document.addEventListener('change', function () { setTimeout(sync, 0); }, true);
    if (res) new MutationObserver(sync).observe(res, { childList: true, subtree: true });
  })();
})();

/* ---------- r114: "Your cake" folds when a file is attached ----------
   Her call on the handoff's silence here. 11b draws no servings or tier
   section at all — Pricing "reads them, never re-asks" — but the handoff
   also says to fall back to the local tier editor when nothing is
   attached. Both are true at once: scoped, the client chip already states
   the tiers and the servings, so the builder folds to a summary line and
   opens on a tap; unscoped, it is the only way to describe the cake and
   stays exactly as it is.

   Nothing about the cake is hidden — the summary states it — and nothing
   is read-only. This is a fold, not a removal. */
(function initLdpCakeFold() {
  /* round 54 (Mariya: "You'll click your cake, and then your cake comes up
     again"). The numbered accordion IS the fold now - the 01 head carries
     the summary and the collapse - so this second "Your cake" bar stacked
     a fold inside a fold on a scoped file. Retired; nothing else changes:
     the builder still lives in 01, scoped or not. */
  return;
  var sec = document.getElementById('ldp-servings');
  if (!sec || sec.querySelector('.ldp-cakefold')) return;

  function scoped() {
    try { return !!(window.ldpQuoteBooking && window.ldpQuoteBooking()); }
    catch (e) { return false; }
  }
  if (!scoped()) return;                  /* one-off cake: leave it open */

  var head = sec.querySelector('.ldp-sec__head') || sec.querySelector('.ldp-heading-sm');
  var body = document.createElement('div');
  body.className = 'ldp-cakebody';
  body.hidden = true;
  [].slice.call(sec.children).forEach(function (k) {
    if (k !== head) body.appendChild(k);
  });
  if (head && head.parentNode) head.parentNode.removeChild(head);

  var row = document.createElement('button');
  row.type = 'button';
  row.className = 'ldp-cakefold';
  row.setAttribute('aria-expanded', 'false');
  row.innerHTML =
    '<span class="ldp-cakefold__k">Your cake</span>' +
    '<span class="ldp-cakefold__s"></span>' +
    '<span class="ldp-cakefold__x" aria-hidden="true">&rsaquo;</span>';
  sec.appendChild(row);
  sec.appendChild(body);
  row.addEventListener('click', function () {
    var open = body.hidden;
    body.hidden = !open;
    sec.classList.toggle('is-open', open);
    row.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* the summary reads the figures the page already rendered — never a
     second calculation of the same cake */
  function sync() {
    var bits = [];
    var rows = document.querySelectorAll('.ldp-tier-row');
    if (rows.length) bits.push(rows.length + (rows.length === 1 ? ' tier' : ' tiers'));
    var m = /(\d[\d,]*)\s*servings/.exec(
      (document.getElementById('ldpResults') || {}).textContent || '');
    if (m) bits.push(m[1] + ' servings');
    row.querySelector('.ldp-cakefold__s').textContent = bits.join(' · ');
  }
  sync();
  var res = document.getElementById('ldpResults');
  if (res) new MutationObserver(sync).observe(res, { childList: true, subtree: true });
  window.addEventListener('load', sync);
})();

/* ============ r175: THE QUOTE SHEET MARKUP (shared) ============
   Moved here from the premium bundle so BOTH tiers build the identical
   document: premium prints it, free shows it watermarked as the Pro
   preview. One copy is the whole point - a preview that drifts from the
   product is worse than no preview.
   Pure markup from a model object: no rates, no policies, no costing.
   `m` carries everything; this function invents nothing. */
/* r222 (Mariya: "a colour option in settings for a brand colour to use as
   their invoice colour"). The studio's chosen accent, or '' for the calm
   default. Only a real hex is honoured, so a stray value can never paint the
   sheet. The caller sets it as --ldq-accent on the sheet host; the print
   window inherits it through the host's outerHTML. */
window.ldqAccentColor = function () {
  try {
    var v = (localStorage.getItem('layerd-studio-color') || '').trim();
    return /^#[0-9a-fA-F]{6}$/.test(v) ? v : '';
  } catch (e) { return ''; }
};
window.ldqApplyAccent = function (host) {
  if (!host) return;
  var ac = window.ldqAccentColor();
  if (ac) host.style.setProperty('--ldq-accent', ac);
  else host.style.removeProperty('--ldq-accent');
};
window.ldqBuildSheetHtml = function (m) {
  function esc(x) { return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function get(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  var studioName = get('layerd-studio-name').trim();
  var contact = get('layerd-studio-contact').trim();
  var logo = get('layerd-studio-logo');
  var h = '';
  /* header: letterhead left, quote meta right */
  h += '<header class="ldq-head"><div class="ldq-brand">';
  if (logo) h += '<div class="ldq-logo" role="img" aria-label="Studio logo" style="background-image:url(' + logo.replace(/"/g, '') + ')"></div>';
  else h += '<div class="ldq-name">' + esc(studioName || 'Your studio') + '</div>';
  h += '</div><div class="ldq-meta"><div class="ldq-word">' +
    (m.invoice ? 'invoice' : 'quote') + '</div><div class="ldq-metagrid">';
  if (m.no) h += '<span class="ldq-k">no.</span><span>' + esc(m.no) + '</span>';
  h += '<span class="ldq-k">issued</span><span>' + esc(m.issued) + '</span>';
  if (m.validUntil) h += '<span class="ldq-k">valid until</span><span>' + esc(m.validUntil) + '</span>';
  h += '</div></div></header><div class="ldq-rule"></div>';
  /* prepared for + event facts */
  h += '<div class="ldq-facts">';
  if (m.client) {
    h += '<div class="ldq-col"><div class="ldq-k ldq-k--head">prepared for</div>' +
      '<div class="ldq-client">' + esc(m.client) + '</div></div>';
  }
  /* r157 (Mariya: "an 'event' section with nothing next to it"). This
     heading exists to sit opposite "prepared for". With no client the
     left column is never built, leaving a label alone over the only
     block on screen - it labels nothing and reads as a gap. */
  h += '<div class="ldq-col">' + (m.client ? '<div class="ldq-k ldq-k--head">event</div>' : '') +
    '<div class="ldq-eventgrid">';
  if (m.eventDate) h += '<span class="ldq-k">date</span><span>' + esc(m.eventDate) + '</span>';
  h += '<span class="ldq-k">servings</span><span>' + esc(m.servings) + '</span>';
  if (m.tiers) h += '<span class="ldq-k">tiers</span><span>' + esc(m.tiers) + '</span>';
  if (m.flavours) h += '<span class="ldq-k">flavours</span><span>' + esc(m.flavours) + '</span>';
  h += '</div></div></div>';
  /* line items */
  h += '<div class="ldq-items"><div class="ldq-ithead"><span>description</span><span class="ldq-r">qty</span><span class="ldq-r">amount</span></div>';
  (m.lines || []).forEach(function (l) {
    /* r54 follow-up (Mariya): a line can carry dLines - each its own row of
       description - so the cake spec prints the sizes on one line and the
       finish on the next, instead of one run-on sentence. Falls back to the
       flat .d string for every other line. */
    var desc = (l.dLines && l.dLines.length)
      ? l.dLines.map(function (x) { return '<div class="ldq-id">' + esc(x) + '</div>'; }).join('')
      : (l.d ? '<div class="ldq-id">' + esc(l.d) + '</div>' : '');
    h += '<div class="ldq-item"><div><div class="ldq-it">' + esc(l.t) + '</div>' +
      desc + '</div>' +
      '<div class="ldq-r ldq-iv">1</div><div class="ldq-r ldq-iv">' + esc(l.v) + '</div></div>';
  });
  h += '<div class="ldq-totwrap"><div class="ldq-totals">' +
    '<span>Subtotal</span><span class="ldq-r">' + esc(m.subtotal) + '</span>';
  if (m.taxLine) h += '<span>' + esc(m.taxLine) + '</span><span class="ldq-r">' + esc(m.taxAmount) + '</span>';
  h += '<div class="ldq-totrule"></div>' +
    '<span class="ldq-tot">Total</span><span class="ldq-r ldq-totv">' + esc(m.total) + '</span>' +
    '</div></div></div>';
  /* deposit + balance panels */
  h += '<div class="ldq-panels"><div class="ldq-panel"><div class="ldq-k">' + esc(m.depositLabel) + '</div>' +
    '<div class="ldq-pv">' + esc(m.deposit) + '</div>' +
    '<div class="ldq-ps">' + (m.invoice ? 'Received. Thank you.' : 'Due at booking. Reserves your date.') + '</div></div>' +
    '<div class="ldq-panel"><div class="ldq-k">' + (m.invoice ? 'final payment' : 'balance') + '</div>' +
    '<div class="ldq-pv">' + esc(m.balance) + '</div>' +
    '<div class="ldq-ps">' + esc(m.balanceWhen) + '</div></div></div>';
  /* thank-you + footer */
  /* r148 (Mariya: "the messaging doesn't even make sense... we don't
     need to send a deposit invoice"). The note stops promising an
     invoice flow that does not exist; the deposit panel above already
     says what is due and when. */
  /* r148b: her note, its own labelled block above the thank-you */
  if (m.note) {
    h += '<div class="ldq-notesblk"><div class="ldq-k ldq-k--head">notes</div>' +
      '<p class="ldq-notestxt">' + esc(m.note) + '</p></div>';
  }
  h += '<div class="ldq-foot"><p class="ldq-note">' + (m.invoice
    ? 'Thank you for trusting us with your day. The final payment above completes your order.'
    : 'Thank you for thinking of us for your day.' +
      (m.validNote ? ' Everything above is held for you until the valid-until date.' : '') +
      ' When you are ready to go ahead, just reply and we will confirm your date.') + '</p>' +
    '<div class="ldq-rule"></div><div class="ldq-footrow"><div class="ldq-contacts">' +
    (contact ? '<span>' + esc(contact) + '</span>' : '') + '</div>' +
    (m.no ? '<div class="ldq-k">quote ' + esc(m.no) + '</div>' : '') + '</div></div>';
  return h;
};

/* ============ r176: the base-cover derivation, BOTH tiers ============
   Mariya: "the free version doesn't seem to follow the changes we make in
   the pro version. We need to make sure these are always aligned."
   It lived in the premium bundle, which free never loads - so the line
   Pro users got simply did not exist for the people it was written to
   convince. This file loads on both tiers, so it lives here now.

   Free shows a RANGE per cover; its low end IS the recommended rate
   (r63), so the same arithmetic explains both tiers' leading number.
   Shortened on her note that it had grown wordy: the sum, nothing else. */
window.ldpSyncCoverWhy = function () {
  var grid = document.querySelector('.ldp-complexity-grid.ldp-coverrows')
    || document.querySelector('.ldp-complexity-grid');
  if (!grid) return;
  /* read the island, not the module's CFG: this block is appended after
     the file's IIFE closes, so CFG is out of scope here. Same trap that
     bit MC in the premium bundle (r165) - in these files, a top-level
     helper must assume every alias it wants belongs to someone else. */
  var CFGX = null;
  try { CFGX = JSON.parse(document.getElementById('ldp-config').textContent); } catch (e0) { return; }
  if (!CFGX) return;
  var line = document.getElementById('ldpCoverWhy');
  if (!line) {
    line = document.createElement('p');
    line.id = 'ldpCoverWhy';
    line.className = 'ldp-coverwhy';
    grid.parentNode.insertBefore(line, grid);
  }
  var on = document.querySelector('.ldp-complexity-btn.is-active');
  var key = on && on.getAttribute('data-complexity');
  if (key !== 'simple' && key !== 'fondant') { line.hidden = true; return; }

  var cf = CFGX.costFirst || {};
  var ing = parseFloat((cf.ing || {})[key]);
  var pct = (cf.marginPct != null) ? +cf.marginPct : 35;

  /* the studio rate for this cover: Pro reads its own preset, free reads
     the band's low end - the same number by construction */
  var RA = (window.LAYERD && window.LAYERD.pricingRates) || null;
  var preset = RA ? RA.preset(key) : null;
  if (preset == null) {
    var band = (CFGX.bands || {})[key];
    preset = band ? band.lo : null;
  }
  if (preset == null || !(ing > 0)) { line.hidden = true; return; }

  /* is she on her own rate? only Pro can be */
  var live = RA ? RA.live() : null;
  if (live != null && Math.abs(live - preset) > 0.005) {
    line.innerHTML = 'your rate · studio default $' + preset.toFixed(2) + ' a serving.';
    line.hidden = false;
    return;
  }
  var lab = preset * (1 - pct / 100) - ing;
  line.innerHTML = (lab > 0)
    ? 'studio default: $' + ing.toFixed(2) + ' ingredients + $' + lab.toFixed(2) +
      ' labour, +' + pct + '% margin = <b>$' + preset.toFixed(2) + ' a serving</b>.'
    : 'the studio default rate for this cover.';
  line.hidden = false;
};
(function bootCoverWhy() {
  window.ldpSyncCoverWhy();
  document.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('.ldp-complexity-btn')) {
      setTimeout(window.ldpSyncCoverWhy, 60);
    }
  });
})();

/* round 54 (Mariya's mobile redesign): each add-on carries its own fee as a
   steppable pill (the redesign's "each customizable per rate"). A generic
   decorator wraps every flat-dollar add-on fee input - the five studio rows
   and any custom ones - with a - / + that steps the value $5 and fires the
   same input/change the typed field does, so the quote recomputes unchanged.
   The rush % and delivery's per-km rate/distance keep their own controls. */
(function ldpAddonSteppers() {
  var host = document.getElementById('ldp-addons');
  if (!host) return;
  /* pro tier = the premium island is on the page (this IIFE sits outside the
     main module closure, so the file-scoped ldpIsPro is not reachable here) */
  var pro = !!document.getElementById('ldp-premium');
  var STEP = 5;
  /* fields that are NOT a flat dollar fee: they get no $ stepper */
  var SKIP = { ldpRushPct: 1, ldpDeliveryPerKm: 1, ldpDeliveryKm: 1 };
  function mkBtn(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ldp-addon-step ldp-addon-step--' + (dir < 0 ? 'down' : 'up');
    b.setAttribute('aria-hidden', 'true');   /* the input stays the labelled control */
    b.tabIndex = -1;
    b.textContent = dir < 0 ? '−' : '+';
    b.addEventListener('click', function () {
      var inp = b.parentNode && b.parentNode.querySelector('input[type="number"]');
      if (!inp) return;
      var cur = parseFloat(inp.value);
      if (!(cur >= 0)) cur = 0;
      var min = parseFloat(inp.min);
      var next = cur + dir * STEP;
      if (!(min >= 0)) min = 0;
      if (next < min) next = min;
      inp.value = String(next);
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return b;
  }
  function curSym() {
    try {
      var s = window.LAYERD && window.LAYERD.pricingCurrency
        && window.LAYERD.pricingCurrency.symbol();
      if (s) return s;
    } catch (e) { }
    return '$';
  }
  function decorate() {
    /* the template hardcodes a "$" prefix; show the real currency symbol so
       CAD reads "CA$" like the mock, and every other currency reads right */
    var sym = curSym();
    Array.prototype.forEach.call(
      host.querySelectorAll('.ldp-addon-row2:not(.ldp-taxrow) .ldp-addon-amt2__pre'),
      function (pre) { if (pre.textContent !== sym) pre.textContent = sym; });
    var inputs = host.querySelectorAll(
      '.ldp-addon-row2:not(.ldp-taxrow) input[type="number"]');
    Array.prototype.forEach.call(inputs, function (inp) {
      if (SKIP[inp.id]) return;
      var pill = inp.closest('.ldp-deliv__flat') || inp.closest('.ldp-addon-amt2');
      if (!pill || pill.classList.contains('ldp-deliv')) {
        /* delivery's outer amt2 wraps flat+km+seg - only pill the flat group */
        pill = inp.closest('.ldp-deliv__flat') || pill;
      }
      if (!pill || pill.getAttribute('data-ldp-stepped') === '1') return;
      pill.setAttribute('data-ldp-stepped', '1');
      /* r54 follow-up (Mariya): add-on fee customization is a Pro door. Free
         toggles add-ons on at studio rates (its total reads data-amt, not this
         input), so on free the fee field is locked read-only and dimmed rather
         than wearing steppers that imply it is editable. */
      if (!pro) {
        inp.readOnly = true;
        inp.tabIndex = -1;
        pill.classList.add('ldp-addon-amt2--locked');
        return;
      }
      pill.insertBefore(mkBtn(-1), pill.firstChild);
      pill.appendChild(mkBtn(1));
    });
    if (!pro) lockHint();
  }
  /* one "set your own in pro" line under the add-on rows, linking straight to
     the Toolkit product page */
  function lockHint() {
    if (host.querySelector('.ldp-addon-lock')) return;
    var wrap = document.createElement('div');
    wrap.className = 'ldp-addon-lock';
    var p = document.createElement('p');
    p.className = 'ldp-addon-lock__copy';
    p.textContent = 'these are studio fees. in pro you set your own for every add-on.';
    var a = document.createElement('a');
    a.className = 'ldp-addon-lock__cta';
    a.href = '/products/learn-hub-pro';
    a.setAttribute('data-cta', 'toolkit');
    a.textContent = 'set your own fees in pro';
    wrap.appendChild(p); wrap.appendChild(a);
    host.appendChild(wrap);
  }
  decorate();
  /* custom add-on rows are added later; re-decorate when they appear */
  try {
    new MutationObserver(function () { decorate(); })
      .observe(host, { childList: true, subtree: true });
  } catch (e) { /* no MutationObserver: the five studio rows are already done */ }
})();

/* round 54 (Mariya): tactile feedback - the "small things that add up".
   A light vibration on tap where the platform allows it (Android / some
   PWAs; iOS Safari gates haptics to native apps, so it is a no-op there -
   the CSS press + reveal animations carry the feel on iOS). One delegated
   pointerdown listener, so nothing else in the file has to know. */
(function ldpTactile() {
  var root = document.querySelector('.ldpc');
  if (!root || !('PointerEvent' in window)) return;
  function vibe(ms) { try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) { } }
  /* a firmer tap for the big moves (open a step, pick a cover, adjust),
     a lighter one for the ± steppers and row toggles */
  var HEAVY = '.ldp-sechead, .mcs1-adjust-toggle, .ldp-complexity-btn, .ldc-pr__step, #ldpCalcBtn';
  var LIGHT = '.mcs1-stepbtn, .ldp-marginctl__b, .ldc-rate__step, .ldp-addon-step,' +
    ' .ldp-step, .ldp-elrow2, .ldp-addon-tick, .ld-chip, .ldp-size, .ldp-shape,' +
    ' .ldc-rate, .mcs1-otherline, .ldp-mktrow, .ldp-taxval, .ldp-adjust__row,' +
    ' .ldp-elrates__toggle, .ldp-cakefold, .ldp-cake__add';
  root.addEventListener('pointerdown', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.closest(HEAVY)) vibe(11);
    else if (t.closest(LIGHT)) vibe(6);
  }, { passive: true });
})();

/* ===================================================================
   round 54 (Mariya): "what it costs you" for FREE. The cost breakdown is
   no longer Pro-only - free bakers see their break-even so the working-
   for-free alarm can fire. This is the studio-average engine: it fills
   #mcs1Box with the same UI the Pro bundle builds, but from the free
   island's studio-average ingredient costs, with rate + overhead editable
   and NO recipe door (recipe-costing stays the Pro door).

   It defines only cakeFloorFor + fmt on window.LDP_COSTFIRST - enough for
   the 02 answer - and deliberately NOT margin / activeCakeRateFor, so the
   base-price rows in 03 stay on the recommended-rate model (free must
   never be told to charge below the market rate). On Pro the premium
   bundle owns #mcs1Box and this bails.
   =================================================================== */
(function initLdpCostFirstFree() {
  var box = document.getElementById('mcs1Box');
  if (!box) return;
  if (document.getElementById('ldp-premium')) return;
  var CFG;
  try { CFG = JSON.parse(document.getElementById('ldp-config').textContent); } catch (e) { return; }
  var CF = (CFG && CFG.costFirst) || {};
  if (!CF.ing) return;

  var BANDS = ['simple', 'fondant'];
  var KEY = 'layerd-pricing-cost-first';
  var RATE_MIN = 5, RATE_MAX = 150, OH_MIN = 0, OH_MAX = 40;
  var COST_STEP = 0.10, HRS_STEP = 0.25;
  var adjustOpen = false;

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  var store = load();
  if (!store.hoursPT) store.hoursPT = {};
  if (!store.costs) store.costs = {};
  function save() { try { localStorage.setItem(KEY, JSON.stringify(store)); } catch (e) { } }

  function money(n) { try { return window.LAYERD.pricingCurrency.money(n); } catch (e) { return '$' + (+n).toFixed(2); } }
  function bareMoney(n) {
    var m = money(n);
    try { var s = window.LAYERD.pricingCurrency.symbol(); return s ? m.replace(s, '').trim() : m; } catch (e) { return m; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function hrsLabel(h) { return String(Math.round(h * 100) / 100) + ' hrs'; }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function activeCover() {
    var on = document.querySelector('.ldp-complexity-btn.is-active');
    var k = on && on.getAttribute('data-complexity');
    return k === 'fondant' ? 'fondant' : 'simple';
  }
  function coverLabel(k) {
    var el = document.querySelector('.ldp-complexity-btn[data-complexity="' + k + '"] .ldp-complexity-title');
    return el ? el.textContent : (k === 'fondant' ? 'Ganache & fondant' : 'Buttercream');
  }
  function servings() { try { var n = window.LAYERD.pricingCake.servings(); return n > 0 ? n : 0; } catch (e) { return 0; } }
  function tiers() { try { var t = window.LAYERD.pricingCake.read().tiers; return (t && t.length) ? t.length : 1; } catch (e) { return 1; } }

  function ingOf(k) { var v = parseFloat(store.costs[k]); if (v >= 0) return v; v = parseFloat((CF.ing || {})[k]); return v >= 0 ? v : (k === 'fondant' ? 1.85 : 1.60); }
  function hptOf(k) { var v = parseFloat(store.hoursPT[k]); if (v > 0) return v; v = parseFloat((CF.hpt || {})[k]); return v > 0 ? v : (k === 'fondant' ? 2.5 : 1.5); }
  function rateOf() { var v = parseFloat(store.rate); if (v > 0) return clamp(v, RATE_MIN, RATE_MAX); v = parseFloat(CF.rate); return v > 0 ? v : 28; }
  function ohOf() { var v = parseFloat(store.overheadPct); return (v >= 0) ? clamp(v, OH_MIN, OH_MAX) : 10; }
  function hoursOf(k) { return Math.max(0.5, hptOf(k) * tiers()); }
  function labSv(k) { var sv = servings(); return sv > 0 ? hoursOf(k) * rateOf() / sv : 0; }
  function cakeSv(k) { return (ingOf(k) + labSv(k)) * (1 + ohOf() / 100); }

  window.LDP_COSTFIRST = window.LDP_COSTFIRST || {};
  window.LDP_COSTFIRST.cakeFloorFor = function (k) { return cakeSv(k === 'fondant' ? 'fondant' : 'simple'); };
  window.LDP_COSTFIRST.fmt = function (n) { return money(n); };
  window.LDP_COSTFIRST.render = render;

  function dispatch() { try { window.dispatchEvent(new CustomEvent('layerd:pricing-changed')); } catch (e) { } }
  function stepbtn(attr, val, aria, sign) {
    return '<button type="button" class="mcs1-stepbtn" data-' + attr + '="' + val + '" aria-label="' + aria + '">' +
      (sign < 0 ? '−' : '+') + '</button>';
  }
  function ledger(k) {
    var ing = ingOf(k), lab = labSv(k), be = cakeSv(k), oh = be - ing - lab;
    function dRow(name, sub, fig, last) {
      return '<div class="ldc-price__drow' + (last ? ' ldc-price__drow--last' : '') + '"><div>' +
        '<span class="ldc-price__dname">' + name + '</span>' +
        (sub ? '<span class="ldc-price__dsub">' + sub + '</span>' : '') + '</div>' +
        '<span class="ldc-price__dfig">' + esc(bareMoney(fig)) + '</span></div>';
    }
    return '<div class="ldc-price__derive">' +
      '<div class="ldc-price__dhead"><span>' + esc(coverLabel(k)) + '</span><span>per serving</span></div>' +
      dRow('Ingredients', 'studio average', ing) +
      dRow('Labour', hrsLabel(hptOf(k)) + '/tier · ' + hrsLabel(hoursOf(k)) + ' total', lab) +
      dRow('Overhead', ohOf() + '%', oh, true) +
      '<div class="ldc-price__dtotal"><span class="ldc-price__dlabel">Break-even</span>' +
      '<span class="ldc-price__dbig">' + esc(bareMoney(be)) + '</span></div></div>';
  }
  function cardHtml(k) {
    return '<div class="mcs1-card" data-cf-card="' + k + '">' +
      '<div class="mcs1-costrow"><span class="mcs1-costlab">ingredients<span class="mcs1-costlab__u">per serving</span></span>' +
      stepbtn('cf-cost', k + ':-1', 'lower the ingredient cost', -1) +
      '<span class="mcs1-costval">' + esc(bareMoney(ingOf(k))) + '</span>' +
      stepbtn('cf-cost', k + ':1', 'raise the ingredient cost', 1) + '</div>' +
      '<div class="mcs1-costrow"><span class="mcs1-costlab">your time</span>' +
      stepbtn('cf-hours', k + ':-1', 'fewer bench hours', -1) +
      '<span class="mcs1-costval">' + hrsLabel(hoursOf(k)) +
      '<span class="mcs1-costval__pt">' + hrsLabel(hptOf(k)) + '/tier</span></span>' +
      stepbtn('cf-hours', k + ':1', 'more bench hours', 1) + '</div>' +
      ledger(k) + '</div>';
  }
  function strip() {
    var active = activeCover();
    return '<div class="mcs1-cmp">' + BANDS.map(function (k) {
      var on = k === active;
      return '<div class="mcs1-cmp__card' + (on ? ' is-on' : '') + (k === 'fondant' ? ' mcs1-cmp__card--gf' : '') + '">' +
        '<span class="mcs1-cmp__k">' + esc(coverLabel(k)) + '</span>' +
        '<span class="mcs1-cmp__v">' + esc(bareMoney(cakeSv(k))) + '<span class="mcs1-cmp__u">/sv</span></span>' +
        '<span class="mcs1-cmp__s">' + esc(hrsLabel(hptOf(k))) + '/tier' + (k === 'fondant' ? ' · +chocolate' : '') + '</span></div>';
    }).join('') + '</div>' +
      '<p class="mcs1-cmp__note">Reflects the cover chosen in what you charge. Ganache costs more: ' +
      'chocolate in the recipe, plus more time per tier. These are studio-average estimates. ' +
      'Cost them from your own recipes in Pro.</p>';
  }
  function render() {
    var k = activeCover();
    box.innerHTML =
      '<div class="mcs1-head"><h2 class="mcs1-title">your break-even price</h2>' +
        '<p class="mcs1-sub">what one serving costs you</p></div>' +
      '<button type="button" class="mcs1-adjust-toggle" data-cf-adjust aria-expanded="' + (adjustOpen ? 'true' : 'false') + '">' +
        '<span class="mcs1-adjust-toggle__t">' + (adjustOpen ? 'done' : 'adjust these numbers') + '</span>' +
        '<span class="mcs1-adjust-toggle__x" aria-hidden="true">' + (adjustOpen ? '⌃' : '⌄') + '</span></button>' +
      '<div class="mcs1-marginrow"><span class="mcs1-mtxt"><span class="mcs1-mk">Hourly rate</span></span>' +
        stepbtn('cf-rate', '-1', 'lower the hourly rate', -1) +
        '<span class="mcs1-mval">' + esc(money(rateOf())) + '</span>' +
        stepbtn('cf-rate', '1', 'raise the hourly rate', 1) + '</div>' +
      '<div class="mcs1-marginrow mcs1-marginrow--join"><span class="mcs1-mtxt"><span class="mcs1-mk">Overhead</span>' +
        '<span class="mcs1-ms">studio default</span></span>' +
        stepbtn('cf-oh', '-1', 'lower overhead', -1) +
        '<span class="mcs1-mval">' + ohOf() + '%<span class="mcs1-mmult">studio default</span></span>' +
        stepbtn('cf-oh', '1', 'raise overhead', 1) + '</div>' +
      '<div class="mcs1-cards">' + cardHtml(k) + '</div>' +
      strip();
    box.classList.toggle('is-adjust', adjustOpen);
  }

  box.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t) return;
    if (t.closest('[data-cf-adjust]')) { adjustOpen = !adjustOpen; render(); return; }
    var r = t.closest('[data-cf-rate]');
    if (r) { store.rate = clamp(rateOf() + parseInt(r.getAttribute('data-cf-rate'), 10), RATE_MIN, RATE_MAX); save(); render(); dispatch(); return; }
    var o = t.closest('[data-cf-oh]');
    if (o) { store.overheadPct = clamp(ohOf() + parseInt(o.getAttribute('data-cf-oh'), 10), OH_MIN, OH_MAX); save(); render(); dispatch(); return; }
    var c = t.closest('[data-cf-cost]');
    if (c) { var p = c.getAttribute('data-cf-cost').split(':'); store.costs[p[0]] = Math.max(0, Math.round((ingOf(p[0]) + parseInt(p[1], 10) * COST_STEP) * 100) / 100); save(); render(); dispatch(); return; }
    var h = t.closest('[data-cf-hours]');
    if (h) { var q = h.getAttribute('data-cf-hours').split(':'); store.hoursPT[q[0]] = Math.max(0.25, Math.round((hptOf(q[0]) + parseInt(q[1], 10) * HRS_STEP) / 0.25) * 0.25); save(); render(); dispatch(); return; }
  });

  render();
  /* the section-answer painter ran before this interface existed - fire one
     change so it fills the collapsed "02" answer with the break-even now */
  dispatch();
  window.addEventListener('layerd:pricing-changed', function () { render(); });
  var grid = document.querySelector('.ldp-complexity-grid');
  if (grid) grid.addEventListener('click', function () { setTimeout(render, 0); });
})();
